import eu1723291Logo from "./logos/EU/1723291.png";
import eu1739270Logo from "./logos/EU/1739270.png";
import eu1739271Logo from "./logos/EU/1739271.png";
import eu1739273Logo from "./logos/EU/1739273.png";
import eu1739274Logo from "./logos/EU/1739274.png";

export const EU_TRADEMARK_API_RESPONSE = {
  trademarks: [
    {
      applicationNumber: "000984401",
      markKind: "INDIVIDUAL",
      markFeature: "WORD",
      markBasis: "EU_TRADEMARK",
      wordMarkSpecification: {
        verbalElement: "White wine",
      },
      niceClasses: [33],
      applicants: [
        {
          office: "EM",
          identifier: "1516",
          name: "White Wine Holdings B.V.",
        },
      ],
      applicationDate: "1997-02-10",
      registrationDate: "1998-10-28",
      expiryDate: "2027-02-10",
      renewalStatus: "RENEWAL_PERIOD_OPEN",
      status: "REGISTERED",
    },
    {
      applicationNumber: "018923441",
      markKind: "INDIVIDUAL",
      markFeature: "FIGURATIVE",
      markBasis: "EU_TRADEMARK",
      wordMarkSpecification: {
        verbalElement: "MarkPilot",
      },
      niceClasses: [35, 42],
      applicants: [
        {
          office: "EM",
          identifier: "28014",
          name: "MarkPilot IP GmbH",
        },
      ],
      applicationDate: "2020-08-03",
      registrationDate: "2021-05-26",
      expiryDate: "2031-08-03",
      renewalStatus: "RENEWAL_PERIOD_TO_START",
      status: "REGISTERED",
    },
    {
      applicationNumber: "019104552",
      markKind: "INDIVIDUAL",
      markFeature: "WORD",
      markBasis: "EU_TRADEMARK",
      wordMarkSpecification: {
        verbalElement: "Trexo Shield",
      },
      niceClasses: [9, 45],
      applicants: [
        {
          office: "EM",
          identifier: "45478",
          name: "Trexo Global Ltd.",
        },
      ],
      applicationDate: "2024-11-12",
      registrationDate: "",
      expiryDate: "",
      renewalStatus: "INVALID_FOR_RENEWAL",
      status: "APPLICATION_UNDER_EXAMINATION",
    },
  ],
  size: 10,
  totalElements: 3,
  totalPages: 1,
  page: 0,
};

export const EU_STATUS_OPTIONS = [
  { value: "all", label: "All Statuses" },
  { value: "REGISTERED", label: "Registered" },
  { value: "APPLICATION_UNDER_EXAMINATION", label: "Application Under Examination" },
  { value: "OPPOSITION_FILED", label: "Opposition Filed" },
  { value: "REFUSED", label: "Refused" },
  { value: "EXPIRED", label: "Expired" },
];

export const EU_MARK_FEATURE_OPTIONS = [
  { value: "all", label: "All Features" },
  { value: "WORD", label: "Word" },
  { value: "FIGURATIVE", label: "Figurative" },
  { value: "POSITION", label: "Position" },
  { value: "PATTERN", label: "Pattern" },
  { value: "MULTIMEDIA", label: "Multimedia" },
];

export const EU_RENEWAL_STATUS_OPTIONS = [
  { value: "all", label: "All Renewal Statuses" },
  { value: "RENEWAL_PERIOD_OPEN", label: "Renewal Period Open" },
  { value: "NOT_TO_BE_RENEWED", label: "Not To Be Renewed" },
  { value: "RENEWAL_PERIOD_TO_START", label: "Renewal Period To Start" },
  { value: "RENEWAL_IN_PROCESS", label: "Renewal In Process" },
  { value: "RENEWAL_PROCESS_BLOCKED", label: "Renewal Process Blocked" },
  { value: "RENEWAL_PERIOD_LAPSED", label: "Renewal Period Lapsed" },
  { value: "INVALID_FOR_RENEWAL", label: "Invalid For Renewal" },
];

export const AU_STATUS_OPTIONS = [
  { value: "all", label: "All Statuses" },
  { value: "REGISTERED", label: "Registered" },
  { value: "PENDING", label: "Pending" },
  { value: "REMOVED", label: "Removed" },
  { value: "EXPIRED", label: "Expired" },
];

export const AU_TRADEMARK_TYPE_OPTIONS = [
  { value: "all", label: "All Trademark Types" },
  { value: "WORD", label: "Word" },
  { value: "LOGO", label: "Logo" },
  { value: "COMPOSITE", label: "Composite" },
  { value: "CERTIFICATION", label: "Certification" },
];

export const NICE_CLASS_OPTIONS = Array.from({ length: 45 }, (_, index) => ({
  value: String(index + 1),
  label: String(index + 1),
}));

export const US_SEARCH_RESULTS = [
  {
    id: 1,
    markName: "CLEARMARK AI",
    jurisdiction: "United States",
    legalStatus: "Registered",
    applicationNo: "US-97635481",
    classes: [9, 42],
    goodsDescription: "Computer software for intellectual property management and trademark analysis; Software as a service (SaaS) for brand management",
    applicationDate: "2022-01-24",
    registrationDate: "2023-03-16",
    renewalDate: "2033-03-16",
    applicantName: "Trexo Global Inc.",
    matchScore: "8/10",
    iconType: "verified",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97635481"
  },
  {
    id: 2,
    markName: "IP NOVA",
    jurisdiction: "United States",
    legalStatus: "Registered",
    applicationNo: "US-98920134",
    classes: [41, 42],
    goodsDescription: "Educational services in the field of intellectual property; Online educational programs for trademark professionals",
    applicationDate: "2021-11-09",
    registrationDate: "2022-06-14",
    renewalDate: "2032-06-14",
    applicantName: "IP Nova Corporation",
    matchScore: "6/10",
    iconType: "award",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98920134"
  },
  {
    id: 3,
    markName: "TM GUARDIAN",
    jurisdiction: "United States",
    legalStatus: "Pending",
    applicationNo: "US-98102945",
    classes: [45],
    goodsDescription: "Legal services relating to trademark protection and enforcement; Brand protection consulting",
    applicationDate: "2023-06-15",
    registrationDate: "-",
    renewalDate: "-",
    applicantName: "Guardian Legal Services LLC",
    matchScore: "7/10",
    iconType: "shield",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98102945"
  },
  {
    id: 4,
    markName: "BRANDMARK",
    jurisdiction: "United States",
    legalStatus: "Registered",
    applicationNo: "US-96284719",
    classes: [35],
    goodsDescription: "Business consulting services in the field of trademark and brand strategy",
    applicationDate: "2019-08-20",
    registrationDate: "2021-02-09",
    renewalDate: "2031-02-09",
    applicantName: "BrandMark Solutions",
    matchScore: "5/10",
    iconType: "policy",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/96284719"
  },
  {
    id: 5,
    markName: "MARK FINDER",
    jurisdiction: "United States",
    legalStatus: "Registered",
    applicationNo: "US-97182934",
    classes: [9, 42],
    goodsDescription: "Online database system for trademark search and retrieval",
    applicationDate: "2021-03-10",
    registrationDate: "2022-08-15",
    renewalDate: "2032-08-15",
    applicantName: "MarkFinder Technologies",
    matchScore: "6/10",
    iconType: "description",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97182934"
  },
  {
    id: 6,
    markName: "SMART SHIELD",
    jurisdiction: "United States",
    legalStatus: "Registered",
    applicationNo: "US-95847291",
    classes: [9, 36, 42],
    goodsDescription: "Financial software and services for IP management; Computer software for portfolio management",
    applicationDate: "2020-05-12",
    registrationDate: "2021-11-23",
    renewalDate: "2031-11-23",
    applicantName: "Smart Shield Financial",
    matchScore: "4/10",
    iconType: "verified",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/95847291"
  },
  {
    id: 7,
    markName: "LEGAL TRACK",
    jurisdiction: "United States",
    legalStatus: "Registered",
    applicationNo: "US-94920847",
    classes: [45],
    goodsDescription: "Legal services for trademark prosecution and maintenance",
    applicationDate: "2018-09-08",
    registrationDate: "2020-01-14",
    renewalDate: "2030-01-14",
    applicantName: "Legal Track Services",
    matchScore: "7/10",
    iconType: "award",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/94920847"
  },
  {
    id: 8,
    markName: "TRADE SECURE",
    jurisdiction: "United States",
    legalStatus: "Pending",
    applicationNo: "US-98547123",
    classes: [42],
    goodsDescription: "Software as a service (SaaS) providing trademark monitoring and enforcement tools",
    applicationDate: "2023-04-22",
    registrationDate: "-",
    renewalDate: "-",
    applicantName: "Trade Secure Solutions",
    matchScore: "8/10",
    iconType: "shield",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98547123"
  },
  {
    "applicationNumber": "75709335",
    "jurisdiction": "United States",
    "country": "US",
    "markName": "@EVENT",
    "status": "Dead/Cancelled",
    "internationalClasses": ["9", "41"],
    "goodsDescription": "Computer software for use in entry, management, and retrieval of data in the field of sports statistics; and instruction manuals provided only in connection with the foregoing",
    "applicationDate": "1999-05-19",
    "registrationDate": "2001-08-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/75709335"
  },
  {
    "applicationNumber": "87689856",
    "jurisdiction": "United States",
    "country": "US",
    "markName": "EVENT PROS",
    "status": "Abandoned because the applicant failed to respond or filed a late response to an Office action.",
    "internationalClasses": ["35", "41"],
    "goodsDescription": "Event planning and management for marketing, branding, promoting or advertising the goods and services of others.",
    "applicationDate": "2017-11-17",
    "registrationDate": "N/A",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87689856"
  },
  {
    "applicationNumber": "78882113",
    "country": "US",
    "markName": "EVENT FOTOS",
    "status": "Live",
    "internationalClasses": [
      "16",
      "41"
    ],
    "goodsDescription": "IC 016: photographs; photographic prints that resemble magazine covers and trading cards; photographic prints of sports teams and individual.; IC 041: Photography services; Portrait photography.",
    "applicationDate": "2006-05-12",
    "registrationDate": "2008-03-04",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78882113",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "75352892",
    "country": "US",
    "markName": "MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: indoor amusement centers featuring bowling, billiards, casino-style blackjack tables and laser tag.",
    "applicationDate": "1997-09-08",
    "registrationDate": "2000-03-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/75352892",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99350871",
    "country": "US",
    "markName": "EVENT GENTS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Hosting social entertainment events, namely, birthday parties, pool parties, bachelorette parties, realtor open houses, dinner parties, and karaoke parties, for others.",
    "applicationDate": "2025-08-21",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99350871",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97527980",
    "country": "US",
    "markName": "@ EVERY EVENT",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41",
      "42"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes; business services, namely, planning and conducting of live, virtual and hybrid business presentations, productions, meetings, events, conferences, exhibits, trade shows and trade show booths; providing temporary personnel and support staff, namely, providing audio-visual technicians, operators and support personnel on a temporary basis to event organizers and exhibitors of live, virtual and hybrid audio-visual business presentations, productions, meetings, events and conferences.; IC 041: Audio-visual production services for live, virtual and hybrid events; audio-visual equipment rentals, namely, audio equipment, video equipment, recording equipment and lighting equipment for meetings, events, conferences, exhibits, trade shows and trade show booths; audio-visual technician services for events, namely, technicians for assisting with set-up, operation and management of audio-visual equipment for live, virtual and hybrid meetings,...",
    "applicationDate": "2022-07-31",
    "registrationDate": "2024-02-06",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97527980",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87667562",
    "country": "US",
    "markName": "EVENT TRASHBOX",
    "status": "Live",
    "internationalClasses": [
      "16"
    ],
    "goodsDescription": "IC 016: Corrugated board and paper containers for waste and recycle collection.",
    "applicationDate": "2017-11-01",
    "registrationDate": "2018-12-11",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87667562",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98601803",
    "country": "US",
    "markName": "EVENT ALPINEST",
    "status": "Live",
    "internationalClasses": [
      "24",
      "25"
    ],
    "goodsDescription": "IC 024: Fabric and fabric components, namely, fabric finish sold as an integral component of frabrics used in the manufacture of clothing, apparel, garments, industrial and protective garments, tents, sleeping bags, bedding, cleanroom garments, medical and surgical gowns, drapes, and footwear.; IC 025: Clothing, namely, jackets, vests, coats, pants, hats, caps, gloves, shoes, boots.",
    "applicationDate": "2024-06-14",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98601803",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90644637",
    "country": "US",
    "markName": "EVENT NETWORK",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: operation of a business for others, namely, souvenir and gift stores for museums, aquariums, zoos, and historical sites.",
    "applicationDate": "2021-04-14",
    "registrationDate": "2022-03-29",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90644637",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98601792",
    "country": "US",
    "markName": "EVENT ALPINEST",
    "status": "Live",
    "internationalClasses": [
      "24",
      "25"
    ],
    "goodsDescription": "IC 024: Fabric and fabric components, namely, fabric finish sold as an integral component of fabrics used in the manufacture of clothing, apparel, garments, industrial and protective garments, tents, sleeping bags, bedding, cleanroom garments, medical and surgical gowns, drapes, and footwear.; IC 025: Clothing, namely, jackets, vests, coats, pants, hats, caps, gloves, shoes, boots.",
    "applicationDate": "2024-06-14",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98601792",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86700156",
    "country": "US",
    "markName": "EVENT 360",
    "status": "Live",
    "internationalClasses": [
      "35",
      "36",
      "41"
    ],
    "goodsDescription": "IC 035: Business organization and operation consultancy in the fields of special entertainment events, entertainment events, charitable fundraising event and exhibition planning; personnel management assistance in the fields of special entertainment events, entertainment events, charitable fundraising event and exhibition planning; development of marketing strategies and concepts in the fields of special entertainment events, entertainment events, charitable fundraising event and exhibition planning; concept and brand development in the fields of special entertainment events, entertainment events, charitable fundraising event and exhibition planning; business risk management; cost analyses; cost price and analysis; logistics management in the fields of special entertainment events, charitable fundraising events, and exhibition planning; business risk management.; IC 036: Consulting services in the field of charitable fundraising events; financial risk management.; IC 041: Special event...",
    "applicationDate": "2015-07-21",
    "registrationDate": "2017-01-31",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86700156",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99699045",
    "country": "US",
    "markName": "EVENT+",
    "status": "Live",
    "internationalClasses": [
      "19"
    ],
    "goodsDescription": "IC 019: Non-metal floors; Vinyl flooring; Non-metal floor panels; luxury vinyl tiles; luxury vinyl flooring.",
    "applicationDate": "2026-03-12",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99699045",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77655934",
    "country": "US",
    "markName": "EVENT",
    "status": "Live",
    "internationalClasses": [
      "6"
    ],
    "goodsDescription": "IC 006: Metal chimneys; metal heating ducts.",
    "applicationDate": "2009-01-24",
    "registrationDate": "2010-04-27",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77655934",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88579585",
    "country": "US",
    "markName": "EVENT",
    "status": "Live",
    "internationalClasses": [
      "18"
    ],
    "goodsDescription": "IC 018: Cross body bags; Belt bags; Handbags; sports bags; School bags; Empty toiletry bags; Bags for carrying baby accessories; Tool bags of leather, sold empty; Garment bags for travel; Sling Bags; Waist Bags; Fitted covers for horse riding saddles; Saddlery.",
    "applicationDate": "2019-08-15",
    "registrationDate": "2023-04-04",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88579585",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97089726",
    "country": "US",
    "markName": "EVENT",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Amplifiers; Microphones; Sub-woofers; Audio equalizer apparatus; Audio speaker enclosures; Conical attachment to an audio speaker for diffusing and distributing sound as it is transmitted from the speaker; Downloadable computer software to control and improve computer and audio equipment sound quality; Electronic products for the generation, measurement, and analysis of audio signals, namely, audio analyzers; Loud speaker systems; Loudspeaker cabinets; Loudspeakers with built in amplifiers; Mounts and mounting brackets adapted for audio speakers with swiveling bases therefor; Protective cases for audio equipment in the nature of SPEAKERS; Public address (PA) and sound system accessories, namely, microphone stands, speaker stands, microphone cables, speaker cables, speaker boxes and sound mixers; Speaker microphones; Wave reflectors for acoustic speakers, lighting apparatus, and air flow devices; Audio speakers; Bass speakers; Loud speakers; Signal processors for audio speakers;...",
    "applicationDate": "2021-10-24",
    "registrationDate": "2025-04-01",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97089726",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86725497",
    "country": "US",
    "markName": "EVENT",
    "status": "Live",
    "internationalClasses": [
      "11"
    ],
    "goodsDescription": "IC 011: Cooking surfaces, namely, electric and gas griddles, electric and gas grills, and electric and gas cooktops sold as a unit with supporting tables, support legs, or supporting enclosures.",
    "applicationDate": "2015-08-14",
    "registrationDate": "2016-05-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86725497",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "75816799",
    "country": "US",
    "markName": "EVENT",
    "status": "Live",
    "internationalClasses": [
      "12"
    ],
    "goodsDescription": "IC 012: HORSE AND STOCK TRAILERS, AUTOMOBILE TRAILERS, RECREATIONAL TRAILERS IN THE NATURE OF TRAILERS CONTAINING A LIVING QUARTERS AND SPACE TO CARRY GOODS OR VEHICLES, VENDORS TRAILERS IN THE NATURE OF TRAILERS USED FOR THE SALE OF VARIOUS GOODS.",
    "applicationDate": "1999-10-07",
    "registrationDate": "2001-04-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/75816799",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85098670",
    "country": "US",
    "markName": "EVENT",
    "status": "Live",
    "internationalClasses": [
      "1"
    ],
    "goodsDescription": "IC 001: Adjuvant for use with agricultural chemicals.",
    "applicationDate": "2010-08-03",
    "registrationDate": "2011-05-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85098670",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "75549688",
    "country": "US",
    "markName": "EVENT",
    "status": "Live",
    "internationalClasses": [
      "24",
      "25"
    ],
    "goodsDescription": "IC 024: FABRIC AND FABRIC COMPONENTS USED IN THE MANUFACTURE OF CLOTHING, APPAREL, GARMENTS, INDUSTRIAL AND PROTECTIVE GARMENTS, TENTS, SLEEPING BAGS, BEDDING, CLEANROOM GARMENTS, MEDICAL AND SURGICAL GOWNS, DRAPES, AND FOOTWEAR.; IC 025: CLOTHING, namely, JACKETS, [ SHIRTS, ] VESTS, COATS, PANTS, HATS, CAPS, GLOVES, SHOES, BOOTS [, SOCKS, ] [ CLEANROOM GARMENTS ].",
    "applicationDate": "1998-09-08",
    "registrationDate": "2001-06-05",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/75549688",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "79232361",
    "country": "US",
    "markName": "EVENT",
    "status": "Live",
    "internationalClasses": [
      "9",
      "11"
    ],
    "goodsDescription": "IC 009: special test stands, in particular for environment simulation installations; gas testing instruments; the aforesaid apparatus for use in scientific research and laboratories; furnaces for laboratory use.; IC 011: ovens for heat treatment under inert gas; dry heat sterilizers; heat pumps; heat accumulators; heat exchangers, other than parts of machines; heating installations; heating apparatus for solid, liquid or gaseous fuels; water and air filtration installations for the extraction of pollutants; all of the aforesaid goods solely in the field of environmental, heating, indoor climate and pharmaceutical technology.",
    "applicationDate": "2017-02-23",
    "registrationDate": "2019-05-21",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/79232361",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78642058",
    "country": "US",
    "markName": "EVENT",
    "status": "Live",
    "internationalClasses": [
      "27"
    ],
    "goodsDescription": "IC 027: Vinyl floor coverings.",
    "applicationDate": "2005-06-02",
    "registrationDate": "2006-05-16",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78642058",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99061367",
    "country": "US",
    "markName": "EC EVENT CONCEPT",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: (Based on 44(e)) retail store services featuring flowers; online retail store services featuring flowers; (Based on Intent to Use) organisation of events, exhibitions, fairs and shows for commercial, promotional and advertising purposes; arranging promotion of charitable fundraising events; event marketing; production of advertising films; film directing of advertising films; information, advisory and consultancy services in relation to all the aforesaid services..; IC 041: (Based on Intent to Use) Organisation of entertainment exhibition events; party planning services; organising of galas; conducting of live entertainment events in the nature of fashion shows, award shows, live musical performances, fundraisers, receptions, premiere afterparties, and galas; production of live entertainment events for social entertainment purposes; organisation of live shows in the nature of fashion shows, award shows, live musical performances, fundraisers, receptions, premiere afterparties,...",
    "applicationDate": "2025-02-28",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99061367",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98396639",
    "country": "US",
    "markName": "MPE EVENT GROUP",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Branding services, namely, consulting, development, management and marketing of brands for businesses and/or individuals; Event planning and management for marketing, branding, promoting or advertising the goods and services of others; Concept and brand development services for corporate clients; Brand concept and brand development services for corporate and individual clients..; IC 041: Disc jockey services; Disc jockeys for parties and special events; Entertainment, namely, lighting production; Rental of portable photo booths; Entertainment in the nature of photo booth services..",
    "applicationDate": "2024-02-07",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98396639",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98077253",
    "country": "US",
    "markName": "EVENT RISK WWW.EVENTRISKINC.COM",
    "status": "Live",
    "internationalClasses": [
      "35",
      "45"
    ],
    "goodsDescription": "IC 035: Business risk management services.; IC 045: Detective investigations; Security guard services.",
    "applicationDate": "2023-07-10",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98077253",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99329712",
    "country": "US",
    "markName": "EVENT KIOSK PLUS",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Interactive computer kiosk systems comprised primarily of computers, computer hardware, computer peripherals, and computer touchscreens for use in event registration.",
    "applicationDate": "2025-08-10",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99329712",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88426390",
    "country": "US",
    "markName": "EVENT Z!NGO",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Promoting the goods and services of others, namely, providing marketing services featuring a website for use as a forum for businesses in the event industry to advertise to private and corporate event planners.",
    "applicationDate": "2019-05-12",
    "registrationDate": "2020-04-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88426390",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98897085",
    "country": "US",
    "markName": "EP EVENT PLANNER.AI",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Software as a service (SAAS) services featuring software using artificial intelligence (AI) for event planning and event management in the nature of event content creation, event budgeting, event scheduling, event registration, attendee management, event reporting and analytics, event visual creation, and vendor management.",
    "applicationDate": "2024-12-11",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98897085",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97471581",
    "country": "US",
    "markName": "XTREME EVENT GROUP",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Disc jockey services; Disc jockeys for parties and special events; Rental of Photo Booth; Master of ceremony services for parties and special events; Entertainment services, namely, staging cultural and arts events and lighting technician services for events; Entertainment services, namely, organizing cultural and arts events featuring video screens, indoor fireworks, carbon dioxide cannons, and lighting effects.",
    "applicationDate": "2022-06-23",
    "registrationDate": "2023-08-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97471581",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98721393",
    "country": "US",
    "markName": "KISMET EVENT CO.",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41",
      "45"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes.; IC 041: Wedding reception planning and coordination consultation services; Special event planning for social entertainment purposes.; IC 045: Planning and arranging wedding ceremonies.",
    "applicationDate": "2024-08-28",
    "registrationDate": "2025-07-01",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98721393",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78908376",
    "country": "US",
    "markName": "A WYNNING EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event planning.",
    "applicationDate": "2006-06-14",
    "registrationDate": "2007-05-29",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78908376",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99487670",
    "country": "US",
    "markName": "THE QUIRK'S EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Conducting of conferences in the field of marketing research.",
    "applicationDate": "2025-11-10",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99487670",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98674485",
    "country": "US",
    "markName": "EVENT-O-MATIC",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Downloadable computer software for calendar management; downloadable computer software for generation of calendar events from spreadsheets, and generation of calendar events from other documents.",
    "applicationDate": "2024-07-30",
    "registrationDate": "2025-04-29",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98674485",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98795320",
    "country": "US",
    "markName": "EVENT HELPER .COM",
    "status": "Live",
    "internationalClasses": [
      "36"
    ],
    "goodsDescription": "IC 036: Marketing services and insurance agency in the field of special event general liability, inland marine, and cancellation insurance; issuance of special event general liability, inland marine and cancellation insurance.",
    "applicationDate": "2024-10-10",
    "registrationDate": "2025-08-26",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98795320",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97321231",
    "country": "US",
    "markName": "NANNYTAINMENT EVENT CHILDCARE",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Child care.",
    "applicationDate": "2022-03-20",
    "registrationDate": "2023-05-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97321231",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98389782",
    "country": "US",
    "markName": "GEOLOCATED EVENT DETECTION",
    "status": "Live",
    "internationalClasses": [
      "38"
    ],
    "goodsDescription": "IC 038: Transmission of digital files and electronic mail; providing user access to global computer networks; communications by cellular phones; satellite communications services, namely, satellite communications to gps tracking devices; communications by computer terminals; computer-aided transmission of messages and images; electronic message sending; transmission of digital files; transmission of electronic mail.",
    "applicationDate": "2024-02-02",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98389782",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86868140",
    "country": "US",
    "markName": "EVENT PLANNER NY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging and conducting special events for social entertainment purposes; Arranging, organizing, conducting, and hosting social entertainment events; Entertainment services, namely, producing cheerleading, dance and spirit-related competitions and events; Organization of events for cultural purposes; Organization of dancing events; Organizing cultural and arts events; Party and wedding reception planning and coordination services; Party and wedding reception planning consultation services; Party and wedding reception planning, coordination and consultation services.",
    "applicationDate": "2016-01-07",
    "registrationDate": "2016-07-05",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86868140",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86822686",
    "country": "US",
    "markName": "BELLISAMIO EVENT SOLUTIONS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging and conducting special events for social entertainment purposes; consultation in the field of special event planning for social entertainment purposes; entertainment services in the nature of arranging social entertainment events; entertainment services in the nature of organizing social entertainment events; party and wedding reception planning and coordination services; party and wedding reception planning consultation services; party and wedding reception planning, coordination and consultation services; party planning; party planning consultation; special event planning for social entertainment purposes; wedding reception planning and coordination consultation services; wedding reception planning and coordination services.",
    "applicationDate": "2015-11-17",
    "registrationDate": "2017-06-06",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86822686",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99210865",
    "country": "US",
    "markName": "ACCUCARE EVENT MEDICAL",
    "status": "Live",
    "internationalClasses": [
      "44"
    ],
    "goodsDescription": "IC 044: Emergency medical services; Emergency medical services offered in or from a remote, mobile or temporary on-site location.",
    "applicationDate": "2025-05-30",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99210865",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "76670380",
    "country": "US",
    "markName": "SPINDUSTRY EVENT TECHNOLOGY",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Computer service, namely, acting as an application service provider in the field of knowledge management to host computer application software for creating searchable databases of information and data in the field of event management and organization.",
    "applicationDate": "2006-12-15",
    "registrationDate": "2007-10-23",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/76670380",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90310318",
    "country": "US",
    "markName": "SP3 EVENT COMPANY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment media production services for the internet; Entertainment services in the nature of live visual and audio performances, namely, musical band, rock group, gymnastic, dance, and ballet performances; Lighting technician services for events; Sound engineering services for events; Arranging, organizing, conducting, and hosting social entertainment events; Audio engineering services for events; Disc jockeys for parties and special events; Party and wedding reception planning, coordination and consultation services; Special event planning for social entertainment purposes.",
    "applicationDate": "2020-11-10",
    "registrationDate": "2023-04-04",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90310318",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88361568",
    "country": "US",
    "markName": "PLAYTIME EVENT SITTERS",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Child care services, namely, providing on-site childcare at events.",
    "applicationDate": "2019-03-28",
    "registrationDate": "2019-10-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88361568",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99452792",
    "country": "US",
    "markName": "SUITS & SHOOT EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging, organizing, conducting, and hosting social entertainment events.",
    "applicationDate": "2025-10-20",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99452792",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99750665",
    "country": "US",
    "markName": "VALUEEDGE GLOBAL EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Education services, namely, providing educational conferences and seminars in the field of global investment management, corporate governance, international financial markets, and fiduciary oversight across multiple jurisdictions.",
    "applicationDate": "2026-04-08",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99750665",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90843206",
    "country": "US",
    "markName": "CVENT EVENT DIAGRAMMING",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41",
      "42"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes; Event room planning, namely, special event planning services featuring planning the use of event rooms for business purposes; Event diagramming, namely, special event planning services featuring planning the use of rooms and facilities using diagrams for meetings, banquets, conventions, exhibits, and special events for business purposes.; IC 041: Special event planning for social entertainment purposes; Event room planning, namely, special event planning services featuring planning the use of event rooms for social entertainment purposes; Event diagramming, namely, special event planning services featuring planning the use of rooms and facilities using diagrams for meetings, banquets, conventions, exhibits, and special events for social entertainment purposes.; IC 042: Providing a website featuring temporary use of non-downloadable software, namely, software for use in facilitating event planning, event room planning, and event...",
    "applicationDate": "2021-07-22",
    "registrationDate": "2026-04-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90843206",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97268119",
    "country": "US",
    "markName": "MB EVENT PROS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Party planning.",
    "applicationDate": "2022-02-15",
    "registrationDate": "2024-03-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97268119",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97482181",
    "country": "US",
    "markName": "SUITETWO EVENT VENUE",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of banquet and social function facilities for special occasions, namely, wedding receptions, birthday parties, bridal shower, baby showers; rental of chairs and tables; rental of chairs, tables, table linen, glassware; rental of conference rooms; rental of dishes; rental of meeting rooms; rental of silverware; rental of table linens; rental of tableware; rental of tableware, silverware, and dishes for special events.",
    "applicationDate": "2022-06-29",
    "registrationDate": "2023-06-13",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97482181",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78850241",
    "country": "US",
    "markName": "EVENT LIFECYCLE MANAGER",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Computer software for use in event management.",
    "applicationDate": "2006-03-30",
    "registrationDate": "2006-11-21",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78850241",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88634680",
    "country": "US",
    "markName": "LOVETUNER LOVE EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Workshops and seminars in the field of mindfulness, breathing, meditation, self-awareness, life-coaching.",
    "applicationDate": "2019-09-27",
    "registrationDate": "2021-02-09",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88634680",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97133669",
    "country": "US",
    "markName": "SUITEONE EVENT VENUE",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of chairs and tables; Rental of chairs, tables, table linen, glassware; Rental of conference rooms; Rental of dishes; Rental of meeting rooms; Rental of silverware; Rental of table linens; Rental of tableware; Rental of tableware, silverware, and dishes for special events; Rental of banquet and social function facilities for special occasions, namely, wedding receptions, birthday parties, bridal showers, baby showers.",
    "applicationDate": "2021-11-19",
    "registrationDate": "2022-12-20",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97133669",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88135833",
    "country": "US",
    "markName": "MC EVENT CONSULTING",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Corporate event management services; Event planning and management for marketing, branding, promoting or advertising the goods and services of others; Business meeting planning; Management of event ticketing for others; Logistics management in the field of corporate events; Event Management and meeting operations services, namely, providing travel management services for corporate events.",
    "applicationDate": "2018-09-28",
    "registrationDate": "2019-10-01",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88135833",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99790124",
    "country": "US",
    "markName": "SUNCOAST EVENT RENTALS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services, namely, providing an amusement park ride in the nature of inflatables, tables, tents, chairs.",
    "applicationDate": "2026-04-27",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99790124",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99575115",
    "country": "US",
    "markName": "S.O.S EVENT GROUP",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Night club entertainment services; Entertainment services in the nature of organizing social entertainment events; Entertainment in the nature of organizing and hosting social entertainment events; Entertainment services in the nature of arranging social entertainment events; Hosting and conducting social entertainment events; Arranging, organizing, conducting, and hosting social entertainment events; Hosting and conducting social entertainment events at Venues; Hosting social entertainment events, namely, Birthday parties, weddings and social gatherings; Dance events; DJ services.",
    "applicationDate": "2026-01-01",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99575115",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85659307",
    "country": "US",
    "markName": "WWE MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "28"
    ],
    "goodsDescription": "IC 028: Toys, namely, action figures and accessories therefor; [ dolls; cases for action figures; ] toy wrestling rings; toy vehicles; board games; [ hand-held units for playing electronic game other than those adopted for use with an electronic display screen or monitor; ] playing cards [ ; stuffed toys; plush toys; toy belts; knee and elbow pads for athletic use; costume masks ].",
    "applicationDate": "2012-06-22",
    "registrationDate": "2016-02-02",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85659307",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98746884",
    "country": "US",
    "markName": "CVW EVENT PRODUCTIONS",
    "status": "Live",
    "internationalClasses": [
      "38",
      "41",
      "42"
    ],
    "goodsDescription": "IC 038: Audio and video broadcasting services over the Internet in the fields of business, conventions, and sporting events.; IC 041: Video production services; Audio production services, namely, production of audio recording; Video editing services for events; Entertainment services, namely, multimedia production services; Entertainment, namely, lighting production; Film production and film editing of recorded events for broadcasting over the Internet in the fields of business, conventions, and sporting events; Post-production film editing of live events, meetings, and conferences for broadcasting over the Internet in the fields of business, conventions, and sporting events; Event management services being organizing and conducting cultural events; Event management services being organizing and conducting educational events in the fields of business, conventions, and sporting events.; IC 042: Stage design for events in the fields of business, conventions, and sporting events.",
    "applicationDate": "2024-09-12",
    "registrationDate": "2025-10-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98746884",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90242352",
    "country": "US",
    "markName": "WWE MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services, namely, a show about professional wrestling broadcast over television, internet and various platforms across multiple forms of transmission media; Entertainment services in the nature of production of television shows featuring professional wrestling events, but do not indicate advertising or commercials; Entertainment services, namely, organizing and conducting exhibitions of professional wrestling events rendered live and recorded for the purpose of distribution through various platforms across multiple forms of transmission media being broadcast media; Entertainment namely, a continuing wrestling news and information show broadcast over television or distributed via various platforms across multiple forms of transmission media; Providing wrestling news and information via a website; entertainment namely, a continuing sports information show broadcast over television or distributed via various platforms across multiple forms of transmission media;...",
    "applicationDate": "2020-10-08",
    "registrationDate": "2025-02-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90242352",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88097638",
    "country": "US",
    "markName": "PALMWOOD EVENT & CONFERENCE",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Provision of conference, exhibition and meeting facilities; Rental of banquet and social function facilities for special occasions, namely, conferences, conventions, events, meetings, and weddings.",
    "applicationDate": "2018-08-29",
    "registrationDate": "2019-11-05",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88097638",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87786945",
    "country": "US",
    "markName": "NYC EVENT SPACES",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Rental of facilities and equipment for the production of radio and television programs, musical and theatrical productions, namely, performance venues, studios, sets, dressing rooms.",
    "applicationDate": "2018-02-06",
    "registrationDate": "2018-07-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87786945",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98746872",
    "country": "US",
    "markName": "CVW EVENT PRODUCTIONS",
    "status": "Live",
    "internationalClasses": [
      "38",
      "41",
      "42"
    ],
    "goodsDescription": "IC 038: Audio and video broadcasting services over the Internet in the fields of business, conventions, and sporting events.; IC 041: Video production services; Audio production services, namely, production of audio recording; Video editing services for events; Entertainment services, namely, multimedia production services; Entertainment, namely, lighting production; Film production and film editing of recorded events for broadcasting over the Internet in the fields of business, conventions, and sporting events; Post-production film editing of live events, meetings, and conferences for broadcasting over the Internet in the fields of business, conventions, and sporting events; Event management services being organizing and conducting cultural events; Event management services being organizing and conducting educational events in the fields of business, conventions, and sporting events.; IC 042: Stage design for events in the fields of business, conventions, and sporting events.",
    "applicationDate": "2024-09-12",
    "registrationDate": "2025-10-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98746872",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88518512",
    "country": "US",
    "markName": "AED ACCREDITED EVENT DECORATOR",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Vocational education in the field of event decorating.",
    "applicationDate": "2019-07-17",
    "registrationDate": "2020-01-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88518512",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90587641",
    "country": "US",
    "markName": "LEC LAUGHLIN EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Arena services, namely, providing general-purpose facilities for sports, concerts and exhibitions.",
    "applicationDate": "2021-03-18",
    "registrationDate": "2022-10-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90587641",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90587630",
    "country": "US",
    "markName": "LEC LAUGHLIN EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services, namely, entertainment ticket agency services and entertainment information services; Providing facilities for live music, theater, comedy, acrobatic, and dance shows; Providing facilities for rodeos, off road racing, and Xtreme sports; Organizing and conducting entertainment festivals featuring a variety of live entertainment activities in the nature of live music and cultural activities; Rental of arena facilities; Providing of websites featuring information in the field of sports, entertainment and arena rental.",
    "applicationDate": "2021-03-18",
    "registrationDate": "2022-10-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90587630",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88517805",
    "country": "US",
    "markName": "AED ACCREDITED EVENT DESIGNER",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Vocational education in the field of event decorating.",
    "applicationDate": "2019-07-16",
    "registrationDate": "2020-01-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88517805",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99320739",
    "country": "US",
    "markName": "ENS EVENT NOTIFICATION SYSTEM",
    "status": "Live",
    "internationalClasses": [
      "36",
      "44"
    ],
    "goodsDescription": "IC 036: Providing health insurance information.; IC 044: Internet-based health care information services.",
    "applicationDate": "2025-08-05",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99320739",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99535224",
    "country": "US",
    "markName": "CNE CAROLINAS NETWORKING EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Arranging, organizing, conducting, and hosting a business networking event for companies and personnel in the real estate sales agency field; Business networking; Event planning and management for marketing, branding, promoting, or advertising the real estate sales agency services of others; Special event planning for real estate sales agents for commercial, promotional or advertising purposes.",
    "applicationDate": "2025-12-08",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99535224",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97637399",
    "country": "US",
    "markName": "SELECT EVENT",
    "status": "Live",
    "internationalClasses": [
      "37",
      "40",
      "41",
      "43",
      "44"
    ],
    "goodsDescription": "IC 037: Party, event and function rental services, namely, rental of portable cloth and wooden room dividers, laydown flooring, elevated flooring and staging.; IC 040: Party, event and function rental services, namely, rental of space heaters, air conditioners, power generators.; IC 041: Party, event and function rental services, namely, rental of dance floors, portable stages and sound equipment.; IC 043: Party, event and function rental services, namely, rental of furniture, table linens, tableware, tents, tent structures, scaffolding, temporary and permanent fabric structures, china, platters, bowls, serving utensils, trays, tray stands, chafing dishes, coffee makers, beverage containers, glasses, cooking pans, ovens, stoves, grills, warming cabinets for food, candelabras, chandeliers, candle lamps, lighting equipment, easels, coat racks, lecterns, drapery, mobile kitchens, carpeting.; IC 044: Party, event and function rental services, namely, rental of portable rest rooms.",
    "applicationDate": "2022-10-18",
    "registrationDate": "2023-11-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97637399",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77761531",
    "country": "US",
    "markName": "EVENT MERCENARIES",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event planning for sporting events and competitions; special event planning consultation for sporting events and competitions; arranging and conducting special sporting events and competitions; organizing sporting events, namely, running events; organization of sports competitions; organizing sporting events, namely, triathlons; organizing community sporting events; event planning for sporting events and competitions; event planning consultation for sporting events and competitions; and arranging and conducting sporting events and competitions.",
    "applicationDate": "2009-06-17",
    "registrationDate": "2010-08-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77761531",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "79426430",
    "country": "US",
    "markName": "BATTERIES EVENT",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Organization of exhibitions for commercial purposes or for promotion of goods and services; presentation of goods.; IC 041: Organization of professional conferences; organization of professional conferences and international exhibitions in the field of technology and for presentation of new products and services providing abstract editing services for congresses, conferences or trade fairs.",
    "applicationDate": "2025-05-20",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/79426430",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78688162",
    "country": "US",
    "markName": "EVENT MONITOR",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Water analysis software using a proprietary algorithm to identify contamination occurances and classify contaminents.",
    "applicationDate": "2005-08-08",
    "registrationDate": "2006-08-01",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78688162",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99029853",
    "country": "US",
    "markName": "EVENT AURA",
    "status": "Live",
    "internationalClasses": [
      "24"
    ],
    "goodsDescription": "IC 024: Textile backdrops for use in photography; Canvas and muslin backdrops for use in photographic and video production; Backdrops comprised of polymeric material being a textile substitute for use in photography; Textile backdrops for use in photography comprised in whole or substantial part of aluminium and spandex.",
    "applicationDate": "2025-02-05",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99029853",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87898200",
    "country": "US",
    "markName": "EVENT BLOSSOM",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: On-line retail store services featuring personalized wedding and party favors, supplies, keepsakes, announcements, invitations and related social stationery items and accessories.",
    "applicationDate": "2018-04-27",
    "registrationDate": "2019-07-02",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87898200",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "79312315",
    "country": "US",
    "markName": "EVENT TWINS",
    "status": "Live",
    "internationalClasses": [
      "9",
      "35",
      "41",
      "42",
      "45"
    ],
    "goodsDescription": "IC 009: Downloadable video recordings featuring music; downloadable computer game software; downloadable computer game programs; downloadable electronic game programs; Downloadable interactive multimedia computer game programs; computer software that permits games to be played in the nature of computer game software downloadable from a global computer network; computer game software for use on mobile devices in the nature of downloadable computer game software for use on mobile and cellular phones; downloadable computer software development tools; computer game cartridges; computer game discs.; IC 035: Advertising services, marketing services and public relations, namely, promoting and marketing the goods and services of others through all public communication means; organization of exhibitions and trade fairs for commercial or advertising purposes; development of advertising concepts; provision of an online marketplace for buyers and sellers of goods and services; digital advertising...",
    "applicationDate": "2020-10-13",
    "registrationDate": "2022-06-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/79312315",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "75931998",
    "country": "US",
    "markName": "EVENT 1",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Event merchandiser services, namely, retail marketing services on-site at sporting events and entertainment events.",
    "applicationDate": "2000-02-29",
    "registrationDate": "2001-02-27",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/75931998",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85550707",
    "country": "US",
    "markName": "MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "1"
    ],
    "goodsDescription": "IC 001: Plant fertilizers; Foliar applications, namely, preparations for fortifying plants and plant food.",
    "applicationDate": "2012-02-23",
    "registrationDate": "2013-12-31",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85550707",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77625580",
    "country": "US",
    "markName": "EVENT INTELLIGENCE",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Computer software that provides real time call routing, data mining, and automated data population of screens displayed on computer monitors of customer service representatives at call centers by use of integrated business management rules that are industry specific.",
    "applicationDate": "2008-12-03",
    "registrationDate": "2009-11-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77625580",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86823364",
    "country": "US",
    "markName": "EVENT CINEMAS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: [ Cinema theaters; distribution of motion picture films; provision of cinema facilities; amusement arcades; video arcade services; providing bowling alleys; entertainment services, namely, movie fan club services; ] providing electronic information in the field of entertainment, namely, cinemas [, distribution of motion picture films, amusement and video arcades, bowling alleys, movie fan clubs, ] and booking and ticketing of cinema seats.",
    "applicationDate": "2015-11-17",
    "registrationDate": "2016-12-27",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86823364",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90635096",
    "country": "US",
    "markName": "EVENT GURU",
    "status": "Live",
    "internationalClasses": [
      "35",
      "16",
      "9",
      "41"
    ],
    "goodsDescription": "IC 009: Electronic downloadable publications in the nature of books, handouts, workbooks, programs, advertisements, notes and guides in the field of trade shows, business fairs, business seminars, business conferences and business events; digital media, namely, pre-recorded CDs, DVDs, and USB cards featuring books, handouts, workbooks, programs, advertisements, notes and guides in the field of seminars, gatherings, conferences, and conventions for businesses, enterprises, healthcare, musical performances and social interactions.; IC 016: Pens, writing pads, sticky adhesive notepads; printed notes, guides, and publications in the nature of books, handouts, workbooks, programs, advertisements in the field of trade shows, business fairs, business seminars, business conferences and business events.; IC 035: Arranging, conducting and promoting trade shows, business fairs, and business events the field of social media marketing, sales and marketing, organizational leadership, organizational...",
    "applicationDate": "2021-04-09",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90635096",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "79261738",
    "country": "US",
    "markName": "EVENT STORE",
    "status": "Live",
    "internationalClasses": [
      "9",
      "42"
    ],
    "goodsDescription": "IC 009: Downloadable electronic publications in the nature of books in the field of computer databases and distributed systems; Downloadable computer software for data storage and database management; Downloadable electronic publications in the nature of electronic magazines in the field of computer databases and distributed systems.; IC 042: Design and development of computer hardware; consultancy, information and advisory services relating to all of the aforesaid services.",
    "applicationDate": "2019-05-17",
    "registrationDate": "2021-01-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/79261738",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87069644",
    "country": "US",
    "markName": "EVENT ESSENTIALS",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Party supply rental services, namely, rental of tables, chairs, tents, awnings, tableware, silverware, flatware, stemware, serviceware, glasses, plates, forks, knives, spoons, linens, umbrellas, centerpieces, candelabras, candle sticks, temporary lighting equipment, and party decorations.",
    "applicationDate": "2016-06-13",
    "registrationDate": "2017-01-31",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87069644",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99698475",
    "country": "US",
    "markName": "EVENT SOURCE",
    "status": "Live",
    "internationalClasses": [
      "20",
      "41",
      "43"
    ],
    "goodsDescription": "IC 020: Punch fountain; pretzel warmer and display; popcorn tray holder; ice cream cart; hot dog cart; ice cream dipping cabinet; cotton candy machine; snow cone machine; nacho cheese dispenser; slush machine; rental of popcorn machines; rental of food service equipment; rental of kitchen sinks; rental of portable buildings; rental of rugs; rental of food services equipment, namely, rental of food warming heat lamps and heated food cabinets; rental of furniture; rental of catering equipment; rental of bar equipment; rental of party and event and banquet supplies, namely, table linens, glassware, tableware, silverware, dishes, chafing dishes and table accessories in the nature of table numbers, table number holders, vases, ashtrays.; IC 041: Providing and rental of exhibition stands and booths including respective equipment; providing a website featuring a list of items and services available for rent by others; event planning; event consultation; event planning virtual design services;...",
    "applicationDate": "2026-03-12",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99698475",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99210893",
    "country": "US",
    "markName": "EVENT ZERO",
    "status": "Live",
    "internationalClasses": [
      "35",
      "38",
      "36",
      "42"
    ],
    "goodsDescription": "IC 035: Promoting the interests of people concerned with health, community and environmental sustainability issues; Promoting public awareness of environmental matters; Promoting public awareness of environmental issues and initiatives; Business consulting in the field of environmental management, namely, advising businesses and individuals on issues of environmental impact, conservation, preservation and protection, and economic analysis for business purposes; Charitable services, namely, organizing and developing projects to promote awareness of tree and environmental conservation; Recruitment and placement of volunteers in the field of environmental conservation.; IC 036: Charitable fund raising services to promote awareness of tree and environmental conservation; Charitable fundraising services by means of organizing and conducting projects to promote awareness of tree and environmental conservation.; IC 038: Telecommunication services, namely, transmission of voice, data and...",
    "applicationDate": "2025-05-30",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99210893",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99495613",
    "country": "US",
    "markName": "EVENT SOURCE",
    "status": "Live",
    "internationalClasses": [
      "20",
      "41",
      "43"
    ],
    "goodsDescription": "IC 020: punch fountain, pretzel warmer and display, popcorn tray holder, popcorn machine, ice cream cart, hot dog cart, ice cream dipping cabinet, cotton candy machine;rental of popcorn machines;rental of food service equipment;rental of kitchen sinks;rental of portable buildings;rental of rugs;rental of food services equipment, namely, rental of food warming heat lamps and heated food cabinets;rental of furniture;rental of catering equipment;rental of bar equipment;rental of party and banquet supplies, namely, table linens, glassware, tableware, silverware, dishes, chafing dishes and table accessories in the nature of table numbers, table number holders, vases, ashtrays, chargers and table ornaments, for commercial and domestic special events.; IC 041: Providing and rental of exhibition stands and booths including respective equipment;providing a website featuring a list of items and services available for rent by others;refrigerator rental;rental of freezers;rental of freezers for...",
    "applicationDate": "2025-11-13",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99495613",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "76120571",
    "country": "US",
    "markName": "EVENT TECH",
    "status": "Live",
    "internationalClasses": [
      "40",
      "41",
      "42"
    ],
    "goodsDescription": "IC 040: RENTAL OF GENERATORS AND POWER DISTRIBUTION.; IC 041: RENTAL OF SOUND SYSTEMS, LIGHTING SYSTEMS, STAGING SYSTEMS, PORTABLE ROOF SYSTEMS, VIDEO PRODUCTION EQUIPMENT, FLIGHT CASES AND CUSTOM SPEAKERS FOR USE IN STAGING EVENTS.; IC 042: CONSULTING SERVICES RELATED TO STAGING EVENTS.",
    "applicationDate": "2000-08-28",
    "registrationDate": "2002-08-13",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/76120571",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99765938",
    "country": "US",
    "markName": "EVENT ENGINE",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Downloadable middleware for software application integration; Downloadable software for monitoring and controlling communication between computers and automated machine systems; Downloadable factory automation software, namely, software to integrate manufacturing machine operations, track problems and generate production reports.",
    "applicationDate": "2026-04-15",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99765938",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97830792",
    "country": "US",
    "markName": "TOTALITY EVENT",
    "status": "Live",
    "internationalClasses": [
      "33"
    ],
    "goodsDescription": "IC 033: Wine.",
    "applicationDate": "2023-03-09",
    "registrationDate": "2024-11-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97830792",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98105126",
    "country": "US",
    "markName": "EVENT BOOST",
    "status": "Live",
    "internationalClasses": [
      "9",
      "41",
      "42"
    ],
    "goodsDescription": "IC 009: Downloadable application software for mobile telephones for event management, namely, software for branded email invitations, online registration forms, automated confirmations, event web page publishing, name badges, on site check-in and guest management; downloadable application software for event management, namely, software for branded email invitations, online registration forms, automated confirmations, event web page publishing, name badges, on site check-in and guest management; downloadable software platforms for event management, namely, software for branded email invitations, online registration forms, automated confirmations, event web page publishing, name badges, on site check-in and guest management.; IC 041: Provision of information relating to entertainment and recreational events via online networks and the Internet; booking of seats for entertainment shows; ticket reservation services for sporting, scientific and cultural events; reservation services for...",
    "applicationDate": "2023-07-27",
    "registrationDate": "2025-05-20",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98105126",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "75222101",
    "country": "US",
    "markName": "EVENT ASSOCIATES",
    "status": "Live",
    "internationalClasses": [
      "36",
      "41"
    ],
    "goodsDescription": "IC 036: fund raising for not-for-profit organizations, corporations, private groups, and capital and political campaigns.; IC 041: special event planning and production services.",
    "applicationDate": "1997-01-07",
    "registrationDate": "1998-05-26",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/75222101",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97353901",
    "country": "US",
    "markName": "EVENT HAWK",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Marketing consulting; Marketing plan development; Search engine optimisation for sales promotion; Social media strategy and marketing consultancy focusing on helping clients create and extend their product and brand strategies by building virally engaging marketing solutions; Advertising and marketing; Advertising and marketing services provided by means of indirect methods of marketing communications, namely, social media, search engine marketing, inquiry marketing, internet marketing, mobile marketing, blogging and other forms of passive, sharable or viral communications channels; Business marketing services; Business reputation management and improvement services; Development of marketing strategies, concepts and tactics, namely, audience development, brand awareness, customer relations, online community building and digital word of mouth communications; Direct marketing services; Marketing services in the field of conversion rate optimization (CRO); On-line customer-based...",
    "applicationDate": "2022-04-08",
    "registrationDate": "2023-05-23",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97353901",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97359281",
    "country": "US",
    "markName": "MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "31"
    ],
    "goodsDescription": "IC 031: Wildlife seed mixtures.",
    "applicationDate": "2022-04-12",
    "registrationDate": "2023-06-20",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97359281",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97574638",
    "country": "US",
    "markName": "EVENT LEATHER",
    "status": "Live",
    "internationalClasses": [
      "25"
    ],
    "goodsDescription": "IC 025: Chaps; Gloves; Gloves as clothing; Gloves for apparel; Motorcycle gloves; Motorcycle jackets; Motorcycle rain suits; Vests; Bomber jackets; Boots for motorcycling; Clothing jacket liners; Clothing jackets; Denim jackets; Driving gloves; Fingerless gloves; Fingerless gloves as clothing; Heavy jackets; Leather jackets; Leather vests; Men's and women's jackets, coats, trousers, vests; Outdoor gloves; Outer jackets; Riding jackets; Sheepskin jackets; Sleeveless jackets; Suede jackets; all made wholly or substantially in part of leather.",
    "applicationDate": "2022-09-01",
    "registrationDate": "2023-11-14",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97574638",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85981593",
    "country": "US",
    "markName": "DISCOVERY EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Real estate marketing services, namely, conducting interviews and surveys for customizing the construction of residential properties for individual lifestyles.",
    "applicationDate": "2011-11-17",
    "registrationDate": "2014-05-13",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85981593",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88354818",
    "country": "US",
    "markName": "EVENT LAB",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing online non-downloadable software for project development and database management in the field of event development, planning, management and execution.",
    "applicationDate": "2019-03-25",
    "registrationDate": "2020-10-27",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88354818",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98707497",
    "country": "US",
    "markName": "EVENT MANIA",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Ticket reservation and booking for entertainment events; Ticket reservation and booking services for entertainment, sporting and cultural events; Ticket reservation and booking services for recreational and leisure events, namely, music concerts; Entertainment ticket agency services; On-line entertainment ticket agency services; Ticket agency services for entertainment events.",
    "applicationDate": "2024-08-20",
    "registrationDate": "2025-06-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98707497",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88610973",
    "country": "US",
    "markName": "EVENT MEDICAL",
    "status": "Live",
    "internationalClasses": [
      "10"
    ],
    "goodsDescription": "IC 010: Medical ventilators.",
    "applicationDate": "2019-09-10",
    "registrationDate": "2020-04-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88610973",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88438775",
    "country": "US",
    "markName": "EVENT BRAINS",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Software as a service (SAAS) services, namely, hosting software for use by others for planning special events such as business conventions, trade shows, and educational events by collecting, organizing and allowing edits to assets in the nature of speaker and sponsor contact information, headshots, logos, biographies, slides, videos, and marketing materials.",
    "applicationDate": "2019-05-20",
    "registrationDate": "2019-12-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88438775",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88891053",
    "country": "US",
    "markName": "CHIL EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Film and video production.",
    "applicationDate": "2020-04-28",
    "registrationDate": "2020-12-29",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88891053",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88093415",
    "country": "US",
    "markName": "COR EVENT",
    "status": "Live",
    "internationalClasses": [
      "44"
    ],
    "goodsDescription": "IC 044: Medical analysis services in the field of cardiology; medical analysis of electrocardiographic data; Medical diagnostic testing, monitoring and reporting services in the field of cardiology and electrocardiographic data.",
    "applicationDate": "2018-08-27",
    "registrationDate": "2023-05-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88093415",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "79272012",
    "country": "US",
    "markName": "EVENT CUP",
    "status": "Live",
    "internationalClasses": [
      "42",
      "40",
      "21",
      "35"
    ],
    "goodsDescription": "IC 021: Plastic cups; paper cups; cup holders for household purposes; kitchen utensils, namely, kitchen tongs, dishers, spatulas; plastic household storage containers for drinks, food, and cooking; cardboard utensils and containers for drinks, food and cooking, namely, cardboard cups; plastic dishes; cardboard dishes.; IC 035: Advertising agency services and consultancy regarding advertising communication strategies for personalized communication; Advertising services and advertising text publication services on plastic cups, cardboard cups, cup holders, plastic utensils and containers for drinks, food and cooking, cardboard utensils and containers for drinks, food and cooking, plastic dishes, cardboard dishes; Design of advertising materials featuring personalized advertising visuals for plastic cups, cardboard cups, cup holders, plastic utensils and containers for drinks, food and cooking, cardboard utensils and containers for drinks, food and cooking, plastic dishes, cardboard...",
    "applicationDate": "2019-06-21",
    "registrationDate": "2020-11-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/79272012",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "76376877",
    "country": "US",
    "markName": "EVENT SCAPE",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: SPECIAL EVENT PLANNING.",
    "applicationDate": "2002-03-04",
    "registrationDate": "2003-03-11",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/76376877",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85475119",
    "country": "US",
    "markName": "DISCOVERY EVENT",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Computer software for use by real estate developers, designers, and builders in planning, designing, and constructing residential properties customized for individual lifestyles.",
    "applicationDate": "2011-11-17",
    "registrationDate": "2014-10-14",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85475119",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85829670",
    "country": "US",
    "markName": "EVENT DIFFERENTLY",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Arranging and conducting special events for business purposes; Arranging and conducting special events for commercial, promotional or advertising purposes.",
    "applicationDate": "2013-01-23",
    "registrationDate": "2013-09-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85829670",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85973358",
    "country": "US",
    "markName": "MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services, namely, conducting live poker events; organizing, conducting and operating poker tournaments.",
    "applicationDate": "2013-06-28",
    "registrationDate": "2019-08-06",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85973358",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98877736",
    "country": "US",
    "markName": "EVENT DYNAMIC",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Software as a service (SAAS) services featuring software using artificial intelligence (AI) for automating pricing of goods and services.",
    "applicationDate": "2024-11-29",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98877736",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99669306",
    "country": "US",
    "markName": "EVENT WIZARD",
    "status": "Live",
    "internationalClasses": [
      "43",
      "35",
      "42"
    ],
    "goodsDescription": "IC 035: Corporate event management services; Conference event management services.; IC 042: Platform as a service (PAAS) featuring computer software platforms for Sourcing and contracting  and booking of event, tradeshow and hotel accommodations, event management.; IC 043: Arranging temporary housing accommodations; Booking agency services for accommodation in hotels.",
    "applicationDate": "2026-02-25",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99669306",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99660435",
    "country": "US",
    "markName": "EVENT ARROW",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging, organizing, conducting, and hosting social entertainment events.",
    "applicationDate": "2026-02-19",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99660435",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87087198",
    "country": "US",
    "markName": "EVENT ELEVEN",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes; Special event planning for commercial, promotional or advertising purposes.; IC 041: Entertainment services, namely, producing public and private social entertainment events for others; Special event planning for social entertainment purposes.",
    "applicationDate": "2016-06-28",
    "registrationDate": "2017-02-14",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87087198",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99698593",
    "country": "US",
    "markName": "EVENT SOURCE",
    "status": "Live",
    "internationalClasses": [
      "20",
      "41",
      "43"
    ],
    "goodsDescription": "IC 020: Punch fountain; pretzel warmer and display; popcorn tray holder; ice cream cart; hot dog cart; ice cream dipping cabinet; cotton candy machine; snow cone machine; nacho cheese dispenser; slush machine; rental of popcorn machines; rental of food service equipment; rental of kitchen sinks; rental of portable buildings; rental of rugs; rental of food services equipment, namely, rental of food warming heat lamps and heated food cabinets; rental of furniture; rental of catering equipment; rental of bar equipment; rental of party and event and banquet supplies, namely, table linens, glassware, tableware, silverware, dishes, chafing dishes and table accessories in the nature of table numbers, table number holders, vases, ashtrays.; IC 041: Providing and rental of exhibition stands and booths including respective equipment; providing a website featuring a list of items and services available for rent by others; event planning; event consultation; event planning virtual design services;...",
    "applicationDate": "2026-03-12",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99698593",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99209048",
    "country": "US",
    "markName": "MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "29",
      "30",
      "5"
    ],
    "goodsDescription": "IC 005: Protein supplements formed and packaged as bars; Nutritional supplement energy bars; Nutritional and dietary supplements formed and packaged as bars; Protein dietary supplements formed and packaged as bars.; IC 029: Nut-based snack foods; Nut-based food bars; Fruit- and nut-based snack bars featuring a chocolate coating; Organic nut and seed-based snack bars; Processed fruit- and nut-based food bars; Fruit-based meal replacement bars; Nut- and dried fruit- based snack bars; Seed-based snack bars; Nut-based snack bars; Fruit-based raw food bars; Vegetable-based raw food bars; Nut and seed-based snack bars.; IC 030: Cereal-based snack food; Cereal-based snack foods; Grain-based snack foods; High-protein cereal bars; Cereal bars; Chocolate-based meal replacement bars; Granola-based snack bars; Chocolate-based snack bars containing nuts; Cereal-based energy bars.",
    "applicationDate": "2025-05-29",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99209048",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99491363",
    "country": "US",
    "markName": "EVENT SCIENCE",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Professional coaching services in the field of professional speaking, entrepreneurship, sales, networking, media outreach, branding, public relations, confidence, and business services; Virtual personal coaching services in the field of professional speaking, entrepreneurship, sales, networking, media outreach, branding, public relations, confidence, and business services; Coaching in the field of professional speaking, entrepreneurship, sales, networking, media outreach, branding, public relations, confidence, and business services; Providing group coaching and in-person learning forums in the field of leadership development; Educational and entertainment services, namely, providing motivational speaking services in the field of professional speaking, entrepreneurship, sales, networking, media outreach, branding, public relations, confidence, and business services; Educational and entertainment services, namely, providing motivational and educational speakers in the field of...",
    "applicationDate": "2025-11-11",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99491363",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99464265",
    "country": "US",
    "markName": "EVENT MULTIPLIER",
    "status": "Live",
    "internationalClasses": [
      "35",
      "9",
      "36",
      "42"
    ],
    "goodsDescription": "IC 009: Downloadable computer software for enabling uploading, downloading, accessing, posting, displaying, editing, tagging, blogging, streaming, linking, sharing and otherwise providing electronic media and information via computer and communication networks; Downloadable computer software for sending and receiving electronic messages, graphics, images, audio and audio visual content via global communication networks; Computer software applications, downloadable, for the collection, editing, organizing, modifying, transmission, storage and sharing of data and information; Downloadable computer search engine software; Downloadable computer software for searching charities and non-profit organizations; Downloadable computer software for social networking; Downloadable computer software for facilitating and arranging for the financing and distribution of fundraising and donations; Downloadable computer software for searching charitable events.; IC 035: Charitable services, namely,...",
    "applicationDate": "2025-10-27",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99464265",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99582543",
    "country": "US",
    "markName": "EVENT STORMBURSTLT",
    "status": "Live",
    "internationalClasses": [
      "24",
      "25"
    ],
    "goodsDescription": "IC 024: Fabric and fabric components used in the manufacture of clothing, apparel, garments, industrial and protective garments, tents, sleeping bags, and drapes.; IC 025: Clothing, namely, jackets, vests, coats, pants, hats, caps, gloves.",
    "applicationDate": "2026-01-07",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99582543",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98109774",
    "country": "US",
    "markName": "EVENT SHIELD",
    "status": "Live",
    "internationalClasses": [
      "37"
    ],
    "goodsDescription": "IC 037: Extermination of pests, other than for agriculture, aquaculture, horticulture and forestry; Pest control and extermination services, other than for agriculture, aquaculture, horticulture and forestry; Pest control for residential homes; Pest control services in homes; Pest control services, other than for agriculture, aquaculture, horticulture and forestry.",
    "applicationDate": "2023-07-31",
    "registrationDate": "2024-10-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98109774",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88778281",
    "country": "US",
    "markName": "EVENT THERAPY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, providing career re-training in the forms of web-based and classroom-based seminars and workshops in the field of continuing education for teachers and principals.",
    "applicationDate": "2020-01-29",
    "registrationDate": "2022-04-05",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88778281",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78948033",
    "country": "US",
    "markName": "EVENT SOURCE",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Retail store services featuring used [ tents, ] tables, chairs, linens, and dishes for non-commercial use by others not providing products or services for events in the nature of meetings, conventions, and special events.",
    "applicationDate": "2006-08-09",
    "registrationDate": "2008-01-01",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78948033",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85792294",
    "country": "US",
    "markName": "EVENT ACCOMPLISHED",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Party and wedding reception planning, coordination and consultation services; providing information in the field of wedding party planning; special event planning for social entertainment purposes.",
    "applicationDate": "2012-12-01",
    "registrationDate": "2013-08-13",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85792294",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85932574",
    "country": "US",
    "markName": "EVENT MARKETER",
    "status": "Live",
    "internationalClasses": [
      "9",
      "41"
    ],
    "goodsDescription": "IC 009: Downloadable electronic magazines containing information in the field of sponsorships and marketing.; IC 041: Non-downloadable electronic magazines delivered by e-mail containing information in the field of sponsorships and marketing.",
    "applicationDate": "2013-05-15",
    "registrationDate": "2013-11-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85932574",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88439713",
    "country": "US",
    "markName": "EVENT ENHANCERS",
    "status": "Live",
    "internationalClasses": [
      "21",
      "35"
    ],
    "goodsDescription": "IC 021: Ceramic sculptures, vases, vessels, bowls, plates and pots; Cocktail glasses; Cocktail shakers; Cooling buckets for wine; Corkscrews; Cups and mugs; Dessert plates; Dinnerware; Drinkware; Ice buckets; Ice scoops; Ice tongs; Margarita glasses; Martini glasses; Mason jars; Mixing bowls; Mixing cups; Mixing spoons; Pitchers; Salad bowls; Salt and pepper shakers; Serving dishes; Serving forks; Serving ladles; Serving platters; Serving spoons; Serving tongs; Serving trays; Tea sets; Wine buckets; Wine glasses; Wine jugs; Crockery, namely, pots, dishes, drinking cups and saucers, bowls, serving bowls and trays;\u00a0serving\u00a0platters; glass products, namely\u00a0glass beverageware drinking glasses, cups, decanters, mugs, tumblers\u00a0for use as drinking glasses,\u00a0household\u00a0food containers made of glass, bottles\u00a0sold empty, plates, bowls,\u00a0glass jars; kitchen utensils\u00a0and\u00a0accessories, namely,\u00a0kitchen tongs and serving utensils.; IC 035: online retail and wholesale store services featuring preparation,...",
    "applicationDate": "2019-05-21",
    "registrationDate": "2020-06-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88439713",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90808592",
    "country": "US",
    "markName": "EVENT THERAPY",
    "status": "Live",
    "internationalClasses": [
      "16",
      "44"
    ],
    "goodsDescription": "IC 016: Book marks; Stationery; Writing utensils; Blank journals for writing; Office stationery; Printed books in the field of lifestyle of event and entertainment professionals, health, event execution and planning, mental health and business health support, travel, fashion, professional and personal development, self help, professional and personal empowerment, lifestyle inspiration and counseling; Printed brochures about lifestyle of event and entertainment professionals, health, event execution and planning, mental health and business health support, travel, fashion, professional and personal development, self help, professional and personal empowerment, lifestyle inspiration and counseling; Stickers.; IC 044: Counseling in the field of mental health and wellness; Mental health therapy services.",
    "applicationDate": "2021-07-02",
    "registrationDate": "2024-03-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90808592",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90853339",
    "country": "US",
    "markName": "EVENT-LIT",
    "status": "Live",
    "internationalClasses": [
      "45"
    ],
    "goodsDescription": "IC 045: Rental of signs for personal messages in the field of commercial and personal events.",
    "applicationDate": "2021-07-28",
    "registrationDate": "2022-09-20",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90853339",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90300262",
    "country": "US",
    "markName": "EVENT BLEND",
    "status": "Live",
    "internationalClasses": [
      "33"
    ],
    "goodsDescription": "IC 033: Mead; Wine; Fruit wine; Hard cider.",
    "applicationDate": "2020-11-05",
    "registrationDate": "2021-08-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90300262",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98278945",
    "country": "US",
    "markName": "EVENT THEM",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging and conducting nightclub entertainment events; Entertainment services in the nature of live musical performances; Entertainment services in the nature of live music, art, culture, theater, sports, dance, gaming, and entertainment performances; Entertainment services in the nature of production of live events for parties and special events for social entertainment purposes; Entertainment services, namely, multimedia production services; Entertainment ticket agency services; Hosting social entertainment events, namely, corporate, fundraising, and live entertainment events, for others; Hosting social entertainment events, namely, weddings, birthdays, and personal life events, for others; Hosting social entertainment events, namely, music, art, culture, theater, sports, dance, gaming, and live events, for others; Live musical theater performances; Organization of entertainment events in the nature of corporate, fundraising, and live entertainment events; Organization of...",
    "applicationDate": "2023-11-20",
    "registrationDate": "2024-10-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98278945",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98279771",
    "country": "US",
    "markName": "EVENT THEM",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Event planning and management for marketing, branding, promoting or advertising the goods and services of others; Management of event ticketing for others; Providing facilities for business meetings; Special event planning for business purposes; Special event planning for commercial, promotional or advertising purposes.",
    "applicationDate": "2023-11-21",
    "registrationDate": "2024-10-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98279771",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78348324",
    "country": "US",
    "markName": "EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "38"
    ],
    "goodsDescription": "IC 038: WEB-BASED INTERACTIVE MULTIMEDIA TELECONFERENCING SERVICES.",
    "applicationDate": "2004-01-06",
    "registrationDate": "2005-11-29",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78348324",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77248588",
    "country": "US",
    "markName": "! EVENT MONITOR",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing temporary use on on-line non-downloadable computer software that provides real-time, integrated business management intelligence by combining information from various databases and presenting it in an easy-to-understand user interface; providing temporary use on on-line non-downloadable computer software for the collection, editing, organizing, modifying, book marking, transmission, storage and sharing of data and information.",
    "applicationDate": "2007-08-07",
    "registrationDate": "2009-05-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77248588",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85375944",
    "country": "US",
    "markName": "EVENT CLOUD",
    "status": "Live",
    "internationalClasses": [
      "35",
      "42"
    ],
    "goodsDescription": "IC 035: Business services, namely, conducting, organizing and promoting interactive virtual and virtual-live hybrid tradeshows, conferences, symposiums, expositions, job fairs, business meetings, expositions, product launches, corporate briefings, lead generation activities, business networking programs, and combinations thereof with third party software applications or functionality.; IC 042: Computer services, namely, providing temporary use of non-downloadable computer software for the purpose of conducting interactive virtual and virtual-live hybrid business meetings, tradeshows, conferences, webcasts conferences, symposiums, expositions, seminars, training programs, online education programs, product launches, corporate briefings, job fairs, lead generation activities, industry networking programs, business networking programs, video streaming, online education programs and combinations thereof.",
    "applicationDate": "2011-07-20",
    "registrationDate": "2012-07-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85375944",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99334086",
    "country": "US",
    "markName": "EVENT HORIZON",
    "status": "Live",
    "internationalClasses": [
      "45"
    ],
    "goodsDescription": "IC 045: Granting of licenses for intellectual property rights; Licensing of patents.",
    "applicationDate": "2025-08-12",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99334086",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88248291",
    "country": "US",
    "markName": "EVENT GUARD",
    "status": "Live",
    "internationalClasses": [
      "44"
    ],
    "goodsDescription": "IC 044: Landscape gardening; Pest control for horticulture.",
    "applicationDate": "2019-01-03",
    "registrationDate": "2019-09-03",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88248291",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "74562220",
    "country": "US",
    "markName": "EVENT TAPE",
    "status": "Live",
    "internationalClasses": [
      "20"
    ],
    "goodsDescription": "IC 020: banners made of printed plastic film.",
    "applicationDate": "1994-08-17",
    "registrationDate": "1995-10-31",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/74562220",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97914693",
    "country": "US",
    "markName": "POP EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: On-line business directories featuring individuals and businesses that provide services to the event industry.",
    "applicationDate": "2023-05-01",
    "registrationDate": "2025-12-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97914693",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86908949",
    "country": "US",
    "markName": "EVENT SOURCE",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Renting and leasing of furniture, food service equipment, catering equipment, bar equipment, and party and banquet supplies, namely, table linens, glassware, tableware, silverware, dishes, chafing dishes and table accessories in the nature of table numbers, table number holders, vases, ashtrays, chargers and table ornaments, for commercial and domestic special events.",
    "applicationDate": "2016-02-16",
    "registrationDate": "2016-11-22",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86908949",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99318443",
    "country": "US",
    "markName": "EVENT VENDORS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Consultation in the field of special event planning for social entertainment purposes.",
    "applicationDate": "2025-08-04",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99318443",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99005872",
    "country": "US",
    "markName": "EVENT PERCH",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing a web site featuring technology that enables users to connect with venues, vendors, and service providers, enabling them to search, compare, and book venues and vendors for events; Providing temporary use of on-line non-downloadable software and applications for use in event planning and management, namely, for managing event logistics, budget tracking, attendee management, task assignments, venue selection, vendor coordination, scheduling, and booking event venues and services; Software as a service (SAAS) services featuring software for use in event planning and management, namely, for managing event logistics, budget tracking, attendee management, task assignments, venue selection, vendor coordination, scheduling, and booking event venues and services.",
    "applicationDate": "2025-01-17",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99005872",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99698527",
    "country": "US",
    "markName": "EVENT SOURCE",
    "status": "Live",
    "internationalClasses": [
      "20",
      "41",
      "43"
    ],
    "goodsDescription": "IC 020: Punch fountain; pretzel warmer and display; popcorn tray holder; ice cream cart; hot dog cart; ice cream dipping cabinet; cotton candy machine; snow cone machine; nacho cheese dispenser; slush machine; rental of popcorn machines; rental of food service equipment; rental of kitchen sinks; rental of portable buildings; rental of rugs; rental of food services equipment, namely, rental of food warming heat lamps and heated food cabinets; rental of furniture; rental of catering equipment; rental of bar equipment; rental of party and event and banquet supplies, namely, table linens, glassware, tableware, silverware, dishes, chafing dishes and table accessories in the nature of table numbers, table number holders, vases, ashtrays.; IC 041: Providing and rental of exhibition stands and booths including respective equipment; providing a website featuring a list of items and services available for rent by others; event planning; event consultation; event planning virtual design services;...",
    "applicationDate": "2026-03-12",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99698527",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99643787",
    "country": "US",
    "markName": "EVENT TWIN",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing online non-downloadable workflow management software.",
    "applicationDate": "2026-02-10",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99643787",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98404178",
    "country": "US",
    "markName": "MANE EVENT",
    "status": "Live",
    "internationalClasses": [
      "5"
    ],
    "goodsDescription": "IC 005: Dietary and nutritional supplements for stimulating hair growth.",
    "applicationDate": "2024-02-13",
    "registrationDate": "2026-02-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98404178",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88515373",
    "country": "US",
    "markName": "MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "41",
      "43"
    ],
    "goodsDescription": "IC 041: Providing amusement center services featuring amusement arcades, interactive play areas and facilities for games and party centers for the purposes of entertaining people and celebrating events; Providing indoor amusement center services featuring bowling, billiards, virtual reality arcade services, augmented reality arcade services, amusement games, rock climbing and rope courses and laser tag.; IC 043: Restaurant and bar services.",
    "applicationDate": "2019-07-15",
    "registrationDate": "2020-11-03",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88515373",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99222014",
    "country": "US",
    "markName": "FIT EVENT",
    "status": "Live",
    "internationalClasses": [
      "9",
      "42"
    ],
    "goodsDescription": "IC 009: Downloadable software in the nature of a mobile application for the collection of precise body measurements for use in the measuring process for uniforms and equipment.; IC 042: Platform as a service (PAAS) featuring computer software platforms for the collection of precise body measurements for use in the measuring process for uniforms and equipment.",
    "applicationDate": "2025-06-06",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99222014",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99668377",
    "country": "US",
    "markName": "AURA EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event planning for social entertainment purposes.",
    "applicationDate": "2026-02-24",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99668377",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87913329",
    "country": "US",
    "markName": "HOPE EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, providing motivational and educational speakers to prisoners; organizing entertainment and educational events for prisoners featuring speakers and musicians in the field of Christian ministry to provide hope and encouragement to those currently incarcerated.",
    "applicationDate": "2018-05-09",
    "registrationDate": "2020-02-25",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87913329",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87913350",
    "country": "US",
    "markName": "HOPE EVENT",
    "status": "Live",
    "internationalClasses": [
      "45"
    ],
    "goodsDescription": "IC 045: Evangelistic and ministerial services in the field of Christian ministry to prisoners.",
    "applicationDate": "2018-05-09",
    "registrationDate": "2020-02-25",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87913350",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99744496",
    "country": "US",
    "markName": "EVENT GENOME",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Software as a service (SAAS) services featuring software for personalized event discovery, event recommendation, attendee matching, and event schedule management.",
    "applicationDate": "2026-04-03",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99744496",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98380428",
    "country": "US",
    "markName": "EVENT ESSENTIALS",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: On-line retail store services featuring party supplies.",
    "applicationDate": "2024-01-29",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98380428",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98977278",
    "country": "US",
    "markName": "EVENT GREENERS",
    "status": "Live",
    "internationalClasses": [
      "35",
      "9",
      "41"
    ],
    "goodsDescription": "IC 009: Downloadable electronic publications in the nature of reference guides and workbooks in the field of do-it-yourself environmentally sustainable events.; IC 035: Staff placement services; Business consultation services, in the field of environmentally sustainable event organization, planning, and management; Rental of signs for advertising purposes.; IC 041: Organization of environmentally sustainable social entertainment events; Special environmentally sustainable event planning for social entertainment purposes; Consultation in the field of special environmentally sustainable event planning for social entertainment purposes; Consultation in the field of special environmentally sustainable event planning for social entertainment purposes namely, development and implementation of event sustainability policies in the nature of event waste reduction and diversion plans, carbon footprint evaluation and reduction plans, upstream and downstream waste evaluations, food waste reduction...",
    "applicationDate": "2024-01-30",
    "registrationDate": "2026-03-31",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98977278",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78860490",
    "country": "US",
    "markName": "EVENT INTELLIGENCE",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing online non-downloadable software for event management.",
    "applicationDate": "2006-04-12",
    "registrationDate": "2007-01-16",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78860490",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99171759",
    "country": "US",
    "markName": "EVENT HORIZON",
    "status": "Live",
    "internationalClasses": [
      "28"
    ],
    "goodsDescription": "IC 028: Disc golf training aid, namely, disc golf practice nets.",
    "applicationDate": "2025-05-06",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99171759",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99787964",
    "country": "US",
    "markName": "EVENT INTELLIGENCE",
    "status": "Live",
    "internationalClasses": [
      "36",
      "42"
    ],
    "goodsDescription": "IC 036: Financial exchange services, namely, operating an electronic exchange for trading financial instruments and probability-based financial contracts; clearinghouse services for financial derivative transactions; financial index services, namely, calculating, maintaining, and providing probability indexes for financial markets; financial data analysis services, namely, providing event-risk measurements, event-driven financial market risk analysis, and probability-based financial market analytics.; IC 042: Providing temporary use of online non-downloadable software for computing financial probabilities, detecting and analyzing event-driven financial market risk, pricing derivative contracts, and generating probability-based financial market analytics.",
    "applicationDate": "2026-04-26",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99787964",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90686738",
    "country": "US",
    "markName": "D-WAY'S EVENT PLANNING D-WAY FOR YOUR EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event planning for business purposes, namely, planning event details and aspects in the nature of seating, dinning and guests; consultation in the fields of special event planning for a wide variety of events for business purposes; planning, coordination, and managing services for business events of varying sizes; providing specialized facilities for business events.",
    "applicationDate": "2021-05-03",
    "registrationDate": "2023-01-03",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90686738",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77272045",
    "country": "US",
    "markName": "EVENT MARKETER",
    "status": "Live",
    "internationalClasses": [
      "16"
    ],
    "goodsDescription": "IC 016: MAGAZINES AND JOURNALS PUBLISHED PERIODICALLY IN THE FIELD OF SPONSORSHIPS AND MARKETING.",
    "applicationDate": "2007-09-05",
    "registrationDate": "2008-05-13",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77272045",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98527254",
    "country": "US",
    "markName": "MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of social function facilities for special occasions, namely, corporate events, birthday parties, adult social events, team building events and school events.",
    "applicationDate": "2024-04-30",
    "registrationDate": "2025-01-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98527254",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85024489",
    "country": "US",
    "markName": "EVENT N3",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing online non-downloadable computer software used for scanning tickets for admission, exit, and readmission to entertainment and sporting venues.",
    "applicationDate": "2010-04-27",
    "registrationDate": "2011-06-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85024489",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85807065",
    "country": "US",
    "markName": "EVENT KINGS",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes.",
    "applicationDate": "2012-12-19",
    "registrationDate": "2013-07-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85807065",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90268162",
    "country": "US",
    "markName": "EVENT RISK",
    "status": "Live",
    "internationalClasses": [
      "45"
    ],
    "goodsDescription": "IC 045: Security guard services.",
    "applicationDate": "2020-10-21",
    "registrationDate": "2021-09-21",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90268162",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "79326210",
    "country": "US",
    "markName": "EVENT GENIUS",
    "status": "Live",
    "internationalClasses": [
      "9",
      "42"
    ],
    "goodsDescription": "IC 009: Downloadable software for managing events, promotion of events, managing and conducting the sales of tickets and merchandise for events, and for managing and facilitating RFID cashless payments.; IC 042: Software as s Service (SaaS) services featuring event software for managing and promoting events, managing and conducting the sales of tickets and other event related products, and managing and facilitating RFID cashless payments.",
    "applicationDate": "2021-08-12",
    "registrationDate": "2023-07-04",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/79326210",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97584665",
    "country": "US",
    "markName": "EVENT BUTTERFLY",
    "status": "Live",
    "internationalClasses": [
      "25"
    ],
    "goodsDescription": "IC 025: Clothing, namely, shirts and hats.",
    "applicationDate": "2022-09-09",
    "registrationDate": "2024-01-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97584665",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87835053",
    "country": "US",
    "markName": "LUXE EVENT",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of furniture for special events namely, tables, bars, buffets, bar carts, highboys; Rental of seating furniture for special events, namely, chairs, stools, benches, daybeds, ottomans, sofas, booths, banquettes; Rental of furniture for special events, namely, cabanas, panels, dividers, canopies; Rental of table accessories for special events, namely, centerpieces, candelabras, vases, table lamps; Rental of room accessories for special events, namely, chandeliers, lighting apparatus, foliage in the nature of artificial foliage topiaries, arches, hedges, and mirrors.",
    "applicationDate": "2018-03-15",
    "registrationDate": "2019-12-03",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87835053",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87035385",
    "country": "US",
    "markName": "EXTINCTION EVENT",
    "status": "Live",
    "internationalClasses": [
      "32"
    ],
    "goodsDescription": "IC 032: Beer.",
    "applicationDate": "2016-05-12",
    "registrationDate": "2020-08-11",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87035385",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97058952",
    "country": "US",
    "markName": "EVENT ACTION",
    "status": "Live",
    "internationalClasses": [
      "9",
      "42"
    ],
    "goodsDescription": "IC 009: Downloadable operating systems management software for tracking, controlling, backing up and monitoring changes on mainframe computers; downloadable teaching aids, namely, installation, instruction and training manuals, user guides and templates on the subject of operating systems management software; downloadable operating systems management software for tracking, controlling, backing up and monitoring changes on mainframe computers sold as a unit with downloadable and print teaching aids, namely, installation, instruction and training manuals, user guides and templates.; IC 042: Providing online non-downloadable operating systems management software for tracking, controlling, backing up and monitoring changes on mainframe computers.",
    "applicationDate": "2021-10-04",
    "registrationDate": "2025-12-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97058952",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99625114",
    "country": "US",
    "markName": "EVENT BOOKIES",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Providing on-line commercial directory information services; Providing on-line web directory services featuring hyperlinks to the websites of vendors for any type of party or event planning, like caterers, florists, entertainment, party rentals, bakers, etc.; On-line business directories featuring website for customers to find any type of vendor for parties or events, like wedding, birthdays, anniversaries, corporate events;.",
    "applicationDate": "2026-01-30",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99625114",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88632440",
    "country": "US",
    "markName": "EVENT ENGINEERS",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Arranging and conducting special events for business purposes.",
    "applicationDate": "2019-09-26",
    "registrationDate": "2020-02-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88632440",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97830966",
    "country": "US",
    "markName": "EVENT SOURCE",
    "status": "Live",
    "internationalClasses": [
      "43",
      "40",
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Providing and rental of exhibition stands and booths including respective equipment; providing a website featuring a list of items and services available for rent by others..; IC 040: Rental of electric fans for cooling; rental of machines and apparatus for processing foods or beverages; rental of space cooling apparatus; rental of space heating apparatus; rental of space heating apparatus, namely, heat lamps..; IC 041: Party planning consultation; party and wedding reception planning consultation services; rental of portable sports arena seating; rental of portable theatre seating; rental services in the field of decorative accessories for parties, namely, structural columns, arches, hedges, stanchions, stanchion rope, and lattices; rental of raffle drums..; IC 043: Renting and leasing of furniture, food service equipment, catering equipment, bar equipment, and party and banquet supplies, namely, table linens, glassware, tableware, silverware, dishes, chafing dishes and table...",
    "applicationDate": "2023-03-09",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97830966",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88022662",
    "country": "US",
    "markName": "EVENT SOURCE",
    "status": "Live",
    "internationalClasses": [
      "40",
      "39",
      "41",
      "43"
    ],
    "goodsDescription": "IC 039: Refrigerator rental; rental of freezers; rental of freezers for commercial use; rental of freezing machines and apparatus; rental of frozen food lockers; rental of refrigerators for commercial use; delivery of goods.; IC 040: Rental of machines and apparatus for processing foods or beverages.; IC 041: Rental services in the field of decorative accessories for parties, namely, hedges, stanchions, stanchion rope, and lattices; rental of raffle drums.; IC 043: Providing event equipment and supplies for temporary use at party or event venues in the areas of food and beverage storage and preparation, food and beverage service, catering equipment and service, bar equipment, banquet seating, flooring and staging; rental of carpet; rental of cooking apparatus; rental of cooking equipment for industrial purposes; rental of cotton candy making machines; rental of popcorn machines; rental of food service equipment; rental of kitchen sinks; rental of portable buildings; rental of rugs;...",
    "applicationDate": "2018-07-02",
    "registrationDate": "2019-07-23",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88022662",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98357391",
    "country": "US",
    "markName": "SELECT EVENT",
    "status": "Live",
    "internationalClasses": [
      "42",
      "45",
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Special event planning for commercial, promotional or advertising purposes; logistics management in the field of special events; business management of special event logistics for others; consultation in the field of special event planning for business purposes; providing facilities for trade exhibitions; event management services being organizing and conducting of exhibitions for commercial or advertising purposes; event management services being organizing and conducting of marketing promotional events; event management services being organizing and conducting of commercial trade show events.; IC 041: Special event planning for social entertainment purposes; consultation in the field of special event planning for social entertainment purposes; providing specialized facilities for business conferences; providing facilities for recreational activities; event management services being organizing and conducting cultural events; lighting technician services for events; sound...",
    "applicationDate": "2024-01-15",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98357391",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99303070",
    "country": "US",
    "markName": "EVENT REWIND",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Software as a service (SaaS) services featuring software for mapping venues, providing location-based navigation, and organizing, storing, sharing, and displaying time-tagged digital media for live events and social gatherings, namely music festivals, concerts, weddings, corporate events, cruises, and sporting events..",
    "applicationDate": "2025-07-25",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99303070",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99457257",
    "country": "US",
    "markName": "LAUNCH EVENT",
    "status": "Live",
    "internationalClasses": [
      "9",
      "16"
    ],
    "goodsDescription": "IC 009: Downloadable computer software featuring digital trading cards; Downloadable digital image files of trading cards authenticated by non-fungible tokens (NFTs); Downloadable image files containing digital trading cards.; IC 016: Collectible printed trading cards; Printed trading cards, other than for games.",
    "applicationDate": "2025-10-22",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99457257",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99264965",
    "country": "US",
    "markName": "EVENT RISK",
    "status": "Live",
    "internationalClasses": [
      "45"
    ],
    "goodsDescription": "IC 045: Detective investigations; Security guard services.",
    "applicationDate": "2025-07-02",
    "registrationDate": "2026-04-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99264965",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98383204",
    "country": "US",
    "markName": "EVENT GREENERS",
    "status": "Live",
    "internationalClasses": [
      "37",
      "39",
      "43"
    ],
    "goodsDescription": "IC 037: Rental of dish washing machines, dish washing equipment, and dish washing stations.; IC 039: Rental of waste, composting, and recycling containers.; IC 043: Rental of tableware, silverware, and dishes for special events; Rental of furniture, linen, table settings and equipment for the provision of food and drink; Rental of drinking water dispensers; Rental of tents;  \nRental of lighting apparatus for decorating for special events.",
    "applicationDate": "2024-01-30",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98383204",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78596584",
    "country": "US",
    "markName": "EVENT 360",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Business organization and operation consultancy, in the fields of special entertainment event, entertainment event, charitable fundraising event and exhibition planning, personnel management assistance in the field of special entertainment events, development of marketing strategies and concepts in the field of special entertainment events, fundraising counsel in the field of charitable fundraising events.; IC 041: Special event and entertainment services, namely, event and exhibition planning, consultation, concept development, on-site management, entertainment, risk management and cost analysis.",
    "applicationDate": "2005-03-28",
    "registrationDate": "2006-07-25",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78596584",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99475846",
    "country": "US",
    "markName": "EVENT HORIZON",
    "status": "Live",
    "internationalClasses": [
      "30"
    ],
    "goodsDescription": "IC 030: Coffee; Coffee beans; Ground coffee beans; Roasted coffee beans.",
    "applicationDate": "2025-11-03",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99475846",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98412039",
    "country": "US",
    "markName": "E-Z EVENT SYSTEM",
    "status": "Live",
    "internationalClasses": [
      "22",
      "11",
      "6",
      "24",
      "9",
      "19"
    ],
    "goodsDescription": "IC 006: Bar hangers and parts and fittings therefor made of metal for lighting fixtures; Metal mounting brackets for general use; Metal pipe supports; Steel plates and sheets.; IC 009: Mounts and mounting brackets adapted for televisions.; IC 011: Electric space heaters; Portable electric fans; String lights for festive decoration.; IC 019: Building materials, namely, non-metal countertops for further installation.; IC 022: Tents; Awnings of textile or synthetic materials; Canopies of textile or synthetic materials.; IC 024: Banners of textile; Cloth banners.",
    "applicationDate": "2024-02-20",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98412039",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90853611",
    "country": "US",
    "markName": "MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: restaurant and bar services.",
    "applicationDate": "2021-07-28",
    "registrationDate": "2022-09-06",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90853611",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98387434",
    "country": "US",
    "markName": "FORWARD EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, developing, arranging, and conducting educational conferences and programs and providing courses of instruction in the field of content generation and marketing.",
    "applicationDate": "2024-02-01",
    "registrationDate": "2024-12-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98387434",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90506836",
    "country": "US",
    "markName": "EVENT DEPOT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: On-line retail store services featuring a wide variety of consumer goods of others.",
    "applicationDate": "2021-02-03",
    "registrationDate": "2022-07-26",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90506836",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77271960",
    "country": "US",
    "markName": "ZAP EVENT",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing on-line, non-downloadable software for use in collecting information, managing registration and payment, and providing promotional support in the field of event management and registration.",
    "applicationDate": "2007-09-05",
    "registrationDate": "2009-05-05",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77271960",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85115680",
    "country": "US",
    "markName": "EVENT PACK",
    "status": "Live",
    "internationalClasses": [
      "4"
    ],
    "goodsDescription": "IC 004: Candles.",
    "applicationDate": "2010-08-25",
    "registrationDate": "2011-07-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85115680",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86967565",
    "country": "US",
    "markName": "TECTONIC EVENT",
    "status": "Live",
    "internationalClasses": [
      "32"
    ],
    "goodsDescription": "IC 032: Ales; Beer.",
    "applicationDate": "2016-04-07",
    "registrationDate": "2016-11-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86967565",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78495439",
    "country": "US",
    "markName": "BIG EVENT",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: GAMING MACHINES.",
    "applicationDate": "2004-10-06",
    "registrationDate": "2006-07-11",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78495439",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88815701",
    "country": "US",
    "markName": "EVENT STORE",
    "status": "Live",
    "internationalClasses": [
      "9",
      "42"
    ],
    "goodsDescription": "IC 009: Downloadable electronic publications in the nature of articles and manuals in the field of computer databases and distributed systems.; IC 042: Design and development of computer hardware; consultancy, information and advisory services relating to design and development of computer hardware.",
    "applicationDate": "2020-02-28",
    "registrationDate": "2020-08-11",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88815701",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97132156",
    "country": "US",
    "markName": "EVENT WAREHOUSE",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Software as a service (SAAS) services featuring software for analyzing and organizing data from multiple data sources for use in subsequent applications, including analytics and auditing; SAAS services featuring online software or system for analyzing and organizing data from multiple data sources into a series of events, series of event logs, series of immutable events series or series of immutable event logs for use in subsequent applications, including analytics and auditing; SAAS services featuring online software or system for analyzing and organizing data from multiple data sources into one or more views for use in subsequent applications; SAAS services featuring online software or system for analyzing and organizing data from multiple data sources, including sensors, IoT sensors, computers, personal computers and server applications, for use in subsequent applications; SAAS services featuring online software or system for analyzing and organizing data from multiple data...",
    "applicationDate": "2021-11-18",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97132156",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77016208",
    "country": "US",
    "markName": "TECHNICAL EVENT",
    "status": "Live",
    "internationalClasses": [
      "36",
      "42"
    ],
    "goodsDescription": "IC 036: Financial services, namely, providing financial information composed of distinct patterns and anomalies recognized within financial time-series data in the fields of foreign currency, commodities, financial derivatives, interest rate products, and equities, namely, stocks, bonds, funds and indexes, via the internet and intranet.; IC 042: Providing on-line non-downloadable software, namely, pattern recognition technology and analysis software for automating the analysis of financial data, for database management and for electronic databases relating to financial chart patterns.",
    "applicationDate": "2006-10-06",
    "registrationDate": "2007-11-13",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77016208",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87394452",
    "country": "US",
    "markName": "EVENT MEET",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: World wide web user interface for telecommunications conferencing equipment for operator assisted conference calls from three or more remote locations simultaneously, namely, conferencing bridges and telecommunication digital sound media processors.",
    "applicationDate": "2017-03-31",
    "registrationDate": "2017-12-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87394452",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99299849",
    "country": "US",
    "markName": "EVENT IT",
    "status": "Live",
    "internationalClasses": [
      "9",
      "42"
    ],
    "goodsDescription": "IC 009: Downloadable computer software and firmware for organizing and managing events.; IC 042: Providing temporary use of on-line non-downloadable software and applications for organizing and managing events.",
    "applicationDate": "2025-07-23",
    "registrationDate": "2026-03-03",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99299849",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98650879",
    "country": "US",
    "markName": "EVENT THERAPY",
    "status": "Live",
    "internationalClasses": [
      "25",
      "28",
      "9"
    ],
    "goodsDescription": "IC 009: Downloadable films and television programs featuring lifestyle of event and entertainment professionals, health, event execution and planning, mental health and business health support, travel, fashion, professional and personal development, self help, professional and personal empowerment, personal and business inspiration and counseling provided via a video-on-demand service.; IC 025: Clothing, namely, shirts, sweaters, pants, aprons, blouses, robes, coats, jackets, leggings, headbands, wristbands, hats, footwear, sleep masks, face masks, underclothing, athletic gear, namely tops and bottoms, sweatshirts, tank tops, vests.; IC 028: Stress relief balls for hand exercise; Stress relief exercise balls.",
    "applicationDate": "2024-07-16",
    "registrationDate": "2026-01-06",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98650879",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "76600819",
    "country": "US",
    "markName": "EVENT CHANNEL",
    "status": "Live",
    "internationalClasses": [
      "39"
    ],
    "goodsDescription": "IC 039: Providing tourism information via a global computer network; and providing on-line information in the field of tourism by means of hyperlinks to the website of others in the tourism industry.",
    "applicationDate": "2004-07-06",
    "registrationDate": "2006-01-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/76600819",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90525150",
    "country": "US",
    "markName": "SHADOW EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, conducting programs in the field of promoting public awareness and prevention of sexual violence.",
    "applicationDate": "2021-02-11",
    "registrationDate": "2022-01-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90525150",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88515357",
    "country": "US",
    "markName": "MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "41",
      "43"
    ],
    "goodsDescription": "IC 041: Providing amusement center services featuring amusement arcades, interactive play areas and facilities for games and party centers for the purposes of entertaining people and celebrating events; Providing indoor amusement center services featuring bowling, billiards, virtual reality arcade services, augmented reality arcade services, amusement games, rock climbing and rope courses and laser tag.; IC 043: Restaurant and bar services.",
    "applicationDate": "2019-07-15",
    "registrationDate": "2020-11-03",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88515357",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78307946",
    "country": "US",
    "markName": "T.E.N...TIMED EVENT NUTRITION",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, seminars in the field of animal health, training in the use and administration of nutritional supplements for animals.",
    "applicationDate": "2003-10-01",
    "registrationDate": "2005-11-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78307946",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99447185",
    "country": "US",
    "markName": "A HERSH BROTHER'S EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Hosting social entertainment events, namely, tailgate parties, house parties and fund raising events.",
    "applicationDate": "2025-10-16",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99447185",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97884854",
    "country": "US",
    "markName": "SONDAY CHRISTIAN EVENT THEMES",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event planning for social entertainment purposes.",
    "applicationDate": "2023-04-12",
    "registrationDate": "2024-12-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97884854",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "75309560",
    "country": "US",
    "markName": "SLASH-IT! SALES EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: advertising agency services, namely, promoting the services of automobile dealerships through the distribution of printed and audio promotional materials and by rendering sales promotion advice.",
    "applicationDate": "1997-06-16",
    "registrationDate": "1999-03-02",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/75309560",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98742337",
    "country": "US",
    "markName": "THE EVENT HELPER, INC.",
    "status": "Live",
    "internationalClasses": [
      "36"
    ],
    "goodsDescription": "IC 036: Insurance agencies in the field of special event general liability and cancellation insurance; Issuance of special event general liability and cancellation insurance.",
    "applicationDate": "2024-09-10",
    "registrationDate": "2025-08-26",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98742337",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88558949",
    "country": "US",
    "markName": "TOURN EVENT WINNERS CIRCLE",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Downloadable computer game software for gambling machines; Downloadable computer game software for gaming machines, namely, slot machines and video lottery terminals; Downloadable computer software and firmware for playing games of chance on any computerized platform, including dedicated gaming consoles, video based slot machines, reel based slot machines, and video lottery terminals; Downloadable games that accept virtual or monetary wagers sold as a feature of downloadable game software.",
    "applicationDate": "2019-08-01",
    "registrationDate": "2022-06-21",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88558949",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99781325",
    "country": "US",
    "markName": "13 COLONIES SPECIAL EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Organizing, arranging, and conducting amateur radio special events.",
    "applicationDate": "2026-04-22",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99781325",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97651019",
    "country": "US",
    "markName": "WILD WEST EVENT CO.",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Bar services; Bar services featuring rental of bar equipment and mobile bars being furniture and cocktail, bartending, and beverage dispensing equipment for indoor and outdoor events and rental of related event supplies in the nature of cooking, cocktail, bartending, beverage dispensing equipment and bar accessories; Rental of bar equipment; Rental of chairs and tables; Pop-up bar services; Providing information about bar services.",
    "applicationDate": "2022-10-27",
    "registrationDate": "2023-12-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97651019",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97651063",
    "country": "US",
    "markName": "WILD WEST EVENT CO.",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Bar services; Bar services featuring rental of bar equipment and mobile bars being furniture and cocktail, bartending, and beverage dispensing equipment for indoor and outdoor events and rental of related event supplies in the nature of cooking, cocktail, bartending, beverage dispensing equipment and bar accessories; Rental of bar equipment; Rental of chairs and tables; Pop-up bar services; Providing information about bar services.",
    "applicationDate": "2022-10-27",
    "registrationDate": "2023-12-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97651063",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98504610",
    "country": "US",
    "markName": "EVENT SOURCE PROFESSIONALS INC.",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Business consulting, management, and planning services in the field of virtual special event and meeting planning; Business meeting planning; Event planning and management for marketing, branding, promoting or advertising the goods and services of others; Special event planning for business purposes; Special event planning for commercial, promotional or advertising purposes.",
    "applicationDate": "2024-04-17",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98504610",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99423449",
    "country": "US",
    "markName": "EVENT READY, ENERGETICALLY ALIGNED",
    "status": "Live",
    "internationalClasses": [
      "3"
    ],
    "goodsDescription": "IC 003: Beauty gels; Beauty milks; Beauty lotions; Facial beauty masks; Beauty creams; Beauty masks; Beauty masks for face, hand, body; Aromatherapy sprays comprised of essential oils for use on beauty masks; Aromatherapy sprays comprised of essential oils for use on face.",
    "applicationDate": "2025-10-01",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99423449",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86711818",
    "country": "US",
    "markName": "TAKE 1 EVENT RENTALS",
    "status": "Live",
    "internationalClasses": [
      "41",
      "43"
    ],
    "goodsDescription": "IC 041: Party and special event planning services for social and entertainment purposes; rental of audio and sound equipment; rental of portable stages.; IC 043: Rental of lighting apparatus for special events; rental of tents; rental of furniture.",
    "applicationDate": "2015-07-31",
    "registrationDate": "2016-03-29",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86711818",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77118327",
    "country": "US",
    "markName": "STAMFORD TENT & EVENT SERVICES",
    "status": "Live",
    "internationalClasses": [
      "41",
      "43"
    ],
    "goodsDescription": "IC 041: Rental of portable dance floors, portable stages and event lighting all for event and party services.; IC 043: Rental of tents, furniture, food service equipment, and bar equipment, all for event and party services.",
    "applicationDate": "2007-02-28",
    "registrationDate": "2009-01-13",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77118327",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88614079",
    "country": "US",
    "markName": "SJL 26 EVENT PRODUCTIONS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services in the nature of hosting social entertainment events; Organizing and hosting of events for cultural purposes; Organizing culinary, food, and community festivals for cultural or entertainment purposes; Special event planning for social entertainment purposes; Arranging, organizing, conducting, and hosting social entertainment events.",
    "applicationDate": "2019-09-12",
    "registrationDate": "2020-10-13",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88614079",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90709946",
    "country": "US",
    "markName": "AURORA EVENT LIGHTING & RENTALS",
    "status": "Live",
    "internationalClasses": [
      "41",
      "43"
    ],
    "goodsDescription": "IC 041: Special event planning for social entertainment purposes; Entertainment services in the nature of organizing and conducting social entertainment events; Party and wedding reception planning, custom setup and coordination services; Rental and leasing of professional sound equipment and parts; Rental of audiovisual equipment; Rental of audio and sound equipment; Rental of portable stages; Rental of trussing; Rental of dance floors; Rental of equipment and supplies for social entertainment events for individuals and businesses, parties, concerts, and weddings, namely, rental of portable stages, dance floors, and recording, audio and visual equipment.; IC 043: Rental of equipment and supplies for social entertainment events for individuals and businesses, parties, concerts, and weddings, namely, rental of tableware, glassware, table linens, chairs and tables, furniture, and decor; Rental of lighting apparatus for corporate and social entertainment events; Rental of draperies and...",
    "applicationDate": "2021-05-13",
    "registrationDate": "2022-10-25",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90709946",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90801388",
    "country": "US",
    "markName": "CIERA WEDDING & EVENT PLANNING",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Consultation in the field of special event planning for social entertainment purposes; Party planning of special events, birthday parties, family events, lifestyle events, life events; Party and wedding reception planning and coordination services; Party and wedding reception planning, coordination and consultation services.",
    "applicationDate": "2021-06-29",
    "registrationDate": "2022-07-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90801388",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97437792",
    "country": "US",
    "markName": "SHOPROS LIVE EVENT SERVICE",
    "status": "Live",
    "internationalClasses": [
      "41",
      "35"
    ],
    "goodsDescription": "IC 035: Providing labor services being job and personnel placement related to event production, for others.; IC 041: Entertainment information; Entertainment services in the nature of development, creation, production and post-production services of multimedia entertainment content; Entertainment services, namely, conducting parties; Entertainment, namely, lighting production; Hosting social entertainment events, namely, corporate Awards Banquets, for others; Hosting social entertainment events, namely, corporate entertainment events, parties, and banquets, for others; Hosting social entertainment events, namely, staging production services for all types of entertainment events, namely, concerts, corporate entertainment events and other special entertainment events, for others; Hosting social entertainment events, namely, staging services, namely, audio, video, and lighting production and projection services for live events, for others; On-line journals, namely, blogs featuring...",
    "applicationDate": "2022-06-01",
    "registrationDate": "2023-08-08",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97437792",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98358690",
    "country": "US",
    "markName": "LAUNCHPAD EVENT & MEDIA ARCHITECTS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services in the nature of production of live events for parties and special events for social entertainment purposes; Film and video film production.",
    "applicationDate": "2024-01-16",
    "registrationDate": "2024-11-26",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98358690",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98555142",
    "country": "US",
    "markName": "SIGNAGEBUZZ YOUR EVENT EXPERT",
    "status": "Live",
    "internationalClasses": [
      "40",
      "24"
    ],
    "goodsDescription": "IC 024: Banners of textile; Display banners of plastic; Flags of textile or plastic; Printed fabric signage panels; Textile signage panels.; IC 040: Printing; Custom imprinting of tents, inflatable tents, pop-up tents, exhibition display booths, trade show displays, signs, tablecloths, banners, displays, flags with decorative designs; Design printing for others; Printing of advertising brochures for others; Stationery printing services.",
    "applicationDate": "2024-05-16",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98555142",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98280424",
    "country": "US",
    "markName": "EBERHARD'S EVENT & PARTY RENTAL",
    "status": "Live",
    "internationalClasses": [
      "41",
      "43"
    ],
    "goodsDescription": "IC 041: Rental of party games.; IC 043: Rental of tables, chairs, tents, table linens, and table settings.",
    "applicationDate": "2023-11-21",
    "registrationDate": "2024-11-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98280424",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90596841",
    "country": "US",
    "markName": "EVENT & WEDDING LIFESTYLE EXPERT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes.",
    "applicationDate": "2021-03-23",
    "registrationDate": "2022-01-25",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90596841",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98435022",
    "country": "US",
    "markName": "RENDER EVENT DESIGN + PRODUCTION",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Business meeting planning; Conference event management services; Corporate event management services; Organizational services for business purposes, namely, organizing and planning special events for charitable and nonprofit organizations; Organizing, promoting and conducting exhibitions, tradeshows and events for business purposes; Promoting the parties and special events of others; Special event planning for business purposes; Special event planning for commercial, promotional or advertising purposes.",
    "applicationDate": "2024-03-05",
    "registrationDate": "2025-06-03",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98435022",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99028094",
    "country": "US",
    "markName": "EVENT POWER MV, LLC",
    "status": "Live",
    "internationalClasses": [
      "40",
      "39",
      "43"
    ],
    "goodsDescription": "IC 039: Rental of motorized golf carts.; IC 040: Rental of electric power generators.; IC 043: Rental of lighting apparatus for public utility areas and parking lots.",
    "applicationDate": "2025-02-04",
    "registrationDate": "2026-04-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99028094",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98240418",
    "country": "US",
    "markName": "NAIL & LASH EVENT SPA",
    "status": "Live",
    "internationalClasses": [
      "44"
    ],
    "goodsDescription": "IC 044: Day spa services, namely, nail care, manicures, pedicures and nail enhancements; Nail care services; Beauty spa services, namely, cosmetic body care.",
    "applicationDate": "2023-10-25",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98240418",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98740781",
    "country": "US",
    "markName": "FUTUREPROOF. A WISE EVENT.",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Conducting of conferences, congresses and symposiums in the field of executive management, organizational challenges, analytics and data for women and executive women in sports; Educational services, namely, conducting conferences and symposiums in the field of women in sports and distribution of course materials in connection therewith in printed or electronic format.",
    "applicationDate": "2024-09-09",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98740781",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "79264772",
    "country": "US",
    "markName": "EVAM EVENT & ACTION MANAGER",
    "status": "Live",
    "internationalClasses": [
      "9",
      "42"
    ],
    "goodsDescription": "IC 009: Measurement apparatus and equipment for testing and measuring radio frequency signals, concentrations of gas and liquids, audio signals including those for scientific, nautical, topographic, meteorologic, industrial and laboratory purposes; thermometers, not for medical purposes; barometers; ammeters; voltmeters; hygrometers; testing apparatus for testing radio frequency signals, concentrations of gas and liquids, audio signals not for medical purposes; telescopes; periscopes; directional compasses; speed indicators; laboratory apparatus, namely, microscopes, magnifying glasses, stills for scientific purposes, binoculars, ovens and furnaces for laboratory experiments; apparatus for recording, transmission or reproduction of sound or images, namely, cameras, photographic cameras, television apparatus for projection purposes, video recorders, CD and DVD players and recorders, MP3 players, computers, desktop computers, tablet computers, microphones, loudspeakers, earphones;...",
    "applicationDate": "2019-04-16",
    "registrationDate": "2020-02-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/79264772",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88936693",
    "country": "US",
    "markName": "PRICELESS EVENT PLANNING, LLC",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Event planning, namely, special event planning for social entertainment purposes; event design, namely, arranging special events for social entertainment purposes; wedding reception planning; wedding reception planning and coordination services; entertainment services in the nature of production of live events for parties and special events for social entertainment purposes.",
    "applicationDate": "2020-05-28",
    "registrationDate": "2023-12-26",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88936693",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98442818",
    "country": "US",
    "markName": "EIC SUSTAINABLE EVENT STANDARDS",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Professional standards and certification program, namely, evaluating organizations and the global business events industry to determine whether the organizations conform to an established accreditation standard for accelerating sustainability and social impact; Professional standards and certification program, namely, developing accreditation standards for organizations and the global business events industry regarding accelerating sustainability and social impact to the order and specification of others; Professional standards and certification program, namely, development of voluntary standards for accelerating sustainability and social impact in organizations and the global business events industry; Professional standards and certification program, namely, evaluation of the services of other organizations and the global business events industry to determine conformity with certification standards for accelerating sustainability and social impact.",
    "applicationDate": "2024-03-11",
    "registrationDate": "2025-03-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98442818",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90604964",
    "country": "US",
    "markName": "416 INTERIORS & EVENT VENUE",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Home inspection services for purposes of home repair and restoration; Home staging consultation, namely, temporary interior and exterior home decoration consultation for the purpose of making homes more appealing to prospective buyers; Interior decorating; Interior decoration consultation; Apartment, condominium and home staging services for the purpose of increasing the appeal of the property to prospective buyers and/or renters; Design of interior decor; Evaluation of the home building and remodeling services of home builders and remodelers to determine conformity with certification standards other than for governmental regulatory purposes during construction; Organizing a community charity event for professional home stagers to donate their staging services of making homes more appealing to prospective buyers to needy families and organizations; Organizing and conducting community charity staging events for professional home stagers to donate their staging services to...",
    "applicationDate": "2021-03-26",
    "registrationDate": "2022-05-31",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90604964",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88396184",
    "country": "US",
    "markName": "SJL 26 EVENT PRODUCTIONS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging, organizing, conducting, and hosting social entertainment events; Entertainment services in the nature of hosting social entertainment events; Organizing and hosting of events for cultural purposes; Special event planning for social entertainment purposes; Organizing culinary, food, and community festivals for cultural or entertainment purposes.",
    "applicationDate": "2019-04-22",
    "registrationDate": "2020-09-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88396184",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99061726",
    "country": "US",
    "markName": "JUMPONOVER TENT & EVENT RENTAL",
    "status": "Live",
    "internationalClasses": [
      "37",
      "41",
      "43"
    ],
    "goodsDescription": "IC 037: Installation of tents.; IC 041: Game equipment rental; rental of game machines and apparatus; rental of inflatable play yards in the nature of outdoor inflatable play structures, namely, structures for bouncing, sliding, climbing, and riding upon; game equipment rental, namely, rental of inflatable structures for sporting games; game equipment rental, namely, rental of inflatable structures for carnival games; rental of inflatable tunnels for parties; rental of inflatable obstacle courses for parties; rental of mechanical ride-on toy vehicles; rental of inflatable figures for use as outdoor decorations for parties; miniature golf courses; rental of party decorations.; IC 043: Rental of tents; rental of chairs and tables.",
    "applicationDate": "2025-02-28",
    "registrationDate": "2026-04-21",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99061726",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88831419",
    "country": "US",
    "markName": "IT TAKES 2 EVENT PLANNERS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Wedding and event planning, design and execution of weddings, birthday parties, bridal showers, bachelor parties, bachelorette parties, private parties, and events in the nature of special event planning for social entertainment purposes.",
    "applicationDate": "2020-03-12",
    "registrationDate": "2020-11-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88831419",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97143884",
    "country": "US",
    "markName": "THE EVENT COMPANY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: event production and consulting services, namely, event design, planning, and staging all in the nature of special event planning for social entertainment and fundraising purposes.",
    "applicationDate": "2021-11-26",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97143884",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97323406",
    "country": "US",
    "markName": "THE EVENT BAE",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Party and wedding reception planning and coordination services; Party and wedding reception planning consultation services; Party and wedding reception planning, coordination and consultation services; Party planning consultation; Providing information in the field of wedding party planning; Providing information regarding wedding reception planning for wedding parties.",
    "applicationDate": "2022-03-21",
    "registrationDate": "2023-09-26",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97323406",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97835174",
    "country": "US",
    "markName": "AMBITIOUS EVENT SPACE",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event planning for social entertainment purposes.",
    "applicationDate": "2023-03-13",
    "registrationDate": "2024-04-02",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97835174",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90887588",
    "country": "US",
    "markName": "ETHOS EVENT COLLECTIVE",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Conference event management services; Corporate event management services; Special event planning for business purposes.",
    "applicationDate": "2021-08-17",
    "registrationDate": "2023-03-14",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90887588",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90860595",
    "country": "US",
    "markName": "ELOQUETS EVENT ENTERPRISE",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging and conducting of training workshops in the field of event planning; Educational services, namely, conducting classes, seminars, conferences, workshops, retreats, camps and field trips in the field of event planning and distribution of training material in connection therewith; Providing on-line training webinars, workshops, and conferences in the field of event planning.",
    "applicationDate": "2021-08-02",
    "registrationDate": "2023-03-14",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90860595",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90444593",
    "country": "US",
    "markName": "ONE SMART EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Advertising, marketing, and promoting the goods and services of others via networking events.",
    "applicationDate": "2021-01-01",
    "registrationDate": "2022-06-14",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90444593",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98215875",
    "country": "US",
    "markName": "ADORN YOUR EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Rental of photo booths.",
    "applicationDate": "2023-10-09",
    "registrationDate": "2025-02-04",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98215875",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98222529",
    "country": "US",
    "markName": "MY EVENT PRODUCTS",
    "status": "Live",
    "internationalClasses": [
      "21"
    ],
    "goodsDescription": "IC 021: Plates; Napkin rings.",
    "applicationDate": "2023-10-13",
    "registrationDate": "2024-09-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98222529",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98406106",
    "country": "US",
    "markName": "THE GIFTED EVENT",
    "status": "Live",
    "internationalClasses": [
      "36"
    ],
    "goodsDescription": "IC 036: charitable fundraising services for barbing.",
    "applicationDate": "2024-02-14",
    "registrationDate": "2025-06-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98406106",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88619625",
    "country": "US",
    "markName": "HUTCH EVENT SERVICES",
    "status": "Live",
    "internationalClasses": [
      "44",
      "39"
    ],
    "goodsDescription": "IC 039: Private ambulance transportation.; IC 044: Standby medical for events.",
    "applicationDate": "2019-09-17",
    "registrationDate": "2020-05-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88619625",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90690847",
    "country": "US",
    "markName": "A BENNETT EVENT",
    "status": "Live",
    "internationalClasses": [
      "41",
      "42"
    ],
    "goodsDescription": "IC 041: Party planning.; IC 042: Custom design of party decorations, clothing, barware, and bags based on personal selections made by the customer.",
    "applicationDate": "2021-05-05",
    "registrationDate": "2022-08-09",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90690847",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97723765",
    "country": "US",
    "markName": "MAGNOLIA EVENT GROUP",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of chafing dishes; Rental of chairs and tables; Rental of chairs, tables, table linen, glassware; Rental of dining tables; Rental of dishes; Rental of furniture; Rental of hot plates; Rental of silverware; Rental of sofas; Rental of table linens; Rental of tableware; Rental of tableware, silverware, and dishes for special events; Rental of tents; Rental of lighting apparatus for decorating private residences.",
    "applicationDate": "2022-12-19",
    "registrationDate": "2024-07-02",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97723765",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85003704",
    "country": "US",
    "markName": "EVENT RENTAL SYSTEMS",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing temporary use of a web-based software application for providing an on-line database in the field of transaction processing to upload transactional data, provide statistical analysis, and produce notifications and reports; Providing temporary use of a web-based software application for on-line real-time rentals of equipment and services, automated marketing follow up correspondence and scheduling and routing of delivery vehicles for use by rental companies.",
    "applicationDate": "2010-03-31",
    "registrationDate": "2010-11-09",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85003704",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97939058",
    "country": "US",
    "markName": "ACTIVE EVENT SENSOR",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Digital sensor apparatus and devices, namely, digital image sensors and detectors for optical sensing and/or depth estimation and/or gaze tracking to detect and measure light and create modules and components for mobiles, wearables, glasses and/or headsets for extended reality (XR), augmented reality (AR), virtual reality (VR) and mixed reality (MR) and/or mobile industries; sensor systems, namely sensor systems comprising of at least one optical sensor comprising photodetectors to produce 3D point clouds, depth maps, splines or gaze vectors enabling devices and machines to understand, process and autonomously make decisions; sensors and detectors, namely, image sensors and detectors comprising photonic integrated circuits to detect and measure light and image or sense a scene and/or estimate the depth of points in the scene and/or estimate the point of gaze of the user used to create modules and components for mobiles, wearables, glasses and/or headsets for the extended...",
    "applicationDate": "2023-05-16",
    "registrationDate": "2025-07-22",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97939058",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86027301",
    "country": "US",
    "markName": "ROOFTOP EVENT SPOT",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of banquet and social function facilities for special occasions, namely, wedding receptions, reunions and corporate meetings.",
    "applicationDate": "2013-08-02",
    "registrationDate": "2014-09-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86027301",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86426728",
    "country": "US",
    "markName": "EVENT PROFIT SECRETS",
    "status": "Live",
    "internationalClasses": [
      "16",
      "41"
    ],
    "goodsDescription": "IC 016: [ [ Educational kits sold as a unit in the field of sales, lead generation, sales conversion, event management, and marketing consisting primarily of printed instructional materials in binders and workbooks and also including audio CDs and DVDs ] ].; IC 041: Training services in the field of sales, lead generation, sales conversion, event management, and marketing and distribution of electronic and physical course material in connection therewith; Business education and training services, namely, providing business education programs, telesummit education programs, sales coaching programs, and prospective customer generation programs to employees and executives and distribution of course material in connection therewith; Providing group coaching in the field of sales, lead generation, sales conversion, event management, and marketing and distribution of course material in connection therewith; Providing peer to peer coaching services in the field of lead generation, sales...",
    "applicationDate": "2014-10-17",
    "registrationDate": "2015-11-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86426728",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88351934",
    "country": "US",
    "markName": "THE BE EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, conducting conferences in the field of the well-being of women.",
    "applicationDate": "2019-03-22",
    "registrationDate": "2019-09-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88351934",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87936141",
    "country": "US",
    "markName": "PERFECT GOLF EVENT",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Providing on-line registration services for golf tournaments.; IC 041: Organizing, conducting and operating golf tournaments.",
    "applicationDate": "2018-05-25",
    "registrationDate": "2019-01-29",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87936141",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88395864",
    "country": "US",
    "markName": "TRAUMATIC EVENT SYSTEM",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, conducting classes, seminars, conferences, training sessions, and workshops in the fields of threat detection, violent threat detection, trauma response planning, threat intervention, risk assessment, and controlling the aftermath of a threat event and distribution of training materials in connection therewith; Personal training services, namely, strength and conditioning training for use in threat detection, violent threat detection, trauma response planning, threat intervention, risk assessment, and controlling the aftermath of a threat event; Education services, namely, training educators in the field of threat detection, violent threat detection, trauma response planning, threat intervention, risk assessment, and controlling the aftermath of a threat event, for purposes of training others; Consulting services about education and training, specifically relating to threat detection, violent threat detection, trauma response planning, threat...",
    "applicationDate": "2019-04-22",
    "registrationDate": "2019-12-03",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88395864",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87948065",
    "country": "US",
    "markName": "NOOK EVENT PODS",
    "status": "Live",
    "internationalClasses": [
      "19"
    ],
    "goodsDescription": "IC 019: Modular non-metal structures with flexible covers for meeting space; mobile non-metal structures used for meeting space; modular and mobile non-metal structures used for meeting space.",
    "applicationDate": "2018-06-04",
    "registrationDate": "2023-04-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87948065",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85366135",
    "country": "US",
    "markName": "DJ EVENT PLANNER",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Non-downloadable computer software for use in event planning and event management.",
    "applicationDate": "2011-07-08",
    "registrationDate": "2012-09-11",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85366135",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77425241",
    "country": "US",
    "markName": "GO OUTDOORS EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Retail store services featuring clothing, camping gear and accessories, hunting equipment and accessories, fishing tackle and accessories, boating supplies and accessories, and outdoor sporting goods.",
    "applicationDate": "2008-03-18",
    "registrationDate": "2009-03-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77425241",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "76146465",
    "country": "US",
    "markName": "THE EVENT DERBY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: entertainment services, namely, organizing and conducting horse competitions.",
    "applicationDate": "2000-10-13",
    "registrationDate": "2001-12-11",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/76146465",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86172045",
    "country": "US",
    "markName": "THE EVENT U",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Education services, namely, providing seminars, workshops and training in the field of corporate event planning.",
    "applicationDate": "2014-01-22",
    "registrationDate": "2014-12-09",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86172045",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86770418",
    "country": "US",
    "markName": "SEAMLESS EVENT SOLUTIONS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Rental of audio visual equipment.",
    "applicationDate": "2015-09-28",
    "registrationDate": "2016-06-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86770418",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99602359",
    "country": "US",
    "markName": "EVENT REVENUE ENGINE",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Software as a service (SaaS) featuring software for event revenue management,lead capture, contact qualification, data enrichment, analytics, and customerengagement..",
    "applicationDate": "2026-01-19",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99602359",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99138384",
    "country": "US",
    "markName": "CHARITY EVENT AWARDS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Organizing, arranging and conducting fundraising and community volunteer recognition events, the proceeds of which are donated to charity.",
    "applicationDate": "2025-04-15",
    "registrationDate": "2026-03-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99138384",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99329701",
    "country": "US",
    "markName": "EVENT KIOSK PRO",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Interactive computer kiosk systems comprised primarily of computers, computer hardware, computer peripherals, and computer touchscreens for use in event registration.",
    "applicationDate": "2025-08-10",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99329701",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98887221",
    "country": "US",
    "markName": "EPIC EVENT EXPERIENCES",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes.; IC 041: Consultation in the field of special event planning for social entertainment purposes; Special event planning for social entertainment purposes.",
    "applicationDate": "2024-12-05",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98887221",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97304205",
    "country": "US",
    "markName": "LEAP EVENT TECHNOLOGY",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Downloadable computer software in the field of live events, namely, computer software for managing ticketing and reservations, all of the aforesaid expressly excluding organizing, promoting, and conducting exhibitions, tradeshows, conferences and events in the field of retail technology.",
    "applicationDate": "2022-03-09",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97304205",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97342907",
    "country": "US",
    "markName": "GROOM'D PET GROOMING'S FAVORITE EVENT",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Arranging and conducting trade show exhibitions in the field of animals, animal care and animal hygiene products and services.; IC 041: Arranging and conducting exhibitions and shows for educational and entertainment purposes in the field of animals, animal care and animal hygiene products and services; arranging and conducting competitions in the field of animal care and animal hygiene products and services; arranging and conducting seminars and workshops in the fields of animal care and animal hygiene products and services.",
    "applicationDate": "2022-04-01",
    "registrationDate": "2024-04-02",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97342907",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88385123",
    "country": "US",
    "markName": "G IV DESIGNS & EVENT PLANNING",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Party planning of showers, celebrations, weddings; Special event planning for social entertainment purposes.",
    "applicationDate": "2019-04-14",
    "registrationDate": "2020-01-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88385123",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85383533",
    "country": "US",
    "markName": "TOTAL EVENT WEATHER INSURANCE PRIZE INDEMNITY EVENT CANCELLATION SPECIAL EVENT LIABILITY",
    "status": "Live",
    "internationalClasses": [
      "36"
    ],
    "goodsDescription": "IC 036: Insurance brokerage; insurance consultation; insurance claims administration; insurance underwriting, brokerage, consultation, and claims administration, all in the fields of specialty insurances covering risks including weather contingencies, prize indemnity and promotional insurance, event cancellation, and special event liability.",
    "applicationDate": "2011-07-28",
    "registrationDate": "2012-12-11",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85383533",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90225513",
    "country": "US",
    "markName": "BLUE BOX EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Online retail store services featuring a wide array of pet goods.",
    "applicationDate": "2020-09-30",
    "registrationDate": "2022-03-22",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90225513",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97876530",
    "country": "US",
    "markName": "MAGNOLIA EVENT GROUP",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of chafing dishes; Rental of chairs and tables; Rental of chairs, tables, table linen, glassware; Rental of dining tables; Rental of dishes; Rental of furniture; Rental of hot plates; Rental of lighting apparatus for decorating private residences; Rental of silverware; Rental of sofas; Rental of table linens; Rental of tableware; Rental of tents; Rental of electric hot plates; Rental of tableware, silverware, and dishes for special events; Rental of banquet and social function facilities for special occasions, namely, wedding receptions, wedding ceremonies, wedding parties; Rental of bar equipment; Rental of beverage fountains; Rental of carpet; Rental of drink dispensing machines; Rental of drinking water dispensers; Rental of electric chocolate fountains; Rental of food service equipment; Rental of kitchen worktops for preparing food for immediate consumption; Rental of portable desks; Rental of portable dressing rooms; Rental of water dispensers.",
    "applicationDate": "2023-04-06",
    "registrationDate": "2024-08-27",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97876530",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97143908",
    "country": "US",
    "markName": "THE EVENT COMPANY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: event production and consulting services, namely, event design, planning, and staging all in the nature of special event planning for social entertainment and fundraising purposes.",
    "applicationDate": "2021-11-26",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97143908",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97340453",
    "country": "US",
    "markName": "WHITE KNUCKLE EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment events, namely, organizing, arranging, conducting, and hosting festivals featuring off-road events and competitions, demo rides, trail rides, concerts, and social entertainment events; provision of facilities for off-road events and competitions, trail rides, concerts, and social entertainment events; Providing information regarding off-road events and recreation and leisure activities.",
    "applicationDate": "2022-03-31",
    "registrationDate": "2023-08-01",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97340453",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97026340",
    "country": "US",
    "markName": "MY EVENT FAVORITES",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: On-line wholesale and retail store services featuring Personalized Gifts, Customized Gifts, Custom Engraved Gifts, Personalized Glassware, Engraved Knives, Custom Flasks, Groomsmen Gifts, Wedding Gifts, Bridesmaid Gifts, Bride and Groom Gifts, Custom Weddings Favors, Holiday Gifts, Personalized Birthday Gifts, Custom Cutting Boards, Custom Wooden Boxes, Custom Home Decor, Personalized Decor, Custom Vinyl Gifts, Custom Picture Frames; Wholesale and retail store services featuring Personalized Gifts, Customized Gifts, Custom Engraved Gifts, Personalized Glassware, Engraved Knives, Custom Flasks, Groomsmen Gifts, Wedding Gifts, Bridesmaid Gifts, Bride and Groom Gifts, Custom Weddings Favors, Holiday Gifts, Personalized Birthday Gifts, Custom Cutting Boards, Custom Wooden Boxes, Custom Home Decor, Personalized Decor, Custom Vinyl Gifts, Custom Picture Frames.",
    "applicationDate": "2021-09-14",
    "registrationDate": "2022-11-22",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97026340",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90870468",
    "country": "US",
    "markName": "MARQUEE EVENT RENTALS",
    "status": "Live",
    "internationalClasses": [
      "41",
      "43",
      "37"
    ],
    "goodsDescription": "IC 037: Rental of leveled flooring systems and flooring support systems in the nature of portable flooring.; IC 041: Rental of staging equipment, namely, camera equipment, lighting equipment and grip equipment; rental of semi-permanent structures in the nature of entertainment halls; rental of dance floors; rental of hardwood floors, leveled flooring systems and flooring support systems, all of the foregoing for use as dance floors.; IC 043: Rental of table linens; rental of tableware, silverware, glassware, china, dishes, and table accessories for special events; rental of tables; rental of chairs; rental of tents and tent d\u00e9cor elements; rental of catering equipment for food preparation; rental of furniture; rental of lighting apparatus and electrical equipment for decorating and illuminating weddings, business events, and festivals; rental of carpeting.",
    "applicationDate": "2021-08-06",
    "registrationDate": "2023-01-31",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90870468",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97043668",
    "country": "US",
    "markName": "MEANINGFUL EVENT SCORE",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Analyzing and compiling business data for organizers of live meetings so that organizers may tailor the content and display of their meetings in a manner in order to maximize audience engagement and retention of such materials.",
    "applicationDate": "2021-09-24",
    "registrationDate": "2022-11-22",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97043668",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98013564",
    "country": "US",
    "markName": "ELEVATE YOUR EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services, namely, providing podcasts in the field of planning and executing fundraising events.",
    "applicationDate": "2023-05-25",
    "registrationDate": "2024-03-26",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98013564",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97382948",
    "country": "US",
    "markName": "YOUR EVENT SPACE",
    "status": "Live",
    "internationalClasses": [
      "35",
      "43"
    ],
    "goodsDescription": "IC 035: Business consultation services; Business marketing consultation services.; IC 043: Providing social function and banquet facilities; Providing temporary accommodation; Hotel services.",
    "applicationDate": "2022-04-26",
    "registrationDate": "2024-06-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97382948",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98291917",
    "country": "US",
    "markName": "NOLA EVENT PLANNERS",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Consultation in the field of special event planning in the nature of event production for business purposes; Consultation in the field of special event planning in the nature of event design for business purposes; Consultation in the field of special event planning for business purposes; Special event planning in the nature of event production for business purposes; Special event planning in the nature of event design for business purposes; Special event planning for business purposes.",
    "applicationDate": "2023-11-30",
    "registrationDate": "2025-04-08",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98291917",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90481608",
    "country": "US",
    "markName": "CE EVENT CHEF",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event planning for social entertainment purposes.",
    "applicationDate": "2021-01-22",
    "registrationDate": "2022-11-22",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90481608",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88764921",
    "country": "US",
    "markName": "EVENT PARKING BNB",
    "status": "Live",
    "internationalClasses": [
      "39"
    ],
    "goodsDescription": "IC 039: Parking garages services; parking lot services; parking place rental; parking space rental; parking space reservation service; aircraft parking; airport passenger shuttle services between the airport parking facilities and the airport; car parking; car rental, garage and parking space rental; providing a website featuring information about rv parking; providing a website featuring information on airport parking; providing aircraft parking; providing real-time information concerning vehicle parking space availability; provision of car parking facilities; rental of parking spaces; rental of car parking spaces; rental of mechanical parking systems; rental of vehicle parking spaces; reservation of parking spaces; travel demand management service, namely, providing customized driving instructions through use of an on-line parking reservation system; valet parking; vehicle parking; vehicle parking services relating to the availability of on-street and off-street parking spaces.",
    "applicationDate": "2020-01-18",
    "registrationDate": "2021-08-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88764921",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90015064",
    "country": "US",
    "markName": "SHINDIG MY EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services in the nature of arranging live music concerts.",
    "applicationDate": "2020-06-23",
    "registrationDate": "2021-09-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90015064",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90834793",
    "country": "US",
    "markName": "EVENT PLANNING BLUEPRINT",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Downloadable documents in the field of event planning provided via a website.",
    "applicationDate": "2021-07-18",
    "registrationDate": "2023-01-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90834793",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97566671",
    "country": "US",
    "markName": "LIVE DEMOLITION EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: arranging and conducting trade show exhibitions in the fields of demolition and demolition products and equipment; organization of exhibitions of demolition products and equipment for commercial or advertising purposes; product demonstration of demolition products and equipment.",
    "applicationDate": "2022-08-26",
    "registrationDate": "2024-01-23",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97566671",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "79302200",
    "country": "US",
    "markName": "EVENT-BASED VISION",
    "status": "Live",
    "internationalClasses": [
      "9",
      "10",
      "42"
    ],
    "goodsDescription": "IC 009: Electronic sensors asynchronously detecting pixel luminance changes; electronic position change detection sensors; electronic speed detection sensors; electronic distance measurement sensors; electronic image sensors; electronic sensors for controlling displacement; electronic positioning detectors; electronic image processing detectors; electronic sensors for detecting vibrations; electronic sensors in combination with a laser for three dimensional detection and imaging use; electronic sensors asynchronously detecting pixel luminance changes hybridized or in combination with a conventional electronic sensor; electronic sensors asynchronously detecting pixel luminance changes hybridized or in combination with an infrared detector for detecting luminance changes in infrared wavelength; computers for processing signals and/or images for artificial vision; recorded software for processing signals and/or images for artificial vision; recorded programs for signal and/or image...",
    "applicationDate": "2020-10-12",
    "registrationDate": "2022-03-22",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/79302200",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "79345229",
    "country": "US",
    "markName": "THE BOSTON EVENT",
    "status": "Live",
    "internationalClasses": [
      "38",
      "9",
      "41",
      "42"
    ],
    "goodsDescription": "IC 009: Downloadable software in the nature of a mobile application for provision of information relating to science; downloadable software in the nature of a mobile application providing access to non-fungible tokens, merchandise and electronic publications relating to science; downloadable computer software for processing digital images; downloadable electronic publications in the nature of e-books in the field of science; audio and video recordings featuring subject matter relating to science; downloadable video recordings featuring scientific events authenticated by non-fungible tokens (NFTs); motion picture films about scientific events; downloadable image files containing images of scientific events authenticated by non-fungible tokens (NFTs); downloadable multimedia file containing artwork, text, audio, and video relating to scientific events authenticated by non-fungible tokens (NFTs).; IC 038: Electronic, electric, and digital transmission of voice, data, images, signals, and...",
    "applicationDate": "2022-04-26",
    "registrationDate": "2023-10-03",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/79345229",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77500078",
    "country": "US",
    "markName": "THE EVENT MECHANIC!",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Arranging and conducting business conferences; Arranging and conducting marketing promotional events for others; Arranging and conducting of fairs and exhibitions for business and advertising purposes; Business consultation in the field of strategic and operational planning for business events, conferences, trade shows, and expositions; Business information in the field of strategic and operational planning for business events, conferences, trade shows, and expositions; Business management and consultation in the field of strategic and operational planning for business events, conferences, trade shows, and expositions; Business marketing consulting services; Business meeting planning.",
    "applicationDate": "2008-06-16",
    "registrationDate": "2009-02-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77500078",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88595600",
    "country": "US",
    "markName": "PRE-EVENT DRIVEN",
    "status": "Live",
    "internationalClasses": [
      "36"
    ],
    "goodsDescription": "IC 036: Financial services, namely, investment advice, investment management, investment consultation and investment of funds for others, including private and public equity and debt investment services; Financial and investment services, namely, asset and investment acquisition, consultation, advisory and development; Financial planning and investment advisory services; Providing financial services with respect to securities and other financial instruments and products, namely, trading of and investments in securities and financial instruments and products for others.",
    "applicationDate": "2019-08-28",
    "registrationDate": "2020-11-03",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88595600",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86162891",
    "country": "US",
    "markName": "STRATEGIC EVENT ASSESSMENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Advertising and marketing consultancy; Arranging and conducting business conferences; [ Brand imagery consulting services; Branding services, namely, consulting, development, management and marketing of brands for businesses and/or individuals; ] Business consulting and information services; Business consulting services, namely, providing assistance in development of business strategies and creative ideation; Event planning and management for marketing, branding, promoting or advertising the goods and services of others; Organizing, promoting and conducting exhibitions, tradeshows and events for business purposes; Preparation and realization of media and advertising plans and concepts; Promotional marketing services using audiovisual media.",
    "applicationDate": "2014-01-10",
    "registrationDate": "2014-07-01",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86162891",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87513522",
    "country": "US",
    "markName": "GONZABA EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational and entertainment services for seniors, namely, providing programs featuring recreational activities, instructional classes in the field of physical and mental health and social gatherings for seniors.",
    "applicationDate": "2017-06-30",
    "registrationDate": "2017-12-05",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87513522",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "74665177",
    "country": "US",
    "markName": "EVENT CONTROL SERVER",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: computer software for use in scheduling and managing computer jobs.",
    "applicationDate": "1995-04-24",
    "registrationDate": "1996-07-16",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/74665177",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98741665",
    "country": "US",
    "markName": "HONEST EVENT RENTALS",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of tableware, silverware, and dishes for special events.",
    "applicationDate": "2024-09-09",
    "registrationDate": "2025-09-09",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98741665",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87911666",
    "country": "US",
    "markName": "MAIN EVENT USA",
    "status": "Live",
    "internationalClasses": [
      "20"
    ],
    "goodsDescription": "IC 020: plastic and wooden signboards, namely, letter boards.",
    "applicationDate": "2018-05-08",
    "registrationDate": "2019-01-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87911666",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88367505",
    "country": "US",
    "markName": "REGAL EVENT SOLUTIONS",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Arranging and organizing corporate events, namely, business meetings, business conferences, team building events for business purposes, business meet-up events, product launches for promotional purposes, and business grand openings for commercial or promotional purposes.; IC 041: Entertainment services in the field of arranging and organizing events for personal social entertainment purposes, namely, bridal parties, wedding receptions, baby showers, birthday parties, anniversary parties, graduations, and family gatherings; Entertainment services, namely, consultation in the field of special event planning for social entertainment purposes.",
    "applicationDate": "2019-04-02",
    "registrationDate": "2019-12-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88367505",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99023363",
    "country": "US",
    "markName": "EVENT DAY BONUS",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes; Special event planning for commercial, promotional or advertising purposes; Marketing, advertising, and promoting the retail goods and services of others through wireless electronic devices; Promoting the goods and services of others; Promoting the goods and services of others by arranging for businesses to affiliate their goods and services with the goods and services of third parties by means of sponsorship relationships; Development of marketing strategies, concepts and tactics, namely, audience development, brand awareness, online community building and digital word of mouth communications; Advertising and marketing consultancy; Advertising and marketing services, namely, promoting the goods and services of others; Marketing services, namely, promoting or advertising the goods and services of others.",
    "applicationDate": "2025-01-30",
    "registrationDate": "2025-10-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99023363",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99028100",
    "country": "US",
    "markName": "THE EVENT NERD",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Conference event management services; Corporate event management services.; IC 041: Event management services being organizing and conducting cultural events; Entertainment services in the nature of arranging social entertainment events; Entertainment services in the nature of production of live events for parties and special events for social entertainment purposes; Arranging and conducting of conferences and symposia in the field of medical science; Consultancy relating to arranging and conducting of conferences; Organization of ethnic festivals for cultural or entertainment purposes; Organizing and conducting festivals in the field of music for cultural or entertainment purposes; Educational and entertainment services, namely, providing motivational speaking services in the field of events and culture.",
    "applicationDate": "2025-02-04",
    "registrationDate": "2025-10-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99028100",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97754292",
    "country": "US",
    "markName": "THE STORYBOOK EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging, organizing, conducting, and hosting social entertainment events; Organization of entertainment exhibition events; Organizing and hosting of events for cultural purposes; Party and wedding reception planning, coordination and consultation services; Providing information in the field of wedding party planning.",
    "applicationDate": "2023-01-13",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97754292",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77136224",
    "country": "US",
    "markName": "EVENT SHOW PRODUCTIONS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Event and entertainment services, namely, providing professional actors, dancers, singers, impersonators, specialty acts, motivational emcees, costumed characters, and sound and lighting for corporate theme parties, sales and marketing meetings, tradeshows, award programs, public events and social galas.",
    "applicationDate": "2007-03-21",
    "registrationDate": "2007-10-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77136224",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78155386",
    "country": "US",
    "markName": "THE EGYPTIAN EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: EDUCATIONAL AND ENTERTAINMENT SERVICES; NAMELY, ORGANIZING AND CONDUCTING AN ANNUAL ARABIAN HORSE SHOW.",
    "applicationDate": "2002-08-19",
    "registrationDate": "2004-10-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78155386",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86390798",
    "country": "US",
    "markName": "NATIONAL EVENT SERVICES",
    "status": "Live",
    "internationalClasses": [
      "37",
      "35",
      "39",
      "44"
    ],
    "goodsDescription": "IC 035: Rental of ticket booths; rental of co-working facilities in the nature of field offices equipped with office equipment.; IC 037: Rental of metal and non-metal fences and related equipment, namely panels, barricades, gates, windscreens, top rails, and barbed wire.; IC 039: Rental of Storage Containers.; IC 044: Rental of portable restrooms and toilet tanks for trailers; rental of portable sinks with hot and cold water reservoirs.",
    "applicationDate": "2014-09-10",
    "registrationDate": "2015-04-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86390798",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85507802",
    "country": "US",
    "markName": "A DIVINE EVENT",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Catering services.",
    "applicationDate": "2012-01-03",
    "registrationDate": "2012-08-21",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85507802",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87298684",
    "country": "US",
    "markName": "PEAK EVENT SERVICES",
    "status": "Live",
    "internationalClasses": [
      "43",
      "40",
      "41"
    ],
    "goodsDescription": "IC 040: Rental of temperature control apparatus.; IC 041: Rental of portable dance floors, portable stages and event lighting, all for event and party services, conventions, meetings, trade shows, and non-theatrical special events.; IC 043: Rental or supply of catering equipment including food service equipment, bar equipment, china and linen, all for event and party services, conventions, meetings, trade shows, and non-theatrical special events; Rental or supply of tents, canopies and other temporary structures, lighting, furniture including tables and chairs, all for event and party services, conventions, meetings, trade shows, and non-theatrical special events.",
    "applicationDate": "2017-01-12",
    "registrationDate": "2018-03-20",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87298684",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97979085",
    "country": "US",
    "markName": "LEAP EVENT TECHNOLOGY",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing online, non-downloadable computer software in the field of live events, namely, computer software for managing ticketing and reservations, all of the aforesaid expressly excluding organizing, promoting, and conducting exhibitions, tradeshows, conferences and events in the field of retail technology.",
    "applicationDate": "2022-03-09",
    "registrationDate": "2025-01-21",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97979085",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99222373",
    "country": "US",
    "markName": "EVENT SAFETY FUND",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Providing funding and support for charitable, educational, and scientific activities.",
    "applicationDate": "2025-06-06",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99222373",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99166980",
    "country": "US",
    "markName": "LOVA EVENT DESIGN",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Event management services being organizing and conducting cultural events; Event management services being organizing and conducting special events for social entertainment purposes; Party and wedding reception planning, coordination and consultation services; Wedding reception planning and coordination consultation services; Wedding reception planning and coordination services; Party and wedding reception planning and coordination services; Providing information in the field of wedding party planning; Arranging, organizing, conducting and hosting birthday parties; Providing information regarding wedding reception planning for wedding parties; Party and wedding reception planning consultation services; Special event planning for social entertainment purposes; Entertainment services in the nature of organizing social entertainment events; Entertainment services in the nature of arranging social entertainment events; Entertainment services in the nature of hosting social...",
    "applicationDate": "2025-05-15",
    "registrationDate": "2026-01-27",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99166980",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97939358",
    "country": "US",
    "markName": "CSC EVENT STAFF",
    "status": "Live",
    "internationalClasses": [
      "45"
    ],
    "goodsDescription": "IC 045: SECURITY SERVICES, namely, PROVIDING SECURITY GUARDS, SECURITY PERSONNEL AND ARMED ESCORTS FOR PROVIDING CROWD MANAGEMENT AT VARIOUS SPORTING AND ENTERTAINMENT EVENTS WHICH ARE HELD AT ARENAS, CONVENTION CENTERS, STADIUMS, SPEEDWAYS AND AMPHITHEATERS NATIONWIDE.",
    "applicationDate": "2023-05-16",
    "registrationDate": "2024-09-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97939358",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97162839",
    "country": "US",
    "markName": "TOTAL EVENT PROGRAM",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Platform as a service featuring computer software platform which allows event organizers to manage and analyze in-person, virtual, hybrid and on-demand events, as well as allowing attendees at in-person, virtual, and hybrid events to create and modify appointments, schedules and agendas, check-in and provide feedback, and allowing vendors at in-person, virtual, and hybrid events to manage sponsorships, exhibitor listings, leads and schedules and obtain event information; providing temporary use of non-downloadable software that allows event organizers to manage and analyze in-person, virtual, hybrid and on-demand events, as well as allowing attendees at in-person, virtual, and hybrid events to create and modify appointments, schedules and agendas, check-in and provide feedback, and allowing vendors at in-person, virtual, and hybrid events to manage sponsorships, exhibitor listings, leads and schedules and obtain event information.",
    "applicationDate": "2021-12-08",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97162839",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86513263",
    "country": "US",
    "markName": "ENCORE EVENT TECHNOLOGIES",
    "status": "Live",
    "internationalClasses": [
      "38",
      "41",
      "42",
      "35"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes; planning and conducting of trade fairs, exhibitions and presentations for economic or advertising purposes; business meeting planning.; IC 038: Providing an on-line forum for companies to showcase, display, demonstrate and promote new and innovative ideas, products and services in the hospitality industry.; IC 041: Providing audio and visual production services, namely, audio production and video production to attendees and guests at conferences and convention centers; special event planning to attendees and guests for social purposes.; IC 042: Design and development of trade show exhibits and visual displays for conventions, trade shows and marketing centers; consulting services related to the design and development of trade show exhibits and visual displays for conventions, trade shows and marketing centers.",
    "applicationDate": "2015-01-24",
    "registrationDate": "2015-09-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86513263",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98544805",
    "country": "US",
    "markName": "THE MULTIPLY EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, providing live, virtual events, namely, classes in the fields of direct sales education, business development, personal development, leadership coaching, direct sales coaching, mindset work, and entrepreneurial training.",
    "applicationDate": "2024-05-10",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98544805",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87073390",
    "country": "US",
    "markName": "AMPHITHEATRE EVENT FACILITY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging and conducting nightclub entertainment events; nightclub services; Arranging and conducting nightclub parties; dance club services.",
    "applicationDate": "2016-06-16",
    "registrationDate": "2017-02-21",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87073390",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99729624",
    "country": "US",
    "markName": "USED EVENT STUFF",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Provision of an on-line marketplace for buyers and sellers of used event equipment, including tables, chairs, decorations, lighting, audio/visual equipment, and other event-related goods; Retail store services featuring used event equipment; business management and administration services in connection with the operation of an online store and marketplace for event products.",
    "applicationDate": "2026-03-27",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99729624",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99432652",
    "country": "US",
    "markName": "EPIC EVENT PRINTS",
    "status": "Live",
    "internationalClasses": [
      "30",
      "40",
      "41"
    ],
    "goodsDescription": "IC 030: Candy-coated apples; Bakery desserts; Bakery goods and dessert items, namely, cakes, cookies, pastries, candies, and frozen confections for retail and wholesale distribution and consumption on or off the premises; Bakery goods and dessert items, namely, cheesecakes for retail and wholesale distribution and consumption on or off the premises.; IC 040: Printing; Printing services; Bindery services for others, namely, collating, folding, stapling, perforating, cutting and binding of printed materials; Bindery services for others, namely, collating, folding, stapling, perforating, cutting and binding of printed, photocopied and typewritten materials; Design printing for others; Digital photo printing services; Direct-to-garment printing services; Dye-sublimation printing services; Imprinting messages on T-shirts; Imprinting messages on wearing apparel and mugs; Imprinting of decorative designs on T-shirts; Inkjet printing services; Portrait printing; Silk screen printing.; IC 041:...",
    "applicationDate": "2025-10-08",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99432652",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85951917",
    "country": "US",
    "markName": "ORIGIN EVENT PLANNING",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Arranging and conducting marketing promotional events for others; Business marketing services; Logistics management in the field of event planning; Special event planning for business purposes.",
    "applicationDate": "2013-06-05",
    "registrationDate": "2016-07-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85951917",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88635657",
    "country": "US",
    "markName": "COASTAL EVENT SOLUTIONS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Rental of audiovisual equipment.",
    "applicationDate": "2019-09-30",
    "registrationDate": "2021-04-27",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88635657",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77537763",
    "country": "US",
    "markName": "CERTIFIED EVENT DECORATOR",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Accreditation services, namely, developing, evaluating, and testing standards for event decorating professionals for the purpose of accreditation.",
    "applicationDate": "2008-08-03",
    "registrationDate": "2009-04-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77537763",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97844503",
    "country": "US",
    "markName": "LOTUS EVENT MANAGEMENT",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes.; IC 041: Special event planning for social entertainment purposes.",
    "applicationDate": "2023-03-17",
    "registrationDate": "2024-06-11",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97844503",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97781497",
    "country": "US",
    "markName": "SMART EVENT ACADEMY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Providing on-line training courses and information in the field of event project management.",
    "applicationDate": "2023-02-05",
    "registrationDate": "2024-08-06",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97781497",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88635660",
    "country": "US",
    "markName": "COASTAL EVENT SOLUTIONS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Rental of audiovisual equipment.",
    "applicationDate": "2019-09-30",
    "registrationDate": "2021-07-13",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88635660",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88639263",
    "country": "US",
    "markName": "AMERICA'S TRUCK EVENT",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Arranging and conducting special events for commercial, promotional and advertising purposes.; IC 041: Organizing, arranging and conducting annual car and truck shows, auto racing, exhibitions, contests and special events for entertainment services.",
    "applicationDate": "2019-10-02",
    "registrationDate": "2021-06-01",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88639263",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98429874",
    "country": "US",
    "markName": "ARION EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of conference rooms, rental of facilities for exhibitions; Rental of banquet and social function facilities for special occasions, namely, wedding receptions, birthday parties, and corporate events; Rental of hall and meeting rooms for social gatherings, business meetings, and community events; Catering services.",
    "applicationDate": "2024-03-01",
    "registrationDate": "2024-12-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98429874",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "76666244",
    "country": "US",
    "markName": "THE RUNNING EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Arranging and Conducting Trade Show Exhibitions and Conferences in the field of running.",
    "applicationDate": "2006-09-18",
    "registrationDate": "2007-07-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/76666244",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97596206",
    "country": "US",
    "markName": "ELITE EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Catering; Catering services; Food preparation services; Catering services for the provision of food and drink; Catering services for weddings; Catering services for indoor events; Hospitality services in the nature of provision of food and drink; Providing banquet and social function facilities for special occasions; Providing general purpose facilities for business conferences, trade shows, exhibitions; Providing general purpose facilities for wedding receptions, conferences, birthday parties, social events and gatherings, business events and meetings, ceremonies, and parties; Providing social meeting, banquet and social function facilities; Rental of conference rooms; Rental of banquet and social function facilities for special occasions, namely, wedding receptions, conferences, birthday parties, social events and gatherings, business events and meetings, ceremonies, and parties.",
    "applicationDate": "2022-09-18",
    "registrationDate": "2024-01-23",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97596206",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "75323196",
    "country": "US",
    "markName": "THE MEGA EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: promoting charitable fund raising participation through the administration of incentive award programs.",
    "applicationDate": "1997-07-11",
    "registrationDate": "1998-08-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/75323196",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98675416",
    "country": "US",
    "markName": "EMERGE EVENT COLLECTIVE",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: General business networking referral services, namely, promoting the goods and services of others by passing business leads and referrals among group members; Organizing business networking events in the field of wedding and event planning.",
    "applicationDate": "2024-07-31",
    "registrationDate": "2025-07-01",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98675416",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98345360",
    "country": "US",
    "markName": "THE EVENT ROAMER",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Portable photo booths.",
    "applicationDate": "2024-01-06",
    "registrationDate": "2025-07-22",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98345360",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85561708",
    "country": "US",
    "markName": "THE PINK EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Arranging and conducting marketing promotional events for others; Arranging and conducting special events for business purposes; Arranging and conducting special events for commercial, promotional or advertising purposes; Organizing, promoting and conducting exhibitions, tradeshows and events for business purposes.",
    "applicationDate": "2012-03-06",
    "registrationDate": "2012-10-09",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85561708",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88588954",
    "country": "US",
    "markName": "NATIONAL EVENT MEDICS",
    "status": "Live",
    "internationalClasses": [
      "44"
    ],
    "goodsDescription": "IC 044: On-site medic services.",
    "applicationDate": "2019-08-22",
    "registrationDate": "2020-07-21",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88588954",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90709321",
    "country": "US",
    "markName": "BRILLIANT EVENT PLANNING",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Wedding reception planning and coordination consultation services; Wedding reception planning and coordination services; Consultation in the field of special event planning for social entertainment purposes; Party planning of marriage proposals, engagement parties, bridal showers, bachelor and bachelorette parties, destination weddings, baby showers, kids parties, birthday parties, anniversary parties, and retirement parties; Party and wedding reception planning and coordination services; Party and wedding reception planning consultation services; Party and wedding reception planning, coordination and consultation services; Providing information in the field of wedding party planning; Special event planning for social entertainment purposes.",
    "applicationDate": "2021-05-13",
    "registrationDate": "2022-05-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90709321",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97171865",
    "country": "US",
    "markName": "THE GAME EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services, namely, production and distribution of a game show; Entertainment services, namely, providing podcasts in the field of game shows; Entertainment services, namely, providing video podcasts in the field of game shows; Entertainment services, namely, providing webcasts in the field of game shows.",
    "applicationDate": "2021-12-14",
    "registrationDate": "2022-11-22",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97171865",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97261904",
    "country": "US",
    "markName": "BOSTON EVENT LIGHTING",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment, namely, lighting production.",
    "applicationDate": "2022-02-10",
    "registrationDate": "2023-03-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97261904",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97269368",
    "country": "US",
    "markName": "TIMED EVENT CHAMPIONSHIP",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services, namely, arranging and conducting of competitions in the field of rodeo events.",
    "applicationDate": "2022-02-16",
    "registrationDate": "2024-03-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97269368",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98259286",
    "country": "US",
    "markName": "BOSTON EVENT GUIDE",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Providing a searchable online advertising website and informational guide featuring the goods and services of other vendors via the internet in the field of events, destinations, dining, accommodations, and points of interest in the Boston area.",
    "applicationDate": "2023-11-07",
    "registrationDate": "2024-10-22",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98259286",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97577843",
    "country": "US",
    "markName": "POPPED EVENT PLANNING",
    "status": "Live",
    "internationalClasses": [
      "41",
      "35"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes, namely, event planning and coordination services for corporate events.; IC 041: Event planning for social entertainment purposes, namely, wedding related events, bridal showers, bachelor parties, bachelorette parties, gender reveal parties, baby showers, birthday parties, anniversary parties, wedding receptions, and special social entertainment events; party and event planning and coordination services for\u00a0conferences and training events.",
    "applicationDate": "2022-09-03",
    "registrationDate": "2024-03-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97577843",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97653216",
    "country": "US",
    "markName": "EVENT DECOR DIRECT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Wholesale and retail store services and on-line retail and wholesale store services featuring event decorations and wedding supplies.",
    "applicationDate": "2022-10-28",
    "registrationDate": "2024-01-23",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97653216",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87390123",
    "country": "US",
    "markName": "EL EVENT LINENS",
    "status": "Live",
    "internationalClasses": [
      "24"
    ],
    "goodsDescription": "IC 024: Dining linens; Fabric table runners; Table linen; Table linen of textile; Table linen, not of paper.",
    "applicationDate": "2017-03-29",
    "registrationDate": "2017-11-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87390123",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87728722",
    "country": "US",
    "markName": "NORTHWEST EVENT TECHNOLOGY",
    "status": "Live",
    "internationalClasses": [
      "42",
      "37"
    ],
    "goodsDescription": "IC 037: Installation of lighting, sound systems, and scenic elements being scenery at trade shows and theatrical and presentation events; consulting services in the field of lighting for live staged events for business purposes, namely, corporate events, trade shows, and conferences; consulting services in the field of providing scenic elements being scenery for special events; technical consultation in the field of installation of lighting apparatus, lighting instruments and lighting systems, namely, lighting design and technology specification services pertaining to temporary use of lighting systems and lighting control for live events being corporate events, trade shows and conferences; technical consultation in the field of visual design services, namely, multidisciplinary visual design services pertaining to temporary scenic elements and digital displays being scenery for live events, being corporate events, trade shows and conferences.; IC 042: Consulting services in the field of...",
    "applicationDate": "2017-12-20",
    "registrationDate": "2018-12-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87728722",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86785083",
    "country": "US",
    "markName": "GORGEOUS HAIR EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Retail stores featuring health and beauty aids, perfumes, jewelry, watches and pharmaceuticals.",
    "applicationDate": "2015-10-12",
    "registrationDate": "2016-05-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86785083",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98386923",
    "country": "US",
    "markName": "MPE EVENT GROUP",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services, namely, providing live performances by musical performers and disk jockeys; Disk jockey services, namely, disk jockey services for weddings; Entertainment multimedia production services, namely, audio, video, and lighting production and projection services for live events; Entertainment multimedia production services, namely, providing technical audio, lighting, video projection and production services for live events; Audio visual services for live and virtual events, namely, sound engineering, video production services, video projection, and videography; Private and commercial event audio and video production, special event planning consultation for social entertainment purposes, event management being organizing and conducting cultural events, and special event planning services for social entertainment purposes; Photo booth services, namely, renting photo booth for live events.",
    "applicationDate": "2024-02-01",
    "registrationDate": "2024-12-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98386923",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88035336",
    "country": "US",
    "markName": "PINK BAG EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: charitable services, namely, organizing events for the coordination of the distribution of donations from retail businesses to breast cancer patients, survivors, and their families as well as the general public in need of breast health and cancer education.",
    "applicationDate": "2018-07-12",
    "registrationDate": "2019-07-09",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88035336",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98512155",
    "country": "US",
    "markName": "NBE EVENT GROUP",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services in the nature of production of live events, namely, audio, video, lighting, staging, trussing and rigging, and technical staff for parties and special events; Arranging, organizing, conducting, and hosting social entertainment events; Events planning, including event design, for special occasions such as social events; Entertainment in the nature of photo booth services; Entertainment in the nature of event disc jockey and master of ceremonies; Photography services; Media production services, namely, video and film production; Rental services for audio and video equipment, audiovisual and lighting apparatus for events.",
    "applicationDate": "2024-04-22",
    "registrationDate": "2025-08-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98512155",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98127151",
    "country": "US",
    "markName": "COUPLE'S ONENESS EVENT",
    "status": "Live",
    "internationalClasses": [
      "45"
    ],
    "goodsDescription": "IC 045: Religious and spiritual services, namely, conducting religious worship, marriage ceremonies, baptismal ceremonies, baby dedications, bereavement ceremonies, and religious counseling; Religious and spiritual services, namely, providing gatherings and retreats to develop and enhance the spiritual lives of individuals; Providing religious counseling services.",
    "applicationDate": "2023-08-10",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98127151",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98088494",
    "country": "US",
    "markName": "THE MAINE EVENT",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Hospitality services in the nature of provision of temporary accommodation..",
    "applicationDate": "2023-07-17",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98088494",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88510450",
    "country": "US",
    "markName": "CO MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "38",
      "41",
      "9"
    ],
    "goodsDescription": "IC 009: Downloadable podcasts in the field of mixed martial arts.; IC 038: Podcasting services.; IC 041: Providing news and information in the field of sports; Providing sports news; Providing sports news and information in the field of mixed martial arts; Providing an Internet sports news portal featuring links to sports news stories and articles in the field of sports; Providing an Internet website portal featuring entertainment news and information specifically in the field of mixed martial arts; Entertainment services, namely, providing podcasts in the field of mixed martial arts; Entertainment services, namely, providing video podcasts in the field of mixed martial arts.",
    "applicationDate": "2019-07-11",
    "registrationDate": "2020-03-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88510450",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88591779",
    "country": "US",
    "markName": "NATIONAL COLOR EVENT",
    "status": "Live",
    "internationalClasses": [
      "44"
    ],
    "goodsDescription": "IC 044: Beauty salons; beauty salon services; hair colouring services; hair cutting services; hair salon services, namely, hair cutting, hair styling, coloring, and hair extension services.",
    "applicationDate": "2019-08-25",
    "registrationDate": "2020-08-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88591779",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99367596",
    "country": "US",
    "markName": "ROYAL EVENT RENTALS",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of tableware, silverware, and dishes for special events; Rental of table linens; Rental of furniture, linen, table settings and equipment for the provision of food and beverages; Rental of furniture, linen, table settings and equipment for the provision of food and drink; Rental of furniture, table linen, table settings and equipment for the provision of food and beverages; Rental of furniture, table linen, table settings and equipment for the provision of food and drink; Rental of chairs, tables, table linen, glassware; Rental of table linen; Rental of furniture; Indoor furniture rental services; Rental of bar furniture; Rental of table cutlery; Dining table rental services; Rental of dining tables; Rental of chairs and tables; Rental of chafing dishes; Rental of blankets; Rental of pillows; Rental of bar equipment; Rental of banquet and social function facilities for special occasions, namely, weddings, wedding receptions, parties and corporate events; Rental of...",
    "applicationDate": "2025-08-31",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99367596",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99204046",
    "country": "US",
    "markName": "COLORADO EVENT COLLECTIVE",
    "status": "Live",
    "internationalClasses": [
      "41",
      "43"
    ],
    "goodsDescription": "IC 041: Party and wedding reception planning and coordination services.; IC 043: Rental of chairs and tables; Rental of tableware; Rental of silverware; Rental of table linens; Rental of furniture, linen, table settings and equipment for the provision of food and beverages.",
    "applicationDate": "2025-05-27",
    "registrationDate": "2026-01-13",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99204046",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90587580",
    "country": "US",
    "markName": "LAUGHLIN EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services, namely, entertainment ticket agency services and entertainment information services; Providing facilities for live music, theater, comedy, acrobatic, and dance shows; Providing facilities for rodeos, off road racing, and Xtreme sports; Organizing and conducting entertainment festivals featuring a variety of live entertainment activities in the nature of live music and cultural activities; Rental of arena facilities; Providing of websites featuring information in the field of sports, entertainment and arena rental.",
    "applicationDate": "2021-03-18",
    "registrationDate": "2022-02-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90587580",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90587612",
    "country": "US",
    "markName": "LAUGHLIN EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services, namely, entertainment ticket agency services and entertainment information services; Providing facilities for live music, theater, comedy, acrobatic, and dance shows; Providing facilities for rodeos, off road racing, and Xtreme sports; Organizing and conducting performing arts entertainment festivals featuring a variety of live entertainment activities in the nature of live music and cultural activities; Rental of arena facilities for entertainment purposes; Providing of websites featuring information in the field of sports, entertainment and arena rental for entertainment and sports events.",
    "applicationDate": "2021-03-18",
    "registrationDate": "2022-09-06",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90587612",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90587620",
    "country": "US",
    "markName": "LAUGHLIN EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Arena services, namely, providing general-purpose facilities for sports, concerts and exhibitions.",
    "applicationDate": "2021-03-18",
    "registrationDate": "2022-08-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90587620",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99656059",
    "country": "US",
    "markName": "GABRO EVENT SERVICES",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of furniture, linen, table settings and equipment for the provision of food and beverages; Rental of tents; Rental of curtains for hotels; Rental of furniture; Rental of hospitality furniture; Rental of bar furniture; Rental of furniture for hotels; Indoor furniture rental services; Rental of display stand furniture; Rental of office furniture in co-working facilities; Rental of furniture, linen, table settings and equipment for the provision of food and drink; Rental of furniture, table linen, table settings and equipment for the provision of food and beverages; Rental of furniture, table linen, table settings and equipment for the provision of food and drink; Rental of lighting apparatus for decorating private residences; Rental and leasing of lighting apparatus and lighting systems for use in municipality lighting and public events.",
    "applicationDate": "2026-02-17",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99656059",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99319035",
    "country": "US",
    "markName": "RENT FOR EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services in the nature of production of live events for parties and special events for social entertainment purposes.",
    "applicationDate": "2025-08-04",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99319035",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99521326",
    "country": "US",
    "markName": "EVENT BUILDERS ACADEMY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Education services, namely, one-on-one mentoring in the field of entrepreneurship, financial literacy, nonprofit organizations, fundraisers, and sponsorships; Education services, namely, one-on-one mentoring in the field of entrepreneurship, financial literacy, nonprofit organizations, fundraisers, and sponsorships.; Education in the fields of entrepreneurship, financial literacy, nonprofit organizations, fundraisers, and sponsorships. rendered through correspondence courses; Educational services, namely, conducting seminars, lectures, teleseminars, teleclasses, and workshops in personal awareness; Providing education courses in the field of entrepreneurship, financial literacy, nonprofit organizations, fundraisers, and sponsorships offered through online, non-downloadable videos and instructor assistance; Educational services, namely, conducting informal on-line programs in the fields of entrepreneurship, financial literacy, nonprofit organizations, fundraisers, and...",
    "applicationDate": "2025-11-29",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99521326",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98782468",
    "country": "US",
    "markName": "DISTINCTIVE EVENT SOLUTIONS",
    "status": "Live",
    "internationalClasses": [
      "41",
      "42"
    ],
    "goodsDescription": "IC 041: Rental of audiovisual equipment.; IC 042: Technological planning and consulting services in the field of audiovisual equipment.",
    "applicationDate": "2024-10-02",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98782468",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99732903",
    "country": "US",
    "markName": "EVENT SMART TECHNOLOGY",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Organization of events, exhibitions, fairs and shows for commercial, promotional and advertising purposes; Event planning and management for marketing, branding, promoting or advertising the goods and services of others; Corporate event management services; Conference event management services; Consultation in the field of special event planning for advertising purposes; Consultation in the field of special event planning for commercial, promotional, or advertising purposes; Event management services being arranging and conducting of exhibitions for commercial or advertising purposes.; IC 041: Rental of audiovisual equipment; Rental of stage and movie equipment, namely,  camera equipment, lighting equipment and grip equipment; Rental of video screens; Rental of cameras; Rental of overhead projectors; Rental of television sets; Rental of sound recordings; Rental of photographic equipment; Rental of video cameras; Rental of audio equipment; Rental services for audio and video...",
    "applicationDate": "2026-03-30",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99732903",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98829674",
    "country": "US",
    "markName": "MAIN EVENT MAFIA",
    "status": "Live",
    "internationalClasses": [
      "25",
      "28"
    ],
    "goodsDescription": "IC 025: Clothing, namely, t-shirts, tank tops, hoodies, sweatshirts, jackets, pants, shorts, socks, hats, baseball caps, beanies.; IC 028: Novelty toy items in the nature of action figures.",
    "applicationDate": "2024-10-30",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98829674",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99473817",
    "country": "US",
    "markName": "MY EVENT LOOP",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Computer programming services, namely, development and hosting of computer platforms for others for organizing and scheduling social events and which allow participants to mark events, make reservations, and process payments..",
    "applicationDate": "2025-10-31",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99473817",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97350695",
    "country": "US",
    "markName": "SPECIAL EVENT PROZ ONE-STOP EVENT SHOP",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Photography services; Disc jockey services; Disc jockeys for parties and special events; Entertainment event booking agencies; Entertainment in the nature of light shows; Entertainment in the nature of live performances by music bands, musicians, fire show entertainers, belly dancers, vocalists, painters; Entertainment in the nature of symphony orchestra performances; Entertainment services in the nature of live musical performances; Entertainment services in the nature of live visual and audio performances by an actor; Entertainment services in the nature of live visual and audio performances by musicians, musical bands, dancers, actors; Entertainment services in the nature of live visual and audio performances, namely, musicians, musical band, and dance performances; Entertainment services in the nature of presenting live musical performances; Entertainment services in the nature of production of multimedia entertainment content; Entertainment services, namely, providing a...",
    "applicationDate": "2022-04-06",
    "registrationDate": "2023-08-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97350695",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97369713",
    "country": "US",
    "markName": "ORO EVENT CO. OLIVIA ROSE EVENT COMPANY",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Event planning for commercial, promotional, or advertising purposes.",
    "applicationDate": "2022-04-19",
    "registrationDate": "2023-08-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97369713",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "76211428",
    "country": "US",
    "markName": "NATIONAL EVENT SERVICES",
    "status": "Live",
    "internationalClasses": [
      "37",
      "39",
      "42"
    ],
    "goodsDescription": "IC 037: Rental of fencing [ and dumpsters ].; IC 039: Rental of storage containers.; IC 042: Rental of sanitation facilities, namely, portable toilets, hot and cold sinks; and portable temporary accommodations, namely, [ rental of field offices and ] portable ticket offices.",
    "applicationDate": "2001-02-15",
    "registrationDate": "2002-06-11",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/76211428",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97841804",
    "country": "US",
    "markName": "EPIC BEAUTY EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Retail store services and online retail store services featuring cosmetics and beauty products; Administration of loyalty programs involving discounts, rewards, or incentives; Administration of a customer loyalty program which provides rewards in the form of access to retail discounts and offers.",
    "applicationDate": "2023-03-16",
    "registrationDate": "2024-12-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97841804",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98032703",
    "country": "US",
    "markName": "NIGHT LIGHTS EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Conducting entertainment exhibitions in the nature of lantern festivals; Organizing community festivals featuring primarily light displays and lanterns and also providing live music; Organizing lantern and light festivals for cultural or entertainment purposes.",
    "applicationDate": "2023-06-07",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98032703",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90690841",
    "country": "US",
    "markName": "A BENNETT EVENT",
    "status": "Live",
    "internationalClasses": [
      "41",
      "42"
    ],
    "goodsDescription": "IC 041: Party planning.; IC 042: Custom design of party decorations, clothing, barware, and bags based on personal selections made by the customer.",
    "applicationDate": "2021-05-05",
    "registrationDate": "2022-08-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90690841",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90725007",
    "country": "US",
    "markName": "IN THE EVENT",
    "status": "Live",
    "internationalClasses": [
      "43",
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes; Special event planning for commercial, promotional or advertising purposes.; IC 041: Games equipment rental; Rental of dance floors; Rental of game machines and apparatus; Rental of portable stages; Rental of textile tapestries and ornamental wall hangings for use as stage and screen curtains in theaters and performance halls; Party planning of corporate events, birthday parties, weddings, holiday parties, quincea\u00f1eros, balls, reunions, and celebrations; Special event planning for social entertainment purposes.; IC 043: Rental of carpet; Rental of furniture; Rental of lighting apparatus for events, parties, weddings, celebrations, and festivals; Rental of tents; Rental of chairs, tables, table linen, glassware; Rental of table linens.",
    "applicationDate": "2021-05-20",
    "registrationDate": "2022-05-31",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90725007",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86513560",
    "country": "US",
    "markName": "THE ONE EVENT",
    "status": "Live",
    "internationalClasses": [
      "45"
    ],
    "goodsDescription": "IC 045: Wedding ceremony planning and arranging consultation services.",
    "applicationDate": "2015-01-25",
    "registrationDate": "2015-09-01",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86513560",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90207380",
    "country": "US",
    "markName": "EVENT CENTER EVOLOVE",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Providing facilities for recreation, including, entertainment activities, educational conventions, and special events for social entertainment purposes.",
    "applicationDate": "2020-09-24",
    "registrationDate": "2021-08-03",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90207380",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85784339",
    "country": "US",
    "markName": "ONE BIG EVENT",
    "status": "Live",
    "internationalClasses": [
      "36"
    ],
    "goodsDescription": "IC 036: Charitable fundraising services; charitable fundraising services, namely, raising funds for providing medical services, dental services, information and referral services, education and support groups, and advocacy services tailored to the lesbian, gay, bisexual, and transgender (LGBT) communities and people living with HIV/AIDS (PLWHA).",
    "applicationDate": "2012-11-20",
    "registrationDate": "2013-11-05",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85784339",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85952652",
    "country": "US",
    "markName": "RARE EVENT PROTOCOL",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Computer software for the stereological analysis of rare events.",
    "applicationDate": "2013-06-06",
    "registrationDate": "2014-02-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85952652",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "75858904",
    "country": "US",
    "markName": "A PERFECT EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Party planning, namely, wedding and party planning for others.",
    "applicationDate": "1999-11-29",
    "registrationDate": "2001-06-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/75858904",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97260175",
    "country": "US",
    "markName": "NORTHWEST EVENT TECHNOLOGY",
    "status": "Live",
    "internationalClasses": [
      "38"
    ],
    "goodsDescription": "IC 038: Electronic transmission and live streaming of digital media content for others via global and local computer networks; Communications services, namely, transmitting sound, video, and audiovisual content via the Internet; Webcasting services.",
    "applicationDate": "2022-02-09",
    "registrationDate": "2023-03-21",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97260175",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97346985",
    "country": "US",
    "markName": "LEGENCY EVENT HALL",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of banquet and social function facilities for special occasions, namely, weddings, wedding receptions, bridal showers, baby showers, graduations, birthday celebrations, anniversaries, reunions, religious ceremonies, holiday events, corporate events, conferences, conventions, exhibitions, job fairs, networking events, award ceremonies, galas, and fund raising events.",
    "applicationDate": "2022-04-05",
    "registrationDate": "2023-05-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97346985",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88958525",
    "country": "US",
    "markName": "EVENT STAFFING TEAM",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Employment staffing consultation services; Employment staffing in the field of hospitality; Special event planning for business purposes; Special event planning for commercial, promotional or advertising purposes.; IC 041: Party planning; Special event planning for social entertainment purposes; Consultation in the field of special event planning for social entertainment purposes.",
    "applicationDate": "2020-06-10",
    "registrationDate": "2021-06-01",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88958525",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98257387",
    "country": "US",
    "markName": "REL EVENT PRODUCTIONS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Production and distribution of television shows and movies; Entertainment services, namely, live comedy performances; production of webisodes and videos featuring comedy, humor, comedy skits, comedy entertainment, variety entertainment, entertainment interviews and talk for use on the internet and with wireless devices; production of web-based videos featuring comedy, humor, comedy skits, comedy entertainment, variety entertainment, entertainment interviews and talk for use on the internet and with wireless devices; entertainment services, namely, providing online non-downloadable videos featuring appearances by a professional entertainer and comedian via a global computer network in the field of comedy, humor, comedy skits, comedy entertainment, variety entertainment; providing online non-downloadable audiovisual recordings and related video clips in the field of comedy, humor, comedy skits, comedy entertainment, variety entertainment.",
    "applicationDate": "2023-11-06",
    "registrationDate": "2025-02-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98257387",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98303770",
    "country": "US",
    "markName": "YOUR GOLF EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Consultation in the field of special event planning for social entertainment purposes.",
    "applicationDate": "2023-12-07",
    "registrationDate": "2024-12-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98303770",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97576721",
    "country": "US",
    "markName": "FLIPSIDE EVENT CLEANUP",
    "status": "Live",
    "internationalClasses": [
      "37",
      "39"
    ],
    "goodsDescription": "IC 037: Cleaning of live events and events; Consultation services in the field of cleaning of live events and events.; IC 039: Junk, trash and debris removal; Transport and storage of trash; Transport of trash from special events; Trash services, namely, rental of dumpsters.",
    "applicationDate": "2022-09-02",
    "registrationDate": "2025-02-04",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97576721",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97702226",
    "country": "US",
    "markName": "EVENT DRAPE RENTAL",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of drapery for events.",
    "applicationDate": "2022-12-02",
    "registrationDate": "2024-01-16",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97702226",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87328678",
    "country": "US",
    "markName": "MAIN EVENT CATERERS",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Catering services.",
    "applicationDate": "2017-02-08",
    "registrationDate": "2017-09-26",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87328678",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77537760",
    "country": "US",
    "markName": "EVENT DECORATING ACADEMY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, conducting classes and seminars in the field of event decorating and distribution of training material in connection therewith.",
    "applicationDate": "2008-08-03",
    "registrationDate": "2009-04-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77537760",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97502703",
    "country": "US",
    "markName": "EVENT HORIZON CAPITAL",
    "status": "Live",
    "internationalClasses": [
      "36"
    ],
    "goodsDescription": "IC 036: Private equity fund investment services; Managing of capital investment funds; managing securities investments; management of private equity funds; financial services, namely, financial management services; financial services, namely, investment management services; investment advisory services, investment management services, and financial asset management services; investing of funds; Financial asset management services in the nature of actively managing and trading liquid digital assets within an institutional fund to produce positive returns for investors.",
    "applicationDate": "2022-07-14",
    "registrationDate": "2023-11-14",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97502703",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97460479",
    "country": "US",
    "markName": "AT EVERY EVENT",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41",
      "42"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes; business services, namely, planning and conducting of live, virtual and hybrid business presentations, productions, meetings, events, conferences, exhibits, trade shows and trade show booths; providing temporary personnel and support staff, namely, providing audio-visual technicians, operators and support personnel on a temporary basis to event organizers and exhibitors of live, virtual and hybrid audio-visual business presentations, productions, meetings, events and conferences.; IC 041: Audio-visual production services for live, virtual and hybrid events; audio-visual equipment rentals, namely, audio equipment, video equipment, recording equipment and lighting equipment for meetings, events, conferences, exhibits, trade shows and trade show booths; audio-visual technician services for events, namely, technicians for assisting with set-up, operation and management of audio-visual equipment for live, virtual and hybrid meetings,...",
    "applicationDate": "2022-06-15",
    "registrationDate": "2024-02-06",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97460479",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97611143",
    "country": "US",
    "markName": "MY STYLISH EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Wedding reception planning and coordination consultation services; Wedding reception planning and coordination services; Party and wedding reception planning and coordination services; Party and wedding reception planning consultation services; Party and wedding reception planning, coordination and consultation services.",
    "applicationDate": "2022-09-28",
    "registrationDate": "2024-06-25",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97611143",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88012741",
    "country": "US",
    "markName": "HARKEN EVENT COMPANY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Event planning services, namely, wedding reception planning and coordination services and special event planning for social entertainment purposes.",
    "applicationDate": "2018-06-25",
    "registrationDate": "2019-06-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88012741",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98762020",
    "country": "US",
    "markName": "TED EVENT SERIES",
    "status": "Live",
    "internationalClasses": [
      "21"
    ],
    "goodsDescription": "IC 021: Beverageware; shot glasses; bottle openers; bowls; cake molds; cookie cutters; cookie jars; cork screws; crystal, ceramic, glass and porcelain figurines; crystal, ceramic, glass and porcelain sculptures; cupcake molds; cutting boards; dental care kits comprising toothbrushes and floss; dental floss; dinnerware; dishes; drinking straws; hair brushes; hair combs; ice cube molds; insulated containers for food or beverages; insulating sleeve holders for beverage cans; lunch boxes; pet brushes; pet feeding and drinking bowls; piggy banks; coasters, not of paper or textile; place mats, not of paper or textile; plastic squeeze bottles sold empty; plastic water bottles sold empty; plates; salt and pepper shakers; serving trays; serving utensils, namely, serving scoops, serving spoons, serving forks, and serving knives; soap dispensing bottles, sold empty; soap holders; sports bottles sold empty; teapots not made of precious metal; thermal insulated containers for food or beverages;...",
    "applicationDate": "2024-09-20",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98762020",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88344241",
    "country": "US",
    "markName": "LIVE! EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "41",
      "43"
    ],
    "goodsDescription": "IC 041: entertainment services, namely, providing mixed-use recreational entertainment facility services; entertainment services in the nature of presenting live musical performances; live performance by musical bands and singers; entertainment services in the nature of live visual and audio performances, namely, musical, variety, news, sports, and comedy shows; entertainment services, namely, night clubs; providing mixed-use entertainment facilities for night clubs, comedy clubs, and casinos.; IC 043: providing of food and drink; catering; provision of meeting or exhibition, conference and convention facilities; providing mixed-use entertainment facilities for conferences and wedding receptions.",
    "applicationDate": "2019-03-18",
    "registrationDate": "2020-03-31",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88344241",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87699618",
    "country": "US",
    "markName": "THE MANE EVENT",
    "status": "Live",
    "internationalClasses": [
      "38",
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: promotional and endorsement services, namely, advertising the goods and services of others; advertising the goods and services of others via electronic media and specifically the internet; Entertainment marketing services, namely, marketing, promotion and advertising for mixed martial arts competitors and professional wrestlers.; IC 038: Streaming of audio, visual and audiovisual material via a global computer network.; IC 041: Providing information in the field of mixed martial arts, professional wrestling and hair care; organizing sporting events, namely, mixed marital arts and professional wrestling matches, competitions, events and exhibitions.",
    "applicationDate": "2017-11-28",
    "registrationDate": "2019-11-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87699618",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87752845",
    "country": "US",
    "markName": "EVENT TICKETS CENTER",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: On-line ticket marketplace for buyers of tickets for sporting events, musical concerts and other entertainment events.",
    "applicationDate": "2018-01-12",
    "registrationDate": "2018-06-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87752845",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88186987",
    "country": "US",
    "markName": "RHINO EVENT EQUIPMENT",
    "status": "Live",
    "internationalClasses": [
      "11",
      "20"
    ],
    "goodsDescription": "IC 011: Portable electric and gas patio heaters.; IC 020: Furniture, namely, chairs, tables, portable sports bars, benches, excluding step stools.",
    "applicationDate": "2018-11-08",
    "registrationDate": "2019-11-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88186987",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99571430",
    "country": "US",
    "markName": "EVENT CREATORS ACADEMY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Providing on-line training courses in the field of event production, event planning, business development, sales and marketing, career; Arranging and conducting of training courses in the field of event production, event planning, business development, sales and marketing, career; Workshops and seminars in the field of event production, event planning, business development, sales and marketing, career; Providing educational mentoring services and programs in the field of event production, event planning, business development, sales and marketing, career; Business training in the field of event production, event planning, business development, sales and marketing, career; Providing group coaching in the field of event production, event planning, business development, sales and marketing, career; Virtual personal coaching services in the field of event production, event planning, business development, sales and marketing, career; Coaching in the field of event production, event...",
    "applicationDate": "2025-12-30",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99571430",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99660261",
    "country": "US",
    "markName": "IDYLLWILD EVENT DESIGN",
    "status": "Live",
    "internationalClasses": [
      "41",
      "45",
      "44"
    ],
    "goodsDescription": "IC 041: Wedding reception planning and coordination consultation services.; IC 044: Floral design services.; IC 045: Planning and arranging wedding ceremonies.",
    "applicationDate": "2026-02-19",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99660261",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90150241",
    "country": "US",
    "markName": "VIRTUAL EVENT PRO",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Computer services, namely, providing temporary use of non-downloadable computer software for organizing and conducting customizable virtual events and virtual hybrid events, namely, meetings, tradeshows, conferences, symposiums, expositions, seminars, training events, career fairs, lead generation events, industry networking events, and entertainment events; providing temporary use of a secure,non-downloadable website featuring non-downloadable software for enabling users to participate in industry networking events, trade expositions, conferences, seminars, workshops, trade shows, career fairs, remotely; providing on-line non-downloadable software for streaming, webcasting and delivering live and pre-recorded audio-visual content; software as a service (saas) services featuring software for conducting virtual hybrid events, namely, for conducting trade shows, conferences, symposiums, expositions, career fairs, meetings, corporate meetings, learning programs, industry...",
    "applicationDate": "2020-08-31",
    "registrationDate": "2021-05-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90150241",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98093816",
    "country": "US",
    "markName": "EVENT SPACE ELITES",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, providing on-line classes, seminars, workshops, and coaching in the field of\u00a0starting profitable event space businesses.",
    "applicationDate": "2023-07-20",
    "registrationDate": "2025-10-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98093816",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86605985",
    "country": "US",
    "markName": "EVENT SAFETY SUMMIT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, conducting seminars, conferences, and workshops in the field of event planning and production.",
    "applicationDate": "2015-04-22",
    "registrationDate": "2015-11-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86605985",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88596816",
    "country": "US",
    "markName": "WILDFLOWER EVENT DESIGN",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Wedding reception planning and coordination consultation services.",
    "applicationDate": "2019-08-28",
    "registrationDate": "2020-03-31",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88596816",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88489762",
    "country": "US",
    "markName": "THE EVENT GARDENS",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Providing banquet and social function facilities for special occasions, as well as providing related services, namely, catering services.",
    "applicationDate": "2019-06-26",
    "registrationDate": "2020-12-22",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88489762",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99602294",
    "country": "US",
    "markName": "EVENT REVENUE PLATFORM",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Software as a service (SaaS) featuring software for event revenue management, lead capture, contact qualification, data enrichment, analytics, and customer engagement..",
    "applicationDate": "2026-01-19",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99602294",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99211052",
    "country": "US",
    "markName": "ACCUCARE EVENT MEDICAL",
    "status": "Live",
    "internationalClasses": [
      "44"
    ],
    "goodsDescription": "IC 044: Emergency medical services; Emergency medical services offered in or from a remote, mobile or temporary on-site location.",
    "applicationDate": "2025-05-30",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99211052",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99719603",
    "country": "US",
    "markName": "HEIRLOOM EVENT COMPANY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event planning for social entertainment purposes; Party and wedding reception planning consultation services; Wedding reception planning and coordination services.",
    "applicationDate": "2026-03-23",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99719603",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88297345",
    "country": "US",
    "markName": "DILLON TAILGATE EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Organizing community festivals featuring a variety of activities, namely, sporting events, [ art exhibitions, ] flea markets, ethnic dances and the like.",
    "applicationDate": "2019-02-11",
    "registrationDate": "2019-10-08",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88297345",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99159672",
    "country": "US",
    "markName": "EASY EVENT TICKETS",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Platform as a service (PAAS) featuring computer software platforms for event managers, independent promoters, venue operators, and sports competition organizers to conduct, manage, and operate ticketing operations; Providing temporary use of non-downloadable cloud-based software for managing and operating a ticketing platform; Providing temporary use of non-downloadable cloud-based software for a ticketing platform that allows users to integrate sponsorship opportunities with ticketing services for events.",
    "applicationDate": "2025-04-28",
    "registrationDate": "2026-03-31",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99159672",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99787991",
    "country": "US",
    "markName": "MATERIAL EVENT LEDGER",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing software as a service (SaaS) featuring software for creating, maintaining, and auditing event-level records of physical material flows and generating audit-ready regulatory compliance documentation.",
    "applicationDate": "2026-04-26",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99787991",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97150426",
    "country": "US",
    "markName": "NON-FUNGIBLE EVENT",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing on-line non-downloadable computer software tools for providing customized user experiences, namely, a digital token exchange for promoting unique user experiences in a live event ecosystem for entertainment events, including for sporting and concert events.",
    "applicationDate": "2021-12-01",
    "registrationDate": "2024-04-02",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97150426",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98130093",
    "country": "US",
    "markName": "ROZ EVENT PLANNING",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Event planning and management for marketing, branding, promoting or advertising the goods and services of others; Special event planning for business purposes.; IC 041: Consultation in the field of special event planning for social entertainment purposes; Party planning of special events; Party planning of business events; Party planning of weddings.",
    "applicationDate": "2023-08-12",
    "registrationDate": "2024-11-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98130093",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90855294",
    "country": "US",
    "markName": "LEGENDS EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Arena services, namely, providing general purpose facilities for sports, concerts, conventions and exhibitions.",
    "applicationDate": "2021-07-29",
    "registrationDate": "2024-09-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90855294",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90421962",
    "country": "US",
    "markName": "SHORELINE EVENT DESIGN",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Event planning and management for marketing, branding, promoting or advertising the goods and services of others; Arranging and conducting special events for business purposes; Arranging and conducting special events for commercial, promotional or advertising purposes; Special event planning for business purposes; Special event planning for commercial, promotional or advertising purposes.; IC 041: Party and wedding reception planning, coordination and consultation services; Providing information regarding wedding reception planning for wedding parties.",
    "applicationDate": "2020-12-29",
    "registrationDate": "2021-11-02",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90421962",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90427874",
    "country": "US",
    "markName": "KRLA EVENT DESIGN",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event planning for social entertainment purposes; entertainment services in the nature of organizing social entertainment events; arranging, organizing, conducting, and hosting social entertainment events; consultation in the field of special event planning for social entertainment purposes; party and wedding reception planning, coordination, and consultation services; party planning; party planning of special events parties, anniversary parties, weddings, baby showers, graduation parties, prom parties, proposal parties, and engagement parties.",
    "applicationDate": "2020-12-29",
    "registrationDate": "2022-04-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90427874",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77409681",
    "country": "US",
    "markName": "A BLISSFUL EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event planning; Special event planning consultation.",
    "applicationDate": "2008-02-29",
    "registrationDate": "2008-09-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77409681",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77343695",
    "country": "US",
    "markName": "THE EVENT DERBY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: ENTERTAINMENT SERVICES, NAMELY, ORGANIZING AND CONDUCTING HORSE COMPETITIONS.",
    "applicationDate": "2007-12-04",
    "registrationDate": "2008-08-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77343695",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77794919",
    "country": "US",
    "markName": "ADOPT-AN-EVENT",
    "status": "Live",
    "internationalClasses": [
      "21"
    ],
    "goodsDescription": "IC 021: containers, namely, trash cans, garbage cans, waste baskets, plastic recycling containers.",
    "applicationDate": "2009-07-31",
    "registrationDate": "2012-11-13",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77794919",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90844656",
    "country": "US",
    "markName": "THE EVENT GALLERY",
    "status": "Live",
    "internationalClasses": [
      "41",
      "43"
    ],
    "goodsDescription": "IC 041: Special event planning for social entertainment purposes.; IC 043: Providing banquet and social function facilities for special occasions; Rental of banquet and social function facilities for special occasions, namely, parties, showers, weddings, and meetings.",
    "applicationDate": "2021-07-23",
    "registrationDate": "2022-12-06",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90844656",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85472971",
    "country": "US",
    "markName": "SCE EVENT GROUP",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging and conducting special events for social entertainment purposes; arranging, organizing, conducting and hosting social entertainment events.",
    "applicationDate": "2011-11-15",
    "registrationDate": "2012-12-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85472971",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97667988",
    "country": "US",
    "markName": "SAGE EVENT CO",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Party and wedding reception planning, coordination and consultation services.",
    "applicationDate": "2022-11-08",
    "registrationDate": "2023-12-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97667988",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86038656",
    "country": "US",
    "markName": "NORTHWEST EVENT TECHNOLOGY",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging and conducting special events for social entertainment purposes; Entertainment services in the nature of development, creation, production and post-production services of multimedia entertainment content; Rental of audiovisual equipment.",
    "applicationDate": "2013-08-15",
    "registrationDate": "2014-04-29",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86038656",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86062900",
    "country": "US",
    "markName": "SELECT EVENT GROUP",
    "status": "Live",
    "internationalClasses": [
      "37",
      "40",
      "43",
      "44",
      "41"
    ],
    "goodsDescription": "IC 037: Party, event and function rental services, namely, rental of portable cloth and wooden room dividers, laydown and elevated flooring.; IC 040: Party, event and function rental services, namely, rental of space heaters, air conditioners, power generators.; IC 041: Party, event and function rental services, namely, rental of dance floors, portable stages and sound equipment.; IC 043: Party, event and function rental services, namely, rental of furniture, table linens, tableware, tents, tent structures, china, platters, bowls, serving utensils, trays, tray stands, chafing dishes, coffee makers, beverage containers, glasses, cooking pans, ovens, stoves, grills, warming cabinets for food, candelabras, chandeliers, candle lamps, lighting equipment, easels, coat racks, lecterns, drapery, [ mobile kitchens, ] and carpeting.; IC 044: Party, event and function rental services, namely, rental of portable rest rooms.",
    "applicationDate": "2013-09-12",
    "registrationDate": "2015-02-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86062900",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85175667",
    "country": "US",
    "markName": "EVENT CARPET PROS",
    "status": "Live",
    "internationalClasses": [
      "35",
      "37"
    ],
    "goodsDescription": "IC 035: wholesale and retail store services featuring flooring, carpet, and artificial turf; wholesale and retail store services featuring seam tape, duct tape, and hand tools for installation and maintenance of flooring, carpeting, and artificial turf.; IC 037: installation of flooring, carpet, and artificial turf; rental of flooring, carpet, and artificial turf; rental of tools for installation and maintenance of flooring, carpeting, and artificial turf.",
    "applicationDate": "2010-11-12",
    "registrationDate": "2012-10-16",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85175667",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98547899",
    "country": "US",
    "markName": "TREND EVENT COLLECTIONS",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of furniture; Rental of heating and cooling apparatus for dispensing hot and cold beverages; Rental of bar furniture; Rental of chairs, tables, table linen, glassware; Rental of hospitality furniture; Rental of lighting apparatus for events such as weddings and banquets; Rental of table linens; Rental of tableware, silverware, and dishes for special events.",
    "applicationDate": "2024-05-13",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98547899",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87195353",
    "country": "US",
    "markName": "SUPER SHRED EVENT",
    "status": "Live",
    "internationalClasses": [
      "36"
    ],
    "goodsDescription": "IC 036: Credit union services.",
    "applicationDate": "2016-10-06",
    "registrationDate": "2017-10-31",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87195353",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87111944",
    "country": "US",
    "markName": "DECADES EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "35",
      "43",
      "41"
    ],
    "goodsDescription": "IC 035: Providing facilities for business meetings and trade exhibitions.; IC 041: Providing facilities for recreation, namely, facilities for concerts with entertainment activities, providing facilities for educational conventions, providing sporting facilities, providing recreation facilities for cultural activities, providing facilities for employment training.; IC 043: Providing banquet and social function facilities for special occasions such as weddings, wedding receptions, parties and graduations.",
    "applicationDate": "2016-07-21",
    "registrationDate": "2017-11-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87111944",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77553015",
    "country": "US",
    "markName": "STARDUST EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Arena services, namely, providing facilities for sports, concerts, conventions and exhibitions; Providing banquet and social function facilities for special occasions; Provision of conference, exhibition and meeting facilities.",
    "applicationDate": "2008-08-21",
    "registrationDate": "2009-06-16",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77553015",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85031954",
    "country": "US",
    "markName": "EVENT WATER SOLUTIONS",
    "status": "Live",
    "internationalClasses": [
      "39"
    ],
    "goodsDescription": "IC 039: the provision of water delivery services to permit the delivery of pre-filtered water to people attending public events such as music and cultural festivals, athletic competitions, concerts, and large meetings and celebrations, including the provision of staff, tents, filters, cups and water containers.",
    "applicationDate": "2010-05-06",
    "registrationDate": "2012-10-02",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85031954",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78409410",
    "country": "US",
    "markName": "NATIONAL EVENT SERVICES",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: EMPLOYMENT STAFFING.; IC 041: SPECIAL EVENT CONSULTATION AND PLANNING.",
    "applicationDate": "2004-04-28",
    "registrationDate": "2006-01-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78409410",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86605943",
    "country": "US",
    "markName": "EVENT SAFETY ALLIANCE",
    "status": "Live",
    "internationalClasses": [
      "45"
    ],
    "goodsDescription": "IC 045: Consultation on physical safety risk assessment procedures in the field of event planning and production.",
    "applicationDate": "2015-04-22",
    "registrationDate": "2016-02-16",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86605943",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98807613",
    "country": "US",
    "markName": "SMART EVENT PLAN",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing online non-downloadable computer software platforms for temporary use of online non downloadable customizable event management software for event project planning, goal setting, registration, attendee management, budget management, AI tools, event logistics, vendor management, event process streamlining, meeting coordination, event reporting, and analytics, gamification, web based surveys, venue selection; customization services for the optimal utilization of the product and technical support services, namely, troubleshooting in the nature of diagnosing computer hardware and software problems..",
    "applicationDate": "2024-10-17",
    "registrationDate": "2025-09-02",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98807613",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "75279329",
    "country": "US",
    "markName": "THE SPECIAL EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: organizing and conducting trade shows for party rental dealers, caterers and event planners; advertising trade shows for party rental dealers, caterers and event planners online.",
    "applicationDate": "1997-04-22",
    "registrationDate": "1999-05-25",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/75279329",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90052615",
    "country": "US",
    "markName": "SPECIAL EVENT FACTORY",
    "status": "Live",
    "internationalClasses": [
      "44"
    ],
    "goodsDescription": "IC 044: Floral design services.",
    "applicationDate": "2020-07-14",
    "registrationDate": "2021-06-22",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90052615",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77015116",
    "country": "US",
    "markName": "ONBOARD EVENT RECORDING",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Providing transportation documentation for others.",
    "applicationDate": "2006-10-05",
    "registrationDate": "2007-05-08",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77015116",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77082723",
    "country": "US",
    "markName": "SPECIAL EVENT GENIE",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event and party planning and consultation.",
    "applicationDate": "2007-01-14",
    "registrationDate": "2008-01-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77082723",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "76487333",
    "country": "US",
    "markName": "MAIN EVENT ENTERTAINMENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Indoor amusement centers featuring bowling, billiards, casino style blackjack tables and laser tag.",
    "applicationDate": "2003-02-04",
    "registrationDate": "2003-12-16",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/76487333",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85276464",
    "country": "US",
    "markName": "DIGITAL EVENT STRATEGIST",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Business education services, namely, providing training courses in the field of digital environments for events, meetings, marketing and learning.",
    "applicationDate": "2011-03-25",
    "registrationDate": "2011-12-20",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85276464",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88348141",
    "country": "US",
    "markName": "FAEM EVENT MGMT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Business networking.",
    "applicationDate": "2019-03-20",
    "registrationDate": "2019-11-05",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88348141",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86601593",
    "country": "US",
    "markName": "WINGS EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Arena services, namely, providing general purpose facilities for sports, concerts, conventions and exhibitions.",
    "applicationDate": "2015-04-17",
    "registrationDate": "2016-12-27",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86601593",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99240514",
    "country": "US",
    "markName": "THE PATRIOT EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services in the nature of production of equine events and competitions, horse racing, horse riding, rodeo exhibitions, rodeo events, animal exhibitions, animal competitions, roping competitions, and equine showings; Organizing, arranging, and conducting roping, horse racing, equine racing, horse riding, rodeo exhibitions, animal exhibitions, and equine showings events.",
    "applicationDate": "2025-06-18",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99240514",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86479008",
    "country": "US",
    "markName": "EVENT GURU SOFTWARE",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing non-downloadable cloud-based customer relations management software solution for use by meeting and conference venues to effectively manage the logistics for meetings and events held at their venue.",
    "applicationDate": "2014-12-12",
    "registrationDate": "2015-11-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86479008",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98762018",
    "country": "US",
    "markName": "TED EVENT SERIES",
    "status": "Live",
    "internationalClasses": [
      "25"
    ],
    "goodsDescription": "IC 025: Clothing namely, shirts and tops, dresses, skirts, pants, trousers, jeans, shorts, rompers, overalls, sweatshirts and sweat pants, sweatsuits, gloves, suspenders, ties, coats and jackets, hosiery, pajamas, robes, sleep shirts, sleepwear, swimwear, underwear, Halloween costumes, infantwear and cloth baby bibs; hats; headwear, namely, caps; shoes, boots, and slippers.",
    "applicationDate": "2024-09-20",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98762018",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99618347",
    "country": "US",
    "markName": "DENVER EVENT RENTAL",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of furniture, linen, table settings and equipment for the provision of food and beverages; Rental of tents.",
    "applicationDate": "2026-01-27",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99618347",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99113102",
    "country": "US",
    "markName": "THE MAINE EVENT",
    "status": "Live",
    "internationalClasses": [
      "25"
    ],
    "goodsDescription": "IC 025: Athletic apparel, namely, shirts, pants, jackets, footwear, hats and caps, athletic uniforms; Athletic shorts; Sweatshirts; Hooded sweatshirts.",
    "applicationDate": "2025-03-31",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99113102",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90587595",
    "country": "US",
    "markName": "LAUGHLIN EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Arena services, namely, providing general-purpose facilities for sports, concerts and exhibitions.",
    "applicationDate": "2021-03-18",
    "registrationDate": "2022-02-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90587595",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98257363",
    "country": "US",
    "markName": "REL EVENT PRODUCTIONS",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: Downloadable television shows and movies featuring comedy, humor, comedy entertainment, variety entertainment, and clips from a comedy and variety television program; audiovisual recordings featuring comedy, humor, comedy entertainment, variety entertainment, and clips from a comedy and variety television program; downloadable audio-visual recordings featuring comedy, humor, comedy entertainment, variety entertainment, and clips from a comedy and variety television program.",
    "applicationDate": "2023-11-06",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98257363",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97870680",
    "country": "US",
    "markName": "EVENT TECH PROTECT",
    "status": "Live",
    "internationalClasses": [
      "36"
    ],
    "goodsDescription": "IC 036: Insurance services, namely, underwriting event cancellation\ninsurance; insurance services, namely, underwriting cyber insurance\ncoverage to protect against malicious and non-malicious cyber\nincidents.",
    "applicationDate": "2023-04-03",
    "registrationDate": "2025-08-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97870680",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87022100",
    "country": "US",
    "markName": "VIRTUAL EVENT BAGS",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Advertising and marketing services, namely, promoting the goods and services of others; administration of a program for enabling participants, including without limitation event participants, to obtain information and discounts on the costs of goods and services of others, including without limitation event sponsors, affiliates, and promoters; promoting the goods and services of others by providing a website featuring coupons, discounts, rebates, links to third party websites and/or other information about the promoted goods and services; promoting the goods and services of others by arranging for sponsors to affiliate their goods and services with an event before, during, and after the event; promoting the goods and services of others through wireless electronic devices; tracking and reporting of online marketing activities and participant engagement for sponsors of events.",
    "applicationDate": "2016-05-02",
    "registrationDate": "2017-04-11",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87022100",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99154348",
    "country": "US",
    "markName": "SOUTHWEST EVENT RENTAL",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of decor, furniture and furnishings for social events, namely, canvas and noncanvas teepees, tables, sofas, chairs, lighting fixtures, portable bars.",
    "applicationDate": "2025-04-24",
    "registrationDate": "2026-02-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99154348",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99358485",
    "country": "US",
    "markName": "ENCORE EVENT RENTALS",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of bar equipment; Rental of dining tables; Rental of coatstands; Rental of popcorn poppers; Rental of ice pails; Rental of table linens; Rental of dishes; Rental of chafing dishes; Rental of chairs, tables, table linen, glassware; Rental of food service equipment; Rental of drinking water dispensers; Rental of drinking water equipment, namely, coolers and hot and cold dispensing consoles; Rental of tableware; Rental of table cutlery; Rental of bar furniture; Rental of ice buckets; Rental of table linen; Rental of furniture, table linen, table settings and equipment for the provision of food and drink.",
    "applicationDate": "2025-08-26",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99358485",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99693610",
    "country": "US",
    "markName": "EVENT OPS DEPOT",
    "status": "Live",
    "internationalClasses": [
      "35",
      "42"
    ],
    "goodsDescription": "IC 035: Provision of an on-line marketplace for buyers and sellers of goods and services.; IC 042: Providing a secure, web-based service featuring technology that enables individuals to remotely create and manage their own accounts so that whatever private content they upload now can be encrypted, then delivered to their intended recipients, at the time and in the manner requested.",
    "applicationDate": "2026-03-10",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99693610",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99736343",
    "country": "US",
    "markName": "IMPERIAL EVENT RENTALS",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of tableware, silverware, and dishes for special events; Rental of tents; Rental of chairs and tables; Rental of lighting apparatus for special events; Rental of bar furniture; Rental of bar equipment; Rental of table linens; Rental of furniture.",
    "applicationDate": "2026-03-31",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99736343",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99462680",
    "country": "US",
    "markName": "FM EVENT PRODUCTIONS",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Provision of an on-line marketplace for buyers and sellers of goods and services.",
    "applicationDate": "2025-10-26",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99462680",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "76718302",
    "country": "US",
    "markName": "MAIN EVENT ENTERTAINMENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Indoor amusement centers featuring bowling, billiards, amusement games, rock climbing and rope course and laser tag.",
    "applicationDate": "2015-07-28",
    "registrationDate": "2016-09-20",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/76718302",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98340184",
    "country": "US",
    "markName": "MAIN EVENT MAFIA",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment in the nature of live performances by professional and amateur wrestlers and sports entertainers; Entertainment services in the nature of production of live wrestling and sports entertainment events for entertainment purposes; Entertainment in the nature of wrestling contests; Entertainment services, namely, wrestling exhibits and performances by a professional wrestler and entertainer.",
    "applicationDate": "2024-01-03",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98340184",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98910559",
    "country": "US",
    "markName": "EVENT BRANDING DEPOT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Event planning and management for marketing, branding, promoting or advertising the goods and services of others.",
    "applicationDate": "2024-12-18",
    "registrationDate": "2026-04-21",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98910559",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78665726",
    "country": "US",
    "markName": "GLOBAL EVENT SOLUTIONS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: International and domestic business special event planning; international and domestic business special event planning consultation.",
    "applicationDate": "2005-07-07",
    "registrationDate": "2006-10-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78665726",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90148812",
    "country": "US",
    "markName": "NEST EVENT RENTALS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: party planning services in the nature of providing balloon decor for events and event d\u00e9cor rentals, namely, rental of structures being part of the balloon d\u00e9cor.",
    "applicationDate": "2020-08-31",
    "registrationDate": "2021-04-27",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90148812",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99418264",
    "country": "US",
    "markName": "INTERNATIONAL ART EVENT DESIGN FESTA DF INTERNATIONAL ART EVENT DESIGN FESTA",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41",
      "43"
    ],
    "goodsDescription": "IC 035: Organization of art exhibitions for commercial or advertising purposes; Business management; organization of trade fairs for advertising purposes.; IC 041: Organizing cultural and arts events; Art exhibitions; organization of art exhibitions for cultural or educational purposes; educational and instruction services, namely, providing exhibitions and cultural events relating to arts and crafts; arranging and planning showings of movies, shows, plays and musical performances.; IC 043: Providing facilities for exhibitions.",
    "applicationDate": "2025-09-29",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99418264",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97688945",
    "country": "US",
    "markName": "ASE EVENT PLANNING + CREATIVE DIRECTION",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Organization of dancing events; Organization of events for cultural purposes; Organizing and hosting of events for cultural purposes; Party planning of baptisms, bris, birthdays, bar and bat mitzvahs, weddings, graduation parties, quincea\u00f1era, bachelor and bachelorette parties, rehearsal dinners, baby showers, anniversaries, retirement parties, fundraisers, holiday parties, showcases, grand openings, award ceremonies, fairs, art walks, corporate events, charity events, and proms; Special event planning for social entertainment purposes; Wedding reception planning and coordination consultation services; Wedding reception planning and coordination services; Arranging and conducting special events for social entertainment purposes; Arranging, organizing, conducting, and hosting social entertainment events; Consultation in the field of special event planning for social entertainment purposes; Party and wedding reception planning and coordination services; Party and wedding...",
    "applicationDate": "2022-11-22",
    "registrationDate": "2023-12-26",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97688945",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99118584",
    "country": "US",
    "markName": "MAVENS & MIMOSAS BRUNCH EVENT SERIES",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Hosting social entertainment events, namely, brunch, happy hour, and dinner networking gatherings, for others; Hosting and conducting social entertainment events, namely, brunch, happy hour, and dinner networking gatherings, for others.",
    "applicationDate": "2025-04-03",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99118584",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98273657",
    "country": "US",
    "markName": "DRAPING VOILE + VEIL EVENT DESIGN",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Consultation in the field of special event planning for social entertainment purposes; Party planning; Party planning consultation; Providing information in the field of wedding party planning; Special event planning for social entertainment purposes.",
    "applicationDate": "2023-11-16",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98273657",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99512282",
    "country": "US",
    "markName": "SN LAVIE EVENT RENTALS & SERVICES",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of tableware, silverware, and dishes for special events; Rental of chairs, tables, table linen, glassware.",
    "applicationDate": "2025-11-24",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99512282",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88689206",
    "country": "US",
    "markName": "THE HUB POWER10 SERIES EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Organizing, conducting, and operating youth basketball tournaments.",
    "applicationDate": "2019-11-12",
    "registrationDate": "2020-12-08",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88689206",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97052250",
    "country": "US",
    "markName": "C&S EVENT SUPPLY CO.",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: On-line retail store services featuring home and kitchen products.",
    "applicationDate": "2021-09-29",
    "registrationDate": "2023-02-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97052250",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90424629",
    "country": "US",
    "markName": "THE CARRINGTON CONFERENCE & EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Catering services; Rental of banquet and social function facilities for special occasions, namely, weddings, social events, and corporate functions.",
    "applicationDate": "2020-12-29",
    "registrationDate": "2021-09-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90424629",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85577540",
    "country": "US",
    "markName": "PROSHOW THE EVENT STAFFING SPECIALISTS",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Personnel management consulting.",
    "applicationDate": "2012-03-22",
    "registrationDate": "2012-11-20",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85577540",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97430376",
    "country": "US",
    "markName": "RISE & RECORD VIDEO MARKETING EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Conducting of business conferences in the field of social media marketing; Conducting of business conferences in the field of video marketing.",
    "applicationDate": "2022-05-26",
    "registrationDate": "2023-07-04",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97430376",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88944531",
    "country": "US",
    "markName": "BB BLACK BUTTERFLY EVENT COORDINATING",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event planning for social entertainment purposes; consultation in the field of special event planning for social entertainment purposes; party planning of birthday, anniversary, baby shower, retirement, graduation, Karaoke, food, beverage and wine tasting events; hosting social entertainment events, namely, birthday parties, anniversary parties, baby shower parties, retirement parties, graduation parties, Karaoke parties and, food, beverage and wine tasting events for others; entertainment services in the nature of arranging social entertainment events; entertainment services in the nature of hosting social entertainment events; organizing, arranging, and conducting birthday, anniversary, baby shower, retirement, graduation, Karaoke, food, beverage and wine tasting events; Karaoke disc jockey services; hosting social entertainment events, namely, birthday parties, anniversary parties, baby shower parties, retirement parties, graduation parties, Karaoke parties and,...",
    "applicationDate": "2020-06-02",
    "registrationDate": "2021-06-29",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88944531",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98452426",
    "country": "US",
    "markName": "PUSH 365 EVENT GROUP LLC",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Concert booking; Party and wedding reception planning, coordination and consultation services; Party planning; Party planning consultation; Arranging and conducting of concerts; Arranging and conducting special events for social entertainment purposes; Arranging, organizing, conducting, and hosting social entertainment events; Consultation in the field of special event planning for social entertainment purposes; Disc jockeys for parties and special events; Entertainment services in the nature of arranging social entertainment events; Entertainment services in the nature of arranging, organizing, conducting, and hosting dinner parties; Entertainment services in the nature of hosting social entertainment events; Entertainment services in the nature of production of live events for parties and special events for social entertainment purposes; Entertainment services, namely, conducting parties; Master of ceremony services for parties and special events; Organization of...",
    "applicationDate": "2024-03-15",
    "registrationDate": "2024-12-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98452426",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77076836",
    "country": "US",
    "markName": "AIRBRANDS EVENT & MARKETING GROUP LTD.",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Advertising agencies, namely, promoting the goods and services of others; Advertising and promotion services and related consulting; Advertising particularly services for the promotion of goods; Advertising, marketing and promotion services; Developing promotional campaigns for business; Promoting the parties and special events of others.",
    "applicationDate": "2007-01-05",
    "registrationDate": "2007-10-23",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77076836",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98599027",
    "country": "US",
    "markName": "FB FORMALBUILDER.COM YOUR EVENT DELIVERED",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event planning for social entertainment purposes.",
    "applicationDate": "2024-06-13",
    "registrationDate": "2025-06-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98599027",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97464105",
    "country": "US",
    "markName": "WEFTEC THE WATER QUALITY EVENT",
    "status": "Live",
    "internationalClasses": [
      "9",
      "35",
      "41"
    ],
    "goodsDescription": "IC 009: downloadable articles, conference proceedings, and conference papers, all in the field of water quality, preservation and enhancement, water-related sanitation and public health, climate change, and infrastructure investments.; IC 035: Organizing business expositions for products and services in the field of water quality, preservation and enhancement, water-related sanitation and public health, climate change, and infrastructure investments such as in plant and equipment for water-related usage and reuse.; IC 041: Education services, namely, providing live and on-line seminars and conferences concerning technical and scientific topics in the field of water quality, water preservation and enhancement, water-related sanitation and public health, climate change, and infrastructure investments such as in plant and equipment for water-related usage and reuse, and distribution of related educational materials.",
    "applicationDate": "2022-06-17",
    "registrationDate": "2024-03-26",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97464105",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98510614",
    "country": "US",
    "markName": "O O.S.E.S OPTIMIZING SAFETY & EVENT SERVICES",
    "status": "Live",
    "internationalClasses": [
      "35",
      "45"
    ],
    "goodsDescription": "IC 035: Employment hiring, recruiting, placement, staffing and career networking services; Employment staffing consultation services; Placement of staff; Professional staffing and recruiting services; Professional staffing services; Providing office support staff services; Staff placement services.; IC 045: Escorting of prisoners and persons in custody being security services; Providing protection for executives being security services; Provision of protection services for executives being security services; Security guard services; Security guard services for buildings; Security services being armed escorts for prisoners; Security services for individuals and business persons traveling internationally and domestically, namely, providing foreign country security briefings, embassy information for security purposes and security reports.",
    "applicationDate": "2024-04-20",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98510614",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99217356",
    "country": "US",
    "markName": "MOMMA LOU'S EVENT PLANNING BY JAIME",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Special event planning for social entertainment purposes.",
    "applicationDate": "2025-06-04",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99217356",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98779926",
    "country": "US",
    "markName": "CREATIVE MINDS. SOLUTIONS FOCUSED. EVENT MAGIC.",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Corporate event management services; Special event planning for commercial, promotional or advertising purposes.",
    "applicationDate": "2024-10-01",
    "registrationDate": "2025-06-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98779926",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88470307",
    "country": "US",
    "markName": "EST. 2018 EVENT CENTER MONTROSE COUNTY",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41",
      "43"
    ],
    "goodsDescription": "IC 035: Providing facilities for business meetings.; IC 041: Entertainment Services, namely, organizing and hosting festivals for cultural or entertainment purposes, and live music concerts; entertainment services, namely, hosting animal and livestock shows, automotive and motorcycle shows; providing facilities for the performing arts; entertainment services, namely, hosting sporting events, charity and fundraising events; rental of indoor recreational facilities for playing sports, sports training, and group recreation events; providing facilities for educational training.; IC 043: Arena services, namely, providing general purpose facilities for sports, concerts, fairs, conventions, and exhibitions; rental of banquet and social function facilities for special occasions, namely, private parties, fundraising events.",
    "applicationDate": "2019-06-12",
    "registrationDate": "2020-06-23",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88470307",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88812333",
    "country": "US",
    "markName": "YOUR ONE STOP PARTY & EVENT SUPPLIER",
    "status": "Live",
    "internationalClasses": [
      "21"
    ],
    "goodsDescription": "IC 021: Decorative centerpieces of crystal and glass.",
    "applicationDate": "2020-02-26",
    "registrationDate": "2020-09-15",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88812333",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98919413",
    "country": "US",
    "markName": "ON IT! EVENT AND OFFICE SUPPLIES",
    "status": "Live",
    "internationalClasses": [
      "16"
    ],
    "goodsDescription": "IC 016: Name badge holders.",
    "applicationDate": "2024-12-23",
    "registrationDate": "2025-09-16",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98919413",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99045418",
    "country": "US",
    "markName": "RED, WHITE AND NEW TRADE EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Retail store services featuring recreational vehicles, recreational vehicle parts and accessories, and outdoor recreational and camping products; On-line retail store services featuring recreational vehicles, recreational vehicle parts and accessories, and outdoor recreational and camping products; Arranging and conducting trade show exhibitions in the field of recreational vehicles, recreational vehicle parts and accessories, and outdoor recreational and camping products; Conducting virtual trade show exhibitions online in the field of recreational vehicles, recreational vehicle parts and accessories, and outdoor recreational and camping products; Advertising and promotional services; Online advertising and promotional services.",
    "applicationDate": "2025-02-18",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99045418",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99145622",
    "country": "US",
    "markName": "REMEMBRANCE EVENT TOAST TO THE FALLEN",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Charitable services, namely, organizing and conducting volunteer programs and community service projects aimed at increasing support and morale of families of deceased war veterans, war veterans, current members and future members of the United States military; Promoting public awareness of the interests of Remembering and honoring fallen veterans.",
    "applicationDate": "2025-04-19",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99145622",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86129412",
    "country": "US",
    "markName": "POSH & LUXE EVENT FURNITURE + D\u00c9COR RENTAL",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of furniture for parties namely, chairs, sofas, ottomans, daybeds, benches, banquettes, and barstools; rental of bars for parties; rental of tables for parties; rental of custom fabricated furniture for parties; rental of custom branded furniture for parties; rental of illuminated furniture and decorations.",
    "applicationDate": "2013-11-26",
    "registrationDate": "2014-12-30",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86129412",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98052376",
    "country": "US",
    "markName": "IRENT EVERYTHING .COM EVENT RENTAL & PRODUCTION",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of chairs and tables; Rental of table linen and glassware; Rental of lighting apparatus for parties and events; Rental of pipes and drapery for use as social meeting, banquet and social function facilities; Rental of tents including structure tents, pole tents, frame tents, sailcloth tents, high peak tents, garden tents and garden structure to support tents.",
    "applicationDate": "2023-06-21",
    "registrationDate": "2025-04-29",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98052376",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "86075924",
    "country": "US",
    "markName": "IWED INSTITUTE OF WEDDING & EVENT DESIGN",
    "status": "Live",
    "internationalClasses": [
      "16",
      "41"
    ],
    "goodsDescription": "IC 016: Printed certificates; Stationery; Printed educational materials, namely, printed instructional wedding and event design course materials, program materials in wedding and event design; Educational printed materials, namely, booklets, catalogs, brochures, forms, magazines, books, manuals, workbooks, printed guides in the field of wedding and event design featuring instructional, training, teaching, testing, examination and assessment materials for professional accreditation as an event designer.; IC 041: Educational services, namely offering training in the field of wedding and event design; Educational services, namely conducting classes, seminars, and workshops and exhibitions in the field of wedding and event design at the professional level and distributing course materials in connection therewith; Providing education in the field of wedding and event design rendered through educational workshops; Arranging and conducting educational workshops, training courses, conferences...",
    "applicationDate": "2013-09-26",
    "registrationDate": "2014-07-22",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/86075924",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98887541",
    "country": "US",
    "markName": "THE CRANE BAY EVENT CENTER CB",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Rental of banquet and social function facilities for special occasions, namely, weddings, corporate functions, social gatherings, tradeshows, proms, holiday parties and meetings.",
    "applicationDate": "2024-12-05",
    "registrationDate": "2025-08-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98887541",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87030059",
    "country": "US",
    "markName": "MOORE FARMS RUSTIC WEDDINGS & EVENT BARNS",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Providing banquet and social function facilities for special occasions.",
    "applicationDate": "2016-05-09",
    "registrationDate": "2017-01-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87030059",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98095428",
    "country": "US",
    "markName": "THE CARDIOMETABOLIC EVENT OF THE YEAR",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, conducting live seminars and workshops in the field of cardiometabolic health.",
    "applicationDate": "2023-07-21",
    "registrationDate": "2024-08-27",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98095428",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90443407",
    "country": "US",
    "markName": "SHE RAINES VIRTUAL EVENT PLANNING & PRESENTATIONS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Education and entertainment services, namely, special event planning for social entertainment purposes; arranging and conducting special events and meetings in the nature of special events for social entertainment purposes; organizing presentations for the events of social entertainment purposes, namely, special event planning for social entertainment purposes.",
    "applicationDate": "2020-12-31",
    "registrationDate": "2022-11-08",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90443407",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88569665",
    "country": "US",
    "markName": "BM THE BIBB MILL EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Catering services; Rental of rooms for social functions; Food and drink catering.",
    "applicationDate": "2019-08-07",
    "registrationDate": "2020-12-29",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88569665",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98014200",
    "country": "US",
    "markName": "ESG EVENT SERVICES GROUP",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41",
      "42",
      "45"
    ],
    "goodsDescription": "IC 035: Special event planning for business purposes; special event planning for commercial, promotional or advertising purposes; event planning and management for marketing, branding, promoting or advertising the goods and services of others; event planning of product launches and activations for business purposes; staff placement services namely, providing models, musicians, and other entertainment talent staff for special events.; IC 041: Consultation in the field of special event planning for social entertainment purposes; party planning; party planning of anniversary parties, birthday parties, bar and bat mitzvahs, and holiday parties; party and wedding reception planning, coordination and consultation services; special event planning for social entertainment purposes.; IC 042: Temporary interior and exterior decorating and d\u00e9cor consultation for special events.; IC 045: Planning and arranging of wedding ceremonies.",
    "applicationDate": "2023-05-25",
    "registrationDate": "2024-06-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98014200",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "75241136",
    "country": "US",
    "markName": "WORLD'S LARGEST MOTORCYCLE EVENT",
    "status": "Live",
    "internationalClasses": [
      "16"
    ],
    "goodsDescription": "IC 016: printed material, namely, posters, [ calendars, decals, post cards, ] * and * business cards [ and coupons ].",
    "applicationDate": "1997-02-12",
    "registrationDate": "1998-10-06",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/75241136",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97215506",
    "country": "US",
    "markName": "COMPASS A FUSION EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging and conducting of conferences and seminars in the field of business risk management, business continuity, disaster recovery, vendor management, and regulatory compliance.",
    "applicationDate": "2022-01-12",
    "registrationDate": "2023-09-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97215506",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97284173",
    "country": "US",
    "markName": "LONE STAR EVENT CHARTERS",
    "status": "Live",
    "internationalClasses": [
      "39"
    ],
    "goodsDescription": "IC 039: Transportation by land.",
    "applicationDate": "2022-02-25",
    "registrationDate": "2023-05-02",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97284173",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90507110",
    "country": "US",
    "markName": "TERRA COTTA EVENT CO.",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Party planning; Party and wedding reception planning, coordination and consultation services; Special event planning for social entertainment purposes.",
    "applicationDate": "2021-02-03",
    "registrationDate": "2021-12-21",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90507110",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98230940",
    "country": "US",
    "markName": "SANDHILLS GLOBAL EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Event center services, namely, providing general purpose facilities for sports, concerts, conventions, and exhibitions.",
    "applicationDate": "2023-10-19",
    "registrationDate": "2024-11-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98230940",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98230951",
    "country": "US",
    "markName": "SANDHILLS GLOBAL EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Event center services, namely, providing general purpose facilities for sports, concerts, conventions, and exhibitions.",
    "applicationDate": "2023-10-19",
    "registrationDate": "2024-11-19",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98230951",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78510522",
    "country": "US",
    "markName": "VIVIEN VIRTUAL EVENT DESIGNER",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: EVENT AND MEETING DESIGN AND PLANNING SOFTWARE, NAMELY, SOFTWARE THAT PERMITS USERS TO ASSEMBLE GRAPHIC ELEMENTS TO PRODUCE LAYOUT AND FLOOR PLAN IMAGES, AS WELL AS LIFE-LIKE 3D IMAGES, OF EVENT VENUES SUCH AS CONFERENCE ROOMS AND BANQUET ROOMS.",
    "applicationDate": "2004-11-03",
    "registrationDate": "2006-07-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78510522",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98741576",
    "country": "US",
    "markName": "SATURDAY NIGHT'S MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "25"
    ],
    "goodsDescription": "IC 025: Clothing, namely, tops, shirts, jackets, sweatshirts, hoodies; outerwear, namely, coats; bottoms, pants, shorts, underwear, dresses, pajamas, lingerie, clothing ties, scarves, gloves, swimwear; Halloween and masquerade costumes; footwear, namely, shoes, sneakers, slippers, flip flops, boots; headwear, namely, hats, caps; wrist bands as clothing; bandanas.",
    "applicationDate": "2024-09-09",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98741576",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88881372",
    "country": "US",
    "markName": "PRIME TIME EVENT GROUP",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Disc jockeys for parties and special events; Rental of portable photography and/or videography booths for taking of pictures and videos.",
    "applicationDate": "2020-04-21",
    "registrationDate": "2020-11-03",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88881372",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87823182",
    "country": "US",
    "markName": "IEP INFLATABLE EVENT PROFESSIONALS",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services in the nature of hosting of catered social events; Entertainment services in the nature of organization of back yard parties, corporate events and parties, family day and Christmas parties, church events, schools, graduations, weddings and similar parties, all for social entertainment purposes; providing and renting inflatable bounce houses, inflatable games, inflatable interactive games, interactive games, giant games, carnival games, table games, inflatable obstacle courses, inflatable slides, inflatable water slides, [ inflatable plastic water slides, ] interactive water games, non-harmful arrows archery, dunk tanks, trackless trains for non-transportation entertainment purposes, [ laser tags, paint balls, virtual reality games, rock climbing walls, mechanical bull for rides, bungee run, ] entertainment services in the nature of photo booths with accompanying props, [ cash cubes in the nature of inflatable money blowing machines, jousting equipment,...",
    "applicationDate": "2018-03-07",
    "registrationDate": "2019-05-21",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87823182",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88719218",
    "country": "US",
    "markName": "SET SPECIALIZED EVENT TEAM",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Professional staffing services.",
    "applicationDate": "2019-12-08",
    "registrationDate": "2020-07-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88719218",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87390168",
    "country": "US",
    "markName": "LIFE THE ULTIMATE EVENT",
    "status": "Live",
    "internationalClasses": [
      "9",
      "16"
    ],
    "goodsDescription": "IC 009: Downloadable MP3 files, MP3 recordings, on-line discussion board posts, webcasts, webinars and podcasts, news, and audio books in the field of personal development, personal growth and event planning; Non-fiction audio books on a variety of topics.; IC 016: Books in the field of personal development, personal growth and event planning; Educational books featuring personal development, personal growth and event planning; Exercise books; Guide books featuring personal development, personal growth and event planning; Printed books in the field of personal development, personal growth and event planning; Printed pamphlets, brochures, manuals, books, booklets, leaflets, informational flyers, informational sheets and newsletters, adhesive backed stickers, and kits comprised solely of one or more of the foregoing materials in the field of personal development, personal growth and event planning; Recipe books; Scholarly books on various topics, namely, personal development, personal...",
    "applicationDate": "2017-03-29",
    "registrationDate": "2020-07-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87390168",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88436991",
    "country": "US",
    "markName": "EVENT PROJECT MANAGEMENT FRAMEWORK",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Consulting services for others in the field of design, planning, and implementation and project management of events, meetings, and special events for business purposes.",
    "applicationDate": "2019-05-19",
    "registrationDate": "2019-12-17",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88436991",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88397678",
    "country": "US",
    "markName": "FRAUD INCIDENT EVENT MANAGEMENT",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Providing temporary use of online non-downloadable computer and cloud-based software for cybersecurity, namely, detecting and mitigating network attacks using artificial intelligence, machine learning and/or deep learning; Providing temporary use of online non-downloadable computer and cloud-based software for continuous monitoring, identifying, verifying, analyzing, comparing, classifying, sorting and scoring of collected or acquired data from network traffic, network communication, network flow data, and network intercommunication using artificial intelligence, machine learning and/or deep learning; Providing temporary use of online non-downloadable computer and cloud-based software for training artificial intelligence, machine learning and/or deep learning systems.",
    "applicationDate": "2019-04-23",
    "registrationDate": "2020-03-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88397678",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88129069",
    "country": "US",
    "markName": "SATURDAY NIGHT'S MAIN EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Entertainment services, namely, a show about professional wrestling; entertainment services, namely, the production and exhibition of professional wrestling events rendered live and through broadcast media including television and radio, and via the internet or commercial online service; providing wrestling news and information via a global computer network; providing information in the fields of sports and entertainment via an online community portal; providing a website in the field of sports entertainment information; fan club services, namely, organizing and staging sporting events in the field of wrestling for wrestling fan club members; providing online newsletters in the field of sports entertainment; online journals, namely, blogs in the fields of sports entertainment.",
    "applicationDate": "2018-09-24",
    "registrationDate": "2023-03-14",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88129069",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "77055599",
    "country": "US",
    "markName": "MAIN EVENT FIGHT GEAR",
    "status": "Live",
    "internationalClasses": [
      "25"
    ],
    "goodsDescription": "IC 025: Boxing, kickboxing and MMA (mixed martial arts) clothing items, namely, shirts, shorts, hats, gloves, pants, sweat shirts, sweat pants, jackets, belts, and martial arts uniforms.",
    "applicationDate": "2006-12-01",
    "registrationDate": "2008-09-16",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/77055599",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "75817475",
    "country": "US",
    "markName": "VIRTUAL EVENT MACHINE (VEM)",
    "status": "Live",
    "internationalClasses": [
      "9"
    ],
    "goodsDescription": "IC 009: COMPUTER SOFTWARE FOR USE IN OPERATING TELEPHONE CALL CENTERS, FEATURING PREDICTIVE DIALING FUNCTIONALITY BASED ON ACCUMULATED DATA FROM OPERATOR ACTIVITIES AND EXPERIENCES.",
    "applicationDate": "1999-10-07",
    "registrationDate": "2003-03-11",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/75817475",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "75977962",
    "country": "US",
    "markName": "EAST COAST EVENT GROUP",
    "status": "Live",
    "internationalClasses": [
      "41",
      "42",
      "39"
    ],
    "goodsDescription": "IC 039: [ [ limousine services ] ].; IC 041: planning parties and special events for others.; IC 042: videotaping parties and special events; photography services for parties and special events.",
    "applicationDate": "1997-10-30",
    "registrationDate": "1999-03-23",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/75977962",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87596209",
    "country": "US",
    "markName": "CERTIFIED EXTREME EVENT MODELER",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, developing, arranging and conducting educational conferences and programs and providing in-person and online classes, seminars, workshops, and training, in the fields of catastrophe modeling, weather modeling, climate modeling, loss modeling, modeling of natural and man-made events, modeling of costs to rebuild and replace damaged structures, and risk management, and distribution of educational materials in connection therewith; educational services, namely, providing training for individuals in the insurance and financial industries for certification in the fields of catastrophe modeling, weather modeling, climate modeling, loss modeling, modeling of natural and man-made events, modeling of costs to rebuild and replace damaged structures, and risk management.",
    "applicationDate": "2017-09-05",
    "registrationDate": "2018-07-31",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87596209",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85025961",
    "country": "US",
    "markName": "WORLD'S LARGEST MOTORCYCLE EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging, organizing, conducting, and hosting motorcycle events for entertainment purposes.",
    "applicationDate": "2010-04-29",
    "registrationDate": "2011-06-07",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85025961",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99058501",
    "country": "US",
    "markName": "WASHBURN LEADERSHIP CHALLENGE EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Leadership development training in the field of leadership development; Providing group coaching and in-person learning forums in the field of leadership development; Entertainment services, namely, arranging and conducting of competitions in the field of leadership.",
    "applicationDate": "2025-02-26",
    "registrationDate": "2025-12-23",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99058501",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99229039",
    "country": "US",
    "markName": "YES YOUR EVENT SOLUTIONS",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Business meeting planning; Special event planning for business purposes.",
    "applicationDate": "2025-06-11",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99229039",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98386797",
    "country": "US",
    "markName": "CERTIFIED EXTREME EVENT MODELER",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Educational services, namely, developing, arranging and conducting educational conferences and programs and providing in-person and online classes, seminars, workshops, and training, in the fields of catastrophe modeling, weather modeling, climate modeling, loss modeling, modeling of natural and man-made events, modeling of costs to rebuild and replace damaged structures, and risk management, and distribution of educational materials in connection therewith; educational services, namely, providing training for individuals in the insurance and financial industries for certification in the fields of catastrophe modeling, weather modeling, climate modeling, loss modeling, modeling of natural and man-made events, modeling of costs to rebuild and replace damaged structures, and risk management.",
    "applicationDate": "2024-02-01",
    "registrationDate": "2026-01-27",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98386797",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88274420",
    "country": "US",
    "markName": "THE INTERNATIONAL SURFACE EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Arranging and conducting tradeshows for the floor covering industry in the field of engineered and natural stone.",
    "applicationDate": "2019-01-24",
    "registrationDate": "2019-09-10",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88274420",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99696236",
    "country": "US",
    "markName": "EVENT SOURCE PANACHE EVENTS",
    "status": "Live",
    "internationalClasses": [
      "41",
      "43",
      "20"
    ],
    "goodsDescription": "IC 020: Punch fountain; pretzel warmer and display; popcorn tray holder; ice cream cart; hot dog cart; ice cream dipping cabinet; cotton candy machine; snow cone machine; nacho cheese dispenser; slush machine; rental of popcorn machines; rental of food service equipment; rental of kitchen sinks; rental of portable buildings; rental of rugs; rental of food services equipment, namely, rental of food warming heat lamps and heated food cabinets; rental of furniture; rental of catering equipment; rental of bar equipment; rental of party and event and banquet supplies, namely, table linens, glassware, tableware, silverware, dishes, chafing dishes and table accessories in the nature of table numbers, table number holders, vases, ashtrays.; IC 041: Providing and rental of exhibition stands and booths including respective equipment; providing a website featuring a list of items and services available for rent by others; event planning; event consultation; event planning virtual design services;...",
    "applicationDate": "2026-03-11",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99696236",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99700022",
    "country": "US",
    "markName": "LITTLE RASCALS EVENT SERVICES",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Rental of amusement park rides in the nature of Mobile Mechanical Carnival Rides, Attractions, Inflatables..",
    "applicationDate": "2026-03-13",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99700022",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99289398",
    "country": "US",
    "markName": "BIG BEAUTIFUL SALES EVENT",
    "status": "Live",
    "internationalClasses": [
      "35",
      "12"
    ],
    "goodsDescription": "IC 012: Motor vehicles, namely, concept motor vehicles; Motor vehicles including cars, trucks, and motorcycles; Electric vehicles, namely, electric automobiles, trucks, and sports utility vehicles.; IC 035: Advertising services related to vehicle sales; Business consulting services related to vehicle sales.",
    "applicationDate": "2025-07-17",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99289398",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98500594",
    "country": "US",
    "markName": "GRIFFIN & GRIFFIN GG EVENT DESIGN ILLUMINATED",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Lighting design services for events and for architectural, landscape, theatrical, entertainment, residential and commercial applications.",
    "applicationDate": "2024-04-15",
    "registrationDate": "2025-05-20",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98500594",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78857450",
    "country": "US",
    "markName": "THE #1 CHARITY EVENT IN GOLF",
    "status": "Live",
    "internationalClasses": [
      "36"
    ],
    "goodsDescription": "IC 036: charitable fund raising services through golf tournaments.",
    "applicationDate": "2006-04-10",
    "registrationDate": "2007-07-24",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78857450",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "99523782",
    "country": "US",
    "markName": "CORPORATE EVENT AND HOSPITALITY SERVICES, LLC",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Corporate event management services.",
    "applicationDate": "2025-12-01",
    "registrationDate": "",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/99523782",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90390761",
    "country": "US",
    "markName": "SO FINE EVENT DESIGN",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Event planning and management for marketing, branding, promoting or advertising the goods and services of others; Arranging personal appearances by persons working in the field of film, music, television, entertainment or sport; Arranging and conducting special events for business purposes; Arranging and conducting special events for commercial, promotional or advertising purposes; Corporate event management services; Special event planning for business purposes; Special event planning for commercial, promotional or advertising purposes.",
    "applicationDate": "2020-12-17",
    "registrationDate": "2021-10-05",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90390761",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97777090",
    "country": "US",
    "markName": "SOCIAL SOCIETY EVENT CENTER",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging and conducting special events for social entertainment purposes; Arranging, organizing, conducting and hosting birthday parties; Consultation in the field of special event planning for social entertainment purposes; Dance events; Dance studios; Entertainment services in the nature of arranging social entertainment events; Entertainment services in the nature of hosting social entertainment events; Entertainment services in the nature of organizing social entertainment events; Entertainment services, namely, conducting parties; Hosting social entertainment events, namely, birthday parties, baby showers, wedding receptions, for others; Organization of entertainment events in the nature of birthday parties, baby showers, wedding receptions; Organization of social entertainment events; Party and wedding reception planning and coordination services; Party and wedding reception planning, coordination and consultation services; Party planning consultation; Party planning of...",
    "applicationDate": "2023-02-01",
    "registrationDate": "2024-02-06",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97777090",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97061269",
    "country": "US",
    "markName": "ZERO WASTE EVENT PRODUCTIONS",
    "status": "Live",
    "internationalClasses": [
      "39"
    ],
    "goodsDescription": "IC 039: Waste management services, namely collection of garbage, recyclable materials, and compostable materials for transport of waste generated during indoor and outdoor social gatherings.",
    "applicationDate": "2021-10-06",
    "registrationDate": "2023-05-23",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97061269",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97215505",
    "country": "US",
    "markName": "COMPASS A FUSION EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging and conducting of conferences and seminars in the field of business risk management, business continuity, disaster recovery, vendor management, and regulatory compliance.",
    "applicationDate": "2022-01-12",
    "registrationDate": "2023-09-12",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97215505",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90689705",
    "country": "US",
    "markName": "DE DISTINCT EVENT PLANNING",
    "status": "Live",
    "internationalClasses": [
      "35",
      "41"
    ],
    "goodsDescription": "IC 035: Event planning, including event design, of special occasions such as corporate events, the foregoing being for business purposes.; IC 041: Events planning, including event design, for special occasions such as weddings, and social events, the foregoing being for social entertainment purposes.",
    "applicationDate": "2021-05-04",
    "registrationDate": "2022-06-14",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90689705",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "90813453",
    "country": "US",
    "markName": "ABSOLUTE OPULENCE EVENT STUDIO",
    "status": "Live",
    "internationalClasses": [
      "43"
    ],
    "goodsDescription": "IC 043: Providing general purpose facilities for social events, namely, wedding receptions, birthday parties, baby showers, and other special events; Rental of banquet and social function facilities for special occasions, namely, wedding receptions, birthday parties, baby showers, and other special events.",
    "applicationDate": "2021-07-06",
    "registrationDate": "2023-04-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/90813453",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "97708597",
    "country": "US",
    "markName": "CITY SETUPS EVENT DECOR",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Photography services; Entertainment services in the nature of arranging social entertainment events; Rental of background scenery, namely, garland made up of balloons, flower decorations for use at special events, parties, conventions, meetings and tradeshows; Providing information for event planning related to decorations and party supplies; Providing information about party planning and special event planning for social entertainment purposes; Entertainment services, namely, providing backdrop scenery for use at special events, parties, conventions, meetings and tradeshows; Party planning; Hosting social entertainment events, namely, special events, and parties for others.",
    "applicationDate": "2022-12-08",
    "registrationDate": "2024-02-06",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/97708597",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "87683406",
    "country": "US",
    "markName": "THE EVENT LIGHT PROS",
    "status": "Live",
    "internationalClasses": [
      "42"
    ],
    "goodsDescription": "IC 042: Lighting design services for events and for architectural, landscape, theatrical, entertainment, residential and commercial applications.",
    "applicationDate": "2017-11-14",
    "registrationDate": "2018-08-28",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/87683406",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "78739776",
    "country": "US",
    "markName": "UPSIDE DOWN TENT EVENT",
    "status": "Live",
    "internationalClasses": [
      "35"
    ],
    "goodsDescription": "IC 035: Advertising and promotion services, namely, promoting the sale of goods and services of others through the placement and distribution of advertisment and promotion materials.",
    "applicationDate": "2005-10-25",
    "registrationDate": "2006-10-03",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/78739776",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "98809371",
    "country": "US",
    "markName": "CODY JOHNSON CHAMPIONSHIP EVENT",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: organizing, arranging, and conducting golf and roping events; entertainment in the nature of golf tournaments; entertainment services in the nature of competitions in the field of roping.",
    "applicationDate": "2024-10-18",
    "registrationDate": "2025-11-25",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/98809371",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "88770967",
    "country": "US",
    "markName": "UNFAILING MOMENTS EVENT DESIGN",
    "status": "Live",
    "internationalClasses": [
      "41"
    ],
    "goodsDescription": "IC 041: Arranging and conducting special events for social entertainment purposes; Party planning; Party planning consultation; Party and wedding reception planning and coordination services; Party and wedding reception planning consultation services; Party and wedding reception planning, coordination and consultation services; Special event planning for social entertainment purposes; Consultation in the field of special event planning for social entertainment purposes.",
    "applicationDate": "2020-01-23",
    "registrationDate": "2020-08-18",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/88770967",
    "jurisdiction": "United States"
  },
  {
    "applicationNumber": "85055764",
    "country": "US",
    "markName": "LIVE EVENT TRIVIA PLAY.",
    "status": "Live",
    "internationalClasses": [
      "9",
      "41"
    ],
    "goodsDescription": "IC 009: Downloadable computer game programs.; IC 041: Entertainment services, namely, providing temporary use of non-downloadable interactive games.",
    "applicationDate": "2010-06-06",
    "registrationDate": "2011-08-16",
    "renewalDate": "",
    "ptoLink": "https://tmsearch.uspto.gov/search/search-results/85055764",
    "jurisdiction": "United States"
  }
];

export const AU_SEARCH_RESULTS = [
  {
    id: 1,
    markName: "CITYSEARCH",
    jurisdiction: "Australia",
    legalStatus: "REMOVED",
    applicationNo: "873261",
    classes: [16],
    goodsDescription:"Printed matter, printed publications, printed directories including telephone and Internet directories",
    applicationDate: "2001-04-20",
    registrationDate: "2003-03-31",
    renewalDate: "2021-04-20",
    applicantName: "CitySearch Australia Pty Limited",
    trademarkType: "WORD",
    matchScore: "8/10",
    iconType: "description",
  },
  {
    id: 2,
    markName: "ALNYLAM",
    jurisdiction: "Australia",
    legalStatus: "REGISTERED",
    applicationNo: "935506",
    classes: [42],
    goodsDescription:
      "Scientific and technological services; research and design; scientific research in pharmaceuticals and medicine; laboratories; industrial and scientific analysis and research services",
    applicationDate: "2002-11-26",
    registrationDate: "2003-04-14",
    renewalDate: "2032-11-26",
    applicantName: "Alnylam Pharmaceuticals Inc.",
    trademarkType: "WORD",
    matchScore: "9/10",
    iconType: "verified",
  },
  {
    id: 3,
    markName: "ROUND UP FOR CHILDREN",
    jurisdiction: "Australia",
    legalStatus: "REMOVED",
    applicationNo: "720715",
    classes: [36],
    goodsDescription: "Charitable fund raising services",
    applicationDate: "1996-10-30",
    registrationDate: "1997-10-03",
    renewalDate: "2016-10-30",
    applicantName: "United Nations Children's Fund",
    trademarkType: "WORD",
    matchScore: "7/10",
    iconType: "policy",
  },
  {
    id: 4,
    markName: "WHITE PAGES",
    jurisdiction: "Australia",
    legalStatus: "REGISTERED",
    applicationNo: "719863",
    classes: [16],
    goodsDescription: "Telephone directories",
    applicationDate: "1996-10-17",
    registrationDate: "1999-07-30",
    renewalDate: "2036-10-17",
    applicantName: "Thryv Australia Pty Ltd",
    trademarkType: "WORD",
    matchScore: "10/10",
    iconType: "award",
  },
  {
    id: 5,
    markName: "VCALENDAR",
    jurisdiction: "Australia",
    legalStatus: "WITHDRAWN",
    applicationNo: "720424",
    classes: [9],
    goodsDescription:
      "Electronic data format for the exchange of calendaring and scheduling information, including meeting events and meeting action items",
    applicationDate: "1996-10-28",
    registrationDate: "-",
    renewalDate: "-",
    applicantName:
      "Siemens Rolm Communications Inc., A T & T Corp., IBM Corporation",
    trademarkType: "WORD",
    matchScore: "6/10",
    iconType: "shield",
  },
  {
    id: 6,
    markName: "WHITE PAGES",
    jurisdiction: "Australia",
    legalStatus: "REGISTERED",
    applicationNo: "891808",
    classes: [9, 38, 41],
    goodsDescription: "Electronic publications; telecommunications services; online information services; education and training services; arranging conferences and seminars; electronic game services; publication of books, business directories and newsletters",
    applicationDate: "2001-10-11",
    registrationDate: "2002-08-19",
    renewalDate: "2031-10-11",
    applicantName: "Thryv Australia Pty Ltd",
    trademarkType: "WORD",
    matchScore: "9/10",
    iconType: "description",
  },
  {
    id: 7,
    markName: "VIZ-A-BALL",
    jurisdiction: "Australia",
    legalStatus: "REMOVED",
    applicationNo: "873361",
    classes: [28],
    goodsDescription: "Bowling balls",
    applicationDate: "2001-04-23",
    registrationDate: "2002-01-21",
    renewalDate: "2021-04-23",
    applicantName: "Brunswick Bowling Products, LLC",
    trademarkType: "WORD",
    matchScore: "7/10",
    iconType: "award",
  },
];

export const EU_SEARCH_RESULTS = [
  {
    id: 1,
    markName: "sp_test",
    jurisdiction: "European Union",
    legalStatus: "UNDER_EXAMINATION",
    applicationNo: "019017867",
    classes: [9, 16, 35, 41, 42],
    goodsDescription: "Software, printed matter, business services, education services, technology services.",
    applicationDate: "2025-02-12",
    registrationDate: "-",
    renewalDate: "-",
    applicantName: "sp_test",
    markFeature: "FIGURATIVE",
    renewalStatus: "NOT_TO_BE_RENEWED",
    matchScore: "9/10",
    iconType: "policy",
  },
  {
    id: 2,
    markName: "sp_test",
    jurisdiction: "European Union",
    legalStatus: "UNDER_EXAMINATION",
    applicationNo: "019017822",
    classes: [9, 16, 35, 41, 42],
    goodsDescription: "Software, printed matter, advertising, training, SaaS and IT services.",
    applicationDate: "2025-02-07",
    registrationDate: "-",
    renewalDate: "-",
    applicantName: "sp_test",
    markFeature: "FIGURATIVE",
    renewalStatus: "NOT_TO_BE_RENEWED",
    matchScore: "8/10",
    iconType: "policy",
  },
  {
    id: 3,
    markName: "sp_test",
    jurisdiction: "European Union",
    legalStatus: "UNDER_EXAMINATION",
    applicationNo: "019017742",
    classes: [9, 16, 35, 41, 42],
    goodsDescription: "Downloadable software, publications, business consultancy, education, cloud services.",
    applicationDate: "2025-02-07",
    registrationDate: "-",
    renewalDate: "-",
    applicantName: "sp_test",
    markFeature: "FIGURATIVE",
    renewalStatus: "NOT_TO_BE_RENEWED",
    matchScore: "8/10",
    iconType: "description",
  },
  {
    id: 4,
    markName: "EutmCreatedByScript",
    jurisdiction: "European Union",
    legalStatus: "REGISTERED",
    applicationNo: "019017734",
    classes: [1],
    goodsDescription: "Chemicals used in industry, science and manufacturing.",
    applicationDate: "2025-02-07",
    registrationDate: "2025-02-07",
    renewalDate: "2035-02-07",
    applicantName: "EutmCreatedByScript",
    markFeature: "WORD",
    renewalStatus: "NOT_TO_BE_RENEWED",
    matchScore: "7/10",
    iconType: "verified",
  },
  {
    id: 5,
    markName: "EutmCreatedByScript",
    jurisdiction: "European Union",
    legalStatus: "RECEIVED",
    applicationNo: "019017806",
    classes: [1],
    goodsDescription: "Industrial chemicals and chemical compositions.",
    applicationDate: "2025-02-07",
    registrationDate: "-",
    renewalDate: "-",
    applicantName: "EutmCreatedByScript",
    markFeature: "WORD",
    renewalStatus: "NOT_TO_BE_RENEWED",
    matchScore: "6/10",
    iconType: "shield",
  },
  {
    id: 6,
    markName: "EutmCreatedByScript",
    jurisdiction: "European Union",
    legalStatus: "RECEIVED",
    applicationNo: "019017769",
    classes: [1],
    goodsDescription: "Chemical additives and raw materials for industrial use.",
    applicationDate: "2025-02-07",
    registrationDate: "-",
    renewalDate: "-",
    applicantName: "EutmCreatedByScript",
    markFeature: "WORD",
    renewalStatus: "NOT_TO_BE_RENEWED",
    matchScore: "6/10",
    iconType: "description",
  },
  {
    id: 7,
    markName: "EutmCreatedByScript",
    jurisdiction: "European Union",
    legalStatus: "REGISTERED",
    applicationNo: "019017685",
    classes: [1],
    goodsDescription: "Industrial chemicals, resins and compositions for manufacturing.",
    applicationDate: "2025-02-07",
    registrationDate: "2025-02-07",
    renewalDate: "2035-02-07",
    applicantName: "EutmCreatedByScript",
    markFeature: "WORD",
    renewalStatus: "NOT_TO_BE_RENEWED",
    matchScore: "7/10",
    iconType: "award",
  },
  {
    id: 8,
    markName: "sp_test",
    jurisdiction: "European Union",
    legalStatus: "UNDER_EXAMINATION",
    applicationNo: "019017765",
    classes: [9, 16, 35, 41, 42],
    goodsDescription: "Software products, publications, business support, education and IT solutions.",
    applicationDate: "2025-02-07",
    registrationDate: "-",
    renewalDate: "-",
    applicantName: "sp_test",
    markFeature: "FIGURATIVE",
    renewalStatus: "NOT_TO_BE_RENEWED",
    matchScore: "8/10",
    iconType: "policy",
  },
  {
    "applicationNumber": "1739274",
    "jurisdiction": "European Union",
    "country": "IR",
    "markName": "CE CURATED EVENTS",
    "trademarkImage": eu1739274Logo,
    "status": "ACCEPTED",
    "internationalClasses": ["41", "43"],
    "goodsDescription": "Rental of staging equipment in the nature of stage scenery rental of semi-permanent structures, namely, portable stages rental of dance floors and associated leveled flooring systems and flooring support systems special event planning for social entertainment services management and planning of social entertainment event services. Rental of table linens rental of tableware, silverware, glassware, china, and dishes for special events rental of dining tables rental of tables and chairs rental of tents rental of catering equipment in the nature of kitchen worktops for preparing food for immediate consumption, portable catering ovens, food service equipment, and serving equipment rental of furniture rental of carpeting rental of lighting apparatuses for decorating and illuminating weddings, business events, and festivals rental of semi-permanent portable structures, namely, frame tents, sailcloth tents, walkway tenting, greenhouse-style tents.",
    "applicationDate": "2023/07/13",
    "registrationDate": "2023-02-27",
    "renewalDate": "2033-02-27",
    "ptoLink": "https://www.tmdn.org/tmview/#/tmview/detail/WO500000001739274"
  },
  {
    "applicationNumber": "1739270",
    "country": "IR",
    "jurisdiction": "European Union",
    "markName": "CE CURATED EVENTS SERVICE · SELECTION · STYLE · DELIVERED",
    "trademarkImage": eu1739270Logo,
    "status": "ACCEPTED",
    "internationalClasses": ["41", "43"],
    "goodsDescription": "Rental of staging equipment rental of dance floors, hardwood floors, leveled flooring systems, and flooring support systems for entertainment purposes special event planning for social entertainment services management and planning of social entertainment event services. Rental of table linens rental of tableware, silverware, glassware, china, dishes, and table accessories for special events rental of tables rental of chairs rental of tents and tent décor elements rental of catering equipment rental of furniture rental of lighting or electrical equipment in the nature of apparatuses for decorating and illuminating weddings, business events, and festivals rental of semi-permanent structures rental of carpeting.",
    "applicationDate": "2023/07/13",
    "registrationDate": "2023-02-27",
    "renewalDate": "2033-02-27",
    "ptoLink": "https://www.tmdn.org/tmview/#/tmview/detail/WO500000001739270"
  },
  {
    "applicationNumber": "1723291",
    "country": "IR",
    "jurisdiction": "European Union",
    "markName": "CURATED EVENTS",
    "trademarkImage": eu1723291Logo,
    "status": "ACCEPTED",
    "internationalClasses": ["41", "43"],
    "goodsDescription": "Rental of staging equipment in the nature of stage scenery rental of semi-permanent structures, namely, portable stages rental of dance floors and associated leveled flooring systems and flooring support systems. Rental of table linens rental of tableware, silverware, glassware, china, dishes, and table accessories for special events rental of tables rental of chairs rental of tents and tent décor elements rental of catering equipment rental of furniture rental of lighting or electrical equipment in the nature of apparatuses for decorating and illuminating weddings, business events, and festivals.",
    "applicationDate": "2023/04/06",
    "registrationDate": "2023-02-27",
    "renewalDate": "2033-02-27",
    "ptoLink": "https://www.tmdn.org/tmview/#/tmview/detail/WO500000001723291"
  },
  {
    "applicationNumber": "1739273",
    "jurisdiction": "European Union",
    "country": "IR",
    "markName": "CURATED EVENTS SERVICE . SELECTION . STYLE . DELIVERED",
    "trademarkImage": eu1739273Logo,
    "status": "ACCEPTED",
    "internationalClasses": ["41", "43"],
    "goodsDescription": "Rental of staging equipment rental of dance floors, hardwood floors, leveled flooring systems, and flooring support systems for entertainment purposes special event planning for social entertainment services management and planning of social entertainment event services. Rental of table linens rental of tableware, silverware, glassware, china, dishes, and table accessories for special events rental of tables rental of chairs rental of tents and tent décor elements rental of catering equipment rental of furniture rental of lighting or electrical equipment in the nature of apparatuses for decorating and illuminating weddings, business events, and festivals rental of semi-permanent structures rental of carpeting.",
    "applicationDate": "2023/07/13",
    "registrationDate": "2023-02-27",
    "renewalDate": "2033-02-27",
    "ptoLink": "https://www.tmdn.org/tmview/#/tmview/detail/WO500000001739273"
  },
  {
    "applicationNumber": "1739271",
    "jurisdiction": "European Union",
    "country": "IR",
    "markName": "CURATED EVENTS SERVICE SELECTION STYLE DELIVERED",
    "trademarkImage": eu1739271Logo,
    "status": "ACCEPTED",
    "internationalClasses": ["41", "43"],
    "goodsDescription": "Rental of staging equipment in the nature of stage scenery rental of semi-permanent structures, namely, portable stages rental of dance floors and associated leveled flooring systems and flooring support systems special event planning for social entertainment services management and planning of social entertainment event services. Rental of table linens rental of tableware, silverware, glassware, china, and dishes for special events rental of dining tables rental of tables and chairs rental of tents rental of catering equipment in the nature of kitchen worktops for preparing food for immediate consumption, portable catering ovens, food service equipment, and serving equipment rental of furniture rental of carpeting rental of lighting apparatuses for decorating and illuminating weddings, business events, and festivals rental of semi-permanent portable structures, namely, frame tents, sailcloth tents, walkway tenting, greenhouse-style tents.",
    "applicationDate": "2023/07/13",
    "registrationDate": "2023-02-27",
    "renewalDate": "2033-02-27",
    "ptoLink": "https://www.tmdn.org/tmview/#/tmview/detail/WO500000001739271"
  }

];

export const CN_SEARCH_RESULTS = [
  {
    id: 1,
    markName: "MAPLEBYTE",
    jurisdiction: "Canada",
    legalStatus: "REGISTERED",
    applicationNo: "CA-1892345",
    classes: [9, 42],
    goodsDescription: "Software development tools; SaaS-based cloud computing services.",
    applicationDate: "2020-09-18",
    registrationDate: "2022-04-12",
    renewalDate: "2032-04-12",
    applicantName: "MapleByte Solutions Inc.",
    matchScore: "2/10",
    iconType: "verified",
  },
  {
    id: 2,
    markName: "NORTHSHIELD",
    jurisdiction: "Canada",
    legalStatus: "PENDING",
    applicationNo: "CA-2023456",
    classes: [45],
    goodsDescription: "Legal advisory services; trademark monitoring and enforcement.",
    applicationDate: "2023-06-05",
    registrationDate: "-",
    renewalDate: "-",
    applicantName: "NorthShield Legal Corp.",
    matchScore: "4/10",
    iconType: "shield",
  },
];
